export type GeneratedMessages = Record<string, string>;

export const generatedTranslations: Record<string, GeneratedMessages> = {
  'en-AU': {
    'common.loading': 'Loading...',
    'common.email': 'Email',
    'common.password': 'Password',
    'common.confirmPassword': 'Confirm Password',
    'common.backToLogin': 'Back to Sign in',
    'common.signIn': 'Sign in',
    'common.emailExample': 'creator@example.com',
    'common.clearSearch': 'Clear search',
    'login.title': 'Welcome back',
    'login.subtitle': 'Sign in to your creator account',
    'login.passwordPlaceholder': 'Enter your password',
    'login.forgotPassword': 'Forgot password?',
    'login.submit': 'Sign In',
    'login.createOne': 'Create one',
    'login.error.verifyEmail': 'Please verify your email before logging in. Check your inbox for the verification link.',
    'login.error.invalidCredentials': 'Invalid email or password.',
    'login.resend.button': 'Resend verification email',
    'login.resend.success': 'If your account exists and is not verified, a new verification email has been sent.',
    'login.resend.error': 'Failed to resend verification email. Please try again shortly.',
    'login.resend.wait': 'Please wait a moment before requesting another verification email.',
    'login.resend.waitWithSeconds': 'Resend available in',
    'register.title': 'Create your account',
    'register.titleSuccess': 'Check your email',
    'register.subtitle': 'Join the X-periences creator community',
    'register.subtitleSuccess': 'We sent you a verification link',
    'register.alias': 'Alias',
    'register.aliasPlaceholder': 'Your creator alias',
    'register.passwordPlaceholder': 'At least 6 characters',
    'register.confirmPasswordPlaceholder': 'Confirm your password',
    'register.acceptPrefix': 'I have read and accept the',
    'register.terms': 'Terms of Use',
    'register.and': 'and',
    'register.privacy': 'Privacy Policy',
    'register.acceptSuffix': '.',
    'register.submit': 'Create Account',
    'register.successCreated': 'Account created successfully!',
    'register.successCheckInbox': 'Please check your inbox (and spam folder) and click the verification link to activate your account.',
    'register.successEmailIssue': 'Your account was created, but verification email delivery is temporarily unavailable. Use the resend verification button from login in a moment.',
    'register.successBackToLogin': 'Back to Login',
    'register.haveAccount': 'Already have an account?',
    'register.signIn': 'Sign in',
    'register.error.passwordsMismatch': 'Passwords do not match',
    'register.error.passwordMin': 'Password must be at least 6 characters',
    'register.error.acceptTerms': 'You must read and accept the Terms of Use and Privacy Policy',
    'register.error.generic': 'Registration failed',
    'forgot.title': 'Reset Password',
    'forgot.subtitle': 'Enter your email to receive a reset link',
    'forgot.submit': 'Send Reset Link',
    'forgot.success': 'Check your email for a password reset link.',
    'forgot.devMode': 'Development mode:',
    'forgot.devGoReset': 'Go to Reset Password',
    'forgot.remember': 'Remember your password?',
    'forgot.error.generic': 'Failed to send reset email',
    'reset.title': 'Reset Password',
    'reset.subtitle': 'Enter your new password',
    'reset.newPassword': 'New Password',
    'reset.confirmPassword': 'Confirm Password',
    'reset.confirmPlaceholder': 'Confirm your new password',
    'reset.submit': 'Reset Password',
    'reset.success': 'Password reset successfully! Redirecting to login...',
    'reset.error.invalidLink': 'Invalid reset link',
    'reset.error.passwordsMismatch': 'Passwords do not match',
    'reset.error.passwordMin': 'Password must be at least 6 characters',
    'reset.error.invalidToken': 'Invalid reset token',
    'reset.error.generic': 'Failed to reset password',
    'verify.title': 'Email Verification',
    'verify.loading': 'Verifying your email...',
    'verify.successLine1': 'Your email has been verified successfully!',
    'verify.successLine2': 'You can now log in to your account.',
    'verify.redirecting': 'Redirecting to login...',
    'verify.alreadyLine1': 'Your email was already verified!',
    'verify.alreadyLine2': 'You can log in to your account.',
    'verify.goLogin': 'Go to Login',
    'verify.error.noToken': 'No verification token provided',
    'verify.error.generic': 'Verification failed',
    'navbar.subtitle': 'Creator Portal',
    'navbar.dashboard': 'Dashboard',
    'navbar.modXperiences': 'Mod. Xperiences',
    'navbar.manageCreators': 'Manage Creators',
    'navbar.newXperience': 'New Xperience',
    'navbar.generateCreators': 'Generate Creators',
    'navbar.generateXperiences': 'Generate Xperiences',
    'navbar.generate': 'Generate',
    'navbar.generating': 'Generating',
    'navbar.profile': 'Profile',
    'navbar.logout': 'Logout',
    'navbar.confirmGenerateCreators': 'Are you sure you want to generate creators JSON?',
    'navbar.confirmGenerateXperiences': 'Are you sure you want to generate xperiences JSON?',
    'navbar.successGenerateCreators': 'Creators generated successfully!',
    'navbar.successGenerateXperiences': 'Xperiences generated successfully!',
    'navbar.error.endpoint': 'Endpoint not found. The API service might need a restart.',
    'navbar.error.noBody': 'No response body',
    'navbar.error.generateCreators': 'Failed to generate creators',
    'navbar.error.generateXperiences': 'Failed to generate xperiences',
    'navbar.roleDefault': 'Creator',
    'navbar.statusPending': 'Pending',
    'navbar.statusTitle': 'Status',
    'navbar.totalViews': 'Total Views',
    'navbar.avgRating': 'Average Rating',
    'navbar.roleTitle': 'Role',
    'navbar.languageLabel': 'Language',
    'navbar.lang.en': 'English',
    'navbar.lang.es': 'Spanish',
    'locale.en': 'English',
    'locale.zhHk': 'Chinese (Hong Kong)',
    'locale.zhHans': 'Chinese, Simplified',
    'locale.zhHant': 'Chinese, Traditional',
    'locale.enAu': 'English (Australia)',
    'locale.enGb': 'English (United Kingdom)',
    'locale.fr': 'French',
    'locale.frCa': 'French (Canada)',
    'locale.de': 'German',
    'locale.ja': 'Japanese',
    'locale.es': 'Spanish',
    'home.profileIncomplete': 'Please complete your profile before managing xperiences',
    'home.error.load': 'Failed to load xperiences',
    'home.title': 'Your Xperiences',
    'home.subtitle': 'Manage your immersive content for Apple Vision Pro',
    'home.newXperience': '+ New Xperience',
    'home.searchPlaceholder': 'Search by title or description...',
    'home.clearSearch': 'Clear search',
    'home.allMediaTypes': 'All Media Types',
    'home.loading': 'Loading xperiences...',
    'home.emptyTitle': 'No xperiences yet',
    'home.emptyText': 'Create your first immersive xperience for Apple Vision Pro',
    'home.createFirst': 'Create First Xperience',
    'home.noResultsTitle': 'No results found',
    'home.noResultsText': 'Try adjusting your search criteria or filters',
    'home.clearFilters': 'Clear Filters',
    'home.privateTitle': 'Private Xperience',
    'home.categoryTitle': 'Category',
    'home.viewsTitle': 'Views',
    'home.likesTitle': 'Likes',
    'home.dislikesTitle': 'Dislikes',
    'home.ratingTitle': 'Rating',
    'home.viewDetails': 'View Details',
    'home.moreTags': 'more tags',
    'home.files': 'file',
    'home.filesPlural': 'files',
    'beCreator.title': 'Be a Creator on X-periences',
    'beCreator.subtitle': 'Share immersive experiences for Apple Vision Pro',
    'beCreator.point1': 'Publish your own xperiences and build your audience.',
    'beCreator.point2': 'Track views, likes, and ratings from your dashboard.',
    'beCreator.point3': 'Manage media and updates from one creator portal.',
    'beCreator.ctaPrimary': 'Create Creator Account',
    'beCreator.ctaSecondary': 'I already have an account',
    'beCreator.heroTitle': 'Become a Creator',
    'beCreator.heroSubtitle': 'Share your unique X-periences with the world and turn your passion into reality.',
    'beCreator.heroCta': 'Join as a Creator',
    'beCreator.benefitsTitle': 'Why Join X-periences?',
    'beCreator.benefit.audienceTitle': 'Reach a Global Audience',
    'beCreator.benefit.audienceText': 'Connect with users worldwide who are eager to discover and engage with your unique content and X-periences.',
    'beCreator.benefit.recognitionTitle': 'Earn Recognition',
    'beCreator.benefit.recognitionText': 'Build your reputation as a creator by sharing immersive stories that inspire users around the world.',
    'beCreator.benefit.toolsTitle': 'Powerful Creator Tools',
    'beCreator.benefit.toolsText': 'Access advanced analytics, seamless media management, and easy-to-use publishing tools tailored for creators.',
    'beCreator.benefit.communityTitle': 'Supportive Community',
    'beCreator.benefit.communityText': 'Join a network of passionate creators. Share ideas, collaborate, and grow together in a safe environment.',
    'beCreator.howItWorksTitle': 'How It Works',
    'beCreator.step.signupTitle': 'Sign Up',
    'beCreator.step.signupText': 'Create your creator profile in just a few clicks.',
    'beCreator.step.createTitle': 'Create',
    'beCreator.step.createText': 'Upload your content and build your engaging X-periences.',
    'beCreator.step.recognizedTitle': 'Get Recognized',
    'beCreator.step.recognizedText': 'Share your xperiences globally, grow your audience, and become a reference creator in immersive content.',
    'beCreator.footerTitle': 'Ready to start your journey?',
    'beCreator.footerText': 'Take the first step to share immersive xperiences with the world.',
    'beCreator.footerCta': 'Get Started Now',
    'profile.loading': 'Loading profile...',
    'profile.title': 'Creator Profile',
    'profile.subtitle': 'Manage your creator information',
    'profile.requiredFieldsLabel': 'Required fields*:',
    'profile.requiredFieldsText': 'Full Name, Avatar, Biography, and Country are required to access the Xperiences dashboard.',
    'profile.section.accountInfo': 'Account Information',
    'profile.section.changePassword': 'Change Password',
    'profile.section.personalInfo': 'Personal Information',
    'profile.section.appSocial': 'App & Social Media',
    'profile.section.creatorStats': 'Creator Statistics',
    'profile.field.usernameAlias': 'Username (Alias)',
    'profile.field.currentPassword': 'Current Password',
    'profile.field.newPassword': 'New Password',
    'profile.field.confirmNewPassword': 'Confirm New Password',
    'profile.field.fullNameRequired': 'Full Name *',
    'profile.field.phone': 'Phone',
    'profile.field.countryRequired': 'Country *',
    'profile.field.avatarRequired': 'Avatar *',
    'profile.field.biographyRequired': 'Biography *',
    'profile.field.appName': 'App Name',
    'profile.field.appUrl': 'App URL',
    'profile.field.youtubeUrl': 'YouTube URL',
    'profile.field.instagramUrl': 'Instagram URL',
    'profile.field.otherUrl': 'Other URL',
    'profile.placeholder.username': 'Your username',
    'profile.placeholder.currentPassword': 'Enter your current password',
    'profile.placeholder.newPassword': 'Enter new password',
    'profile.placeholder.confirmNewPassword': 'Confirm new password',
    'profile.placeholder.fullName': 'Your full name',
    'profile.placeholder.phone': '+1 (555) 000-0000',
    'profile.placeholder.searchCountries': 'Type to search countries...',
    'profile.placeholder.biography': 'Tell us about yourself...',
    'profile.placeholder.appName': 'e.g., My App',
    'profile.placeholder.appUrl': 'https://myapp.com',
    'profile.placeholder.youtubeUrl': 'https://youtube.com/@yourusername',
    'profile.placeholder.instagramUrl': 'https://instagram.com/yourusername',
    'profile.placeholder.otherUrl': 'https://example.com',
    'profile.note.publicUsername': 'Your public username',
    'profile.note.emailImmutable': 'Email address cannot be changed in profile',
    'profile.note.passwordMin': 'Minimum 6 characters',
    'profile.note.requiredForDashboard': 'Required to access dashboard',
    'profile.note.countryRequired': 'Required to access dashboard • Select from list or type to search',
    'profile.note.avatarRequired': 'Required to access dashboard • JPG, PNG, or GIF (max 20MB)',
    'profile.note.biographyRequiredPrefix': 'Required to access dashboard •',
    'profile.note.characters': 'characters',
    'profile.optional': 'Optional',
    'profile.allOptional': 'All Optional',
    'profile.uploading': 'Uploading...',
    'profile.uploadingAvatar': 'Uploading avatar...',
    'profile.chooseAvatarImage': 'Choose Avatar Image',
    'profile.avatarPreviewAlt': 'Avatar Preview',
    'profile.preview': 'PREVIEW',
    'profile.openInNewTab': 'Open in new tab',
    'profile.view': 'View',
    'profile.stats.rating': 'Rating',
    'profile.stats.credits': 'Credits',
    'profile.stats.views': 'Views',
    'profile.stats.votes': 'Votes',
    'profile.saving': 'Saving...',
    'profile.saveChanges': 'Save Changes',
    'profile.success.profileAndPasswordUpdated': 'Profile and password updated successfully!',
    'profile.success.profileUpdatedComplete': 'Profile updated successfully! All required fields are complete. You can now access the Xperiences dashboard.',
    'profile.success.profileUpdatedIncomplete': 'Profile updated successfully! Please complete all required fields (Name, Avatar, Biography, Country) to access the dashboard.',
    'profile.error.loadProfile': 'Failed to load profile',
    'profile.error.avatarUpload': 'Failed to upload avatar. Profile NOT saved.',
    'profile.error.fillAllPasswordFields': 'Please fill all password fields to change your password',
    'profile.error.passwordsMismatch': 'New passwords do not match',
    'profile.error.passwordMin': 'New password must be at least 6 characters',
    'profile.error.changePassword': 'Failed to change password',
    'profile.error.profileUpdatedPasswordFailed': 'Profile updated but password change failed',
    'profile.error.updateProfile': 'Failed to update profile. Please try again.',
    'adminCreators.title': 'Manage Creators',
    'adminCreators.loading': 'Loading creators...',
    'adminCreators.error.load': 'Failed to load creators',
    'adminCreators.error.roleUpdate': 'Failed to update role',
    'adminCreators.error.statusUpdate': 'Failed to update status',
    'adminCreators.error.trustUpdate': 'Failed to update trust flag',
    'adminCreators.success.roleUpdated': 'Role updated successfully!',
    'adminCreators.success.statusUpdated': 'Status updated successfully!',
    'adminCreators.success.trustUpdated': 'Trust flag updated successfully!',
    'adminCreators.table.alias': 'Alias',
    'adminCreators.table.email': 'Email',
    'adminCreators.table.emailVerified': 'Email Verified',
    'adminCreators.table.hidden': 'Hidden',
    'adminCreators.table.joinDate': 'Join Date',
    'adminCreators.table.role': 'Role',
    'adminCreators.table.status': 'Status',
    'adminCreators.table.trusted': 'Trusted',
    'adminCreators.yes': 'Yes',
    'adminCreators.no': 'No',
    'adminCreators.hidden': 'Hidden',
    'adminCreators.visible': 'Visible',
    'adminCreators.trusted': 'Trusted',
    'adminCreators.standard': 'Standard',
    'adminCreators.role.creator': 'Creator',
    'adminCreators.role.manager': 'Manager',
    'adminCreators.role.administrator': 'Administrator',
    'adminCreators.status.pending': 'Pending',
    'adminCreators.status.approved': 'Approved',
    'adminCreators.status.rejected': 'Banned / Rejected',
    'adminCreators.empty': 'No creators found.',
    'adminCreators.pagination.page': 'Page',
    'adminCreators.pagination.of': 'of',
    'adminCreators.pagination.total': 'Total',
    'adminCreators.pagination.rowsPerPage': 'Rows per page',
    'adminCreators.pagination.previous': 'Previous',
    'adminCreators.pagination.next': 'Next',
    'adminCreatorDetail.title': 'Edit Creator:',
    'adminCreatorDetail.back': 'Back',
    'adminCreatorDetail.id': 'ID',
    'adminCreatorDetail.email': 'Email',
    'adminCreatorDetail.alias': 'Alias',
    'adminCreatorDetail.fullName': 'Full Name',
    'adminCreatorDetail.phone': 'Phone',
    'adminCreatorDetail.countryCode': 'Country Code',
    'adminCreatorDetail.countryPlaceholder': 'Type to search countries...',
    'adminCreatorDetail.flags': 'Profile Flags',
    'adminCreatorDetail.emailVerified': 'Email Verified',
    'adminCreatorDetail.resendEmail': 'Resend Email',
    'adminCreatorDetail.sending': 'Sending...',
    'adminCreatorDetail.hideProfile': 'Hide Profile (Incomplete)',
    'adminCreatorDetail.isTrusted': 'Trusted Creator',
    'adminCreatorDetail.bio': 'Bio / Description',
    'adminCreatorDetail.linksApps': 'Links & Apps',
    'adminCreatorDetail.appName': 'App Name',
    'adminCreatorDetail.appUrl': 'App URL',
    'adminCreatorDetail.youtubeUrl': 'YouTube URL',
    'adminCreatorDetail.instagramUrl': 'Instagram URL',
    'adminCreatorDetail.otherUrl': 'Other URL',
    'adminCreatorDetail.saveProfile': 'Save Profile',
    'adminCreatorDetail.saving': 'Saving...',
    'adminCreatorDetail.error.load': 'Failed to load creator',
    'adminCreatorDetail.error.verificationSend': 'Failed to send verification email.',
    'adminCreatorDetail.error.update': 'Failed to update creator',
    'adminCreatorDetail.success.verificationSent': 'Verification email sent successfully.',
    'adminCreatorDetail.success.updated': 'Creator updated successfully',
    'moderation.back': 'Back',
    'moderation.title.single': 'Moderating Xperience Content',
    'moderation.title.global': 'Content Moderation',
    'moderation.searchPlaceholder': 'Search by title, description, or creator...',
    'moderation.filter.allMedia': 'All Media',
    'moderation.filter.pending': 'Pending',
    'moderation.filter.approved': 'Approved',
    'moderation.filter.rejected': 'Rejected',
    'moderation.loading': 'Loading media...',
    'moderation.empty.search': 'No media match your search.',
    'moderation.empty.filter': 'No media found for the selected filter.',
    'moderation.noPoster': 'No Poster',
    'moderation.untitled': 'Untitled',
    'moderation.noDescription': 'No description',
    'moderation.creator': 'Creator',
    'moderation.email': 'Email',
    'moderation.date': 'Date',
    'moderation.na': 'N/A',
    'moderation.viewOriginal': 'View Original File',
    'moderation.action.approve': 'Approve',
    'moderation.action.reject': 'Reject',
    'moderation.action.setPending': 'Set Pending',
    'moderation.success.markedAs': 'Media successfully marked as',
    'moderation.error.loadMedia': 'Error loading media for moderation.',
    'moderation.error.updateStatus': 'Failed to update media status.',
    'adminXperiences.backDashboard': 'Back to Dashboard',
    'adminXperiences.title': 'Global Xperiences Moderation',
    'adminXperiences.searchPlaceholder': 'Search by title, description, or creator...',
    'adminXperiences.filter.all': 'All Xperiences',
    'adminXperiences.filter.pending': 'Pending',
    'adminXperiences.filter.approved': 'Approved',
    'adminXperiences.filter.rejected': 'Rejected',
    'adminXperiences.loading': 'Loading xperiences...',
    'adminXperiences.empty.search': 'No xperiences match your search.',
    'adminXperiences.empty.filter': 'No xperiences found for the selected filter.',
    'adminXperiences.noPoster': 'No Poster',
    'adminXperiences.noDescription': 'No description',
    'adminXperiences.creator': 'Creator',
    'adminXperiences.email': 'Email',
    'adminXperiences.date': 'Date',
    'adminXperiences.na': 'N/A',
    'adminXperiences.mediaCount': 'Media Count',
    'adminXperiences.items': 'items',
    'adminXperiences.action.moderateMedia': 'Moderate Media',
    'adminXperiences.action.approveAll': 'Approve All',
    'adminXperiences.action.rejectAll': 'Reject All',
    'adminXperiences.action.setPending': 'Set Pending',
    'adminXperiences.success.markedAs': 'Xperience successfully marked as',
    'adminXperiences.error.fetch': 'Failed to fetch xperiences',
    'adminXperiences.error.updateStatus': 'Failed to update status',
    'createXperience.profileIncomplete': 'Please complete your profile before creating a xperience',
    'createXperience.error.create': 'Failed to create xperience',
    'createXperience.title': 'Create New Xperience',
    'createXperience.subtitle': 'Start building your immersive content',
    'createXperience.field.title': 'Title',
    'createXperience.placeholder.title': 'Xperience title',
    'createXperience.field.description': 'Description',
    'createXperience.placeholder.description': 'Describe your xperience...',
    'createXperience.field.location': 'Location',
    'createXperience.field.tags': 'Tags',
    'createXperience.copyLastLocation': 'Copy last location',
    'createXperience.error.noLastLocation': 'No previous location available yet.',
    'createXperience.placeholder.tags': 'Select or search tags...',
    'createXperience.help.tags': 'Choose one or more tags to improve discovery.',
    'createXperience.cancel': 'Cancel',
    'createXperience.submit': 'Create Xperience',
    'xperienceDetail.success.mediaOrderSaved': 'Media order saved successfully.',
    'xperienceDetail.error.mediaOrderSave': 'Failed to save media order.',
    'xperienceDetail.error.load': 'Failed to load xperience',
    'xperienceDetail.success.updated': 'Xperience updated successfully.',
    'xperienceDetail.error.update': 'Failed to update xperience',
    'xperienceDetail.sendingEmail': 'Sending email...',
    'xperienceDetail.success.emailSent': 'QR access email sent successfully.',
    'xperienceDetail.success.locationCopiedToAll': 'Location copied to {count} media items.',
    'xperienceDetail.error.sendEmail': 'Failed to send QR email.',
    'xperienceDetail.error.uploadMedia': 'Failed to upload media',
    'xperienceDetail.error.deleteMedia': 'Failed to delete media',
    'xperienceDetail.error.deleteXperience': 'Failed to delete xperience',
    'xperienceDetail.error.noLocationToCopyAll': 'Set a location first before copying it to all media.',
    'xperienceDetail.error.invalidLocationToCopyAll': 'Current location coordinates are invalid.',
    'xperienceDetail.error.noMediaToCopyLocationAll': 'No media items found to update in this xperience.',
    'xperienceDetail.error.locationCopiedToAllPartial': 'Updated {success} media items, but {failed} failed.',
    'xperienceDetail.error.locationCopiedToAllFailed': 'Could not update location for all media.',
    'xperienceDetail.loading': 'Loading xperience...',
    'xperienceDetail.notFound': 'Xperience not found',
    'xperienceDetail.backDashboard': 'Back to Dashboard',
    'xperienceDetail.editTitle': 'Edit Xperience',
    'xperienceDetail.field.title': 'Title',
    'xperienceDetail.field.description': 'Description',
    'xperienceDetail.field.location': 'Location',
    'xperienceDetail.field.tags': 'Tags',
    'xperienceDetail.copyLastLocation': 'Copy last location',
    'xperienceDetail.copyLocationToAll': 'Copy location to all media',
    'xperienceDetail.copyLocationToAllLoading': 'Copying to all media...',
    'xperienceDetail.error.noLastLocation': 'No previous location available yet.',
    'xperienceDetail.success.lastLocationCopied': 'Last location copied.',
    'xperienceDetail.placeholder.tags': 'Select or search tags...',
    'xperienceDetail.help.tags': 'Choose one or more tags to improve discovery.',
    'xperienceDetail.privateToggle': 'Private xperience (requires password)',
    'xperienceDetail.cancel': 'Cancel',
    'xperienceDetail.saveChanges': 'Save Changes',
    'xperienceDetail.edit': 'Edit',
    'xperienceDetail.deleteXperience': 'Delete Xperience',
    'xperienceDetail.info.status': 'Status',
    'xperienceDetail.pending': 'Pending',
    'xperienceDetail.info.views': 'Views',
    'xperienceDetail.info.rating': 'Rating',
    'xperienceDetail.info.reactions': 'Reactions',
    'xperienceDetail.info.tags': 'Tags',
    'xperienceDetail.info.category': 'Category',
    'xperienceDetail.info.created': 'Created',
    'xperienceDetail.noDate': 'N/A',
    'xperienceDetail.info.mediaCount': 'Media Count',
    'xperienceDetail.info.visibility': 'Visibility',
    'xperienceDetail.visibility.private': 'Private',
    'xperienceDetail.visibility.public': 'Public',
    'xperienceDetail.privateQR.title': 'Private Access QR',
    'xperienceDetail.privateQR.description': 'Share this QR or password to grant private access to your xperience.',
    'xperienceDetail.privateQR.alt': 'Private access QR code',
    'xperienceDetail.success.passwordCopied': 'Password copied to clipboard.',
    'xperienceDetail.copyPassword': 'Copy Password',
    'xperienceDetail.wait': 'Wait',
    'xperienceDetail.emailQR': 'Email QR',
    'xperienceDetail.mediaSectionTitle': 'Xperience Media',
    'xperienceDetail.createMedia': '+ Create Media',
    'xperienceDetail.uploading': 'Uploading',
    'xperienceDetail.noMedia': 'No media added yet.',
    'xperienceDetail.noMediaHelp': 'No media files yet. Upload images, videos, or audio.',
    'xperienceDetail.mediaCard.added': 'Added',
    'xperienceDetail.mediaCard.na': 'N/A',
    'xperienceDetail.mediaCard.viewDetails': 'View Details',
    'xperienceDetail.confirm.deleteMediaTitle': 'Delete media?',
    'xperienceDetail.confirm.deleteMediaMessage': 'This media item will be permanently deleted. This action cannot be undone.',
    'xperienceDetail.confirm.deleteXperienceTitle': 'Delete xperience?',
    'xperienceDetail.confirm.deleteXperienceMessage': 'This xperience and all associated media will be permanently deleted. This action cannot be undone.',
    'xperienceDetail.confirm.delete': 'Delete',
    'xperienceDetail.confirm.cancel': 'Cancel',
    'xperienceDetail.confirm.copyLocationAllTitle': 'Copy location to all media?',
    'xperienceDetail.confirm.copyLocationAllMessage': 'This will update location coordinates for all media in this xperience. Continue?',
    'xperienceDetail.confirm.copyLocationAllConfirm': 'Yes, update all media',
    'xperienceDetail.confirm.copyLocationAllCancel': 'Cancel',
    'xmedia.error.loadData': 'Failed to load data',
    'xmedia.error.delete': 'Failed to delete media',
    'xmedia.error.save': 'Failed to save xperience media',
    'xmedia.error.noXperienceLocation': 'The parent xperience has no location to copy yet.',
    'xmedia.error.noLastLocation': 'No previous location available yet.',
    'xmedia.error.requiredPrefix': 'The following fields are required:',
    'xmedia.success.posterSelected': 'Poster selected locally. It will be uploaded on save.',
    'xmedia.success.mediaSelected': 'Media selected locally. It will be uploaded on save.',
    'xmedia.success.deleted': 'Media deleted successfully!',
    'xmedia.success.created': 'Xperience media created and files uploaded successfully!',
    'xmedia.success.updated': 'Xperience media updated successfully!',
    'xmedia.success.locationCopied': 'Location copied from xperience.',
    'xmedia.success.lastLocationCopied': 'Last location copied.',
    'xmedia.confirm.deleteMessage': 'Are you sure you want to permanently delete this media item and its associated files? This action cannot be undone.',
    'xmedia.loading': 'Loading xperience media...',
    'xmedia.notFound': 'Xperience media not found',
    'xmedia.back': 'Back',
    'xmedia.title.create': 'Create New Media',
    'xmedia.title.edit': 'Edit Xperience Media',
    'xmedia.subtitle': 'Update all metadata and files for this media item.',
    'xmedia.field.title': 'Title',
    'xmedia.field.description': 'Description',
    'xmedia.field.type': 'Type',
    'xmedia.field.format': 'Format',
    'xmedia.field.category': 'Category',
    'xmedia.field.mediaFile': 'Media File',
    'xmedia.field.posterUrl': 'Poster URL',
    'xmedia.field.order': 'Order',
    'xmedia.field.runtime': 'Runtime',
    'xmedia.field.credits': 'Credits / Points required',
    'xmedia.field.location': 'Location',
    'xmedia.field.createdDate': 'Created Date',
    'xmedia.placeholder.title': 'Enter a title',
    'xmedia.placeholder.description': 'Enter description...',
    'xmedia.placeholder.mediaUrl': 'URL will be generated safely on save',
    'xmedia.placeholder.posterUrl': 'Poster path will be generated on save',
    'xmedia.placeholder.order': 'e.g., 1',
    'xmedia.placeholder.runtime': 'e.g., 3600',
    'xmedia.placeholder.credits': 'e.g., 0',
    'xmedia.selectFile': 'Select File',
    'xmedia.changeFile': 'Change File',
    'xmedia.viewMedia': 'View Media',
    'xmedia.selectImage': 'Select Image',
    'xmedia.changeImage': 'Change Image',
    'xmedia.thumbnail': 'Thumbnail Image',
    'xmedia.seconds': 'seconds',
    'xmedia.requiresDownload': 'Requires Download',
    'xmedia.isPublic': 'Is Public',
    'xmedia.isPremium': 'Is Premium',
    'xmedia.hide': 'Hide',
    'xmedia.deleteMedia': 'Delete Media',
    'xmedia.cancel': 'Cancel',
    'xmedia.saving': 'Saving...',
    'xmedia.saveChanges': 'Save Changes',
    'xmedia.copyXperienceLocation': 'Copy xperience location',
    'xmedia.copyLastLocation': 'Copy last location',
    'xmedia.copyLocationToAll': 'Copy location to all media',
    'xmedia.copyLocationToAllLoading': 'Copying to all media...',
    'xmedia.locationSource.xperience': 'Using xperience primary location',
    'xmedia.locationSource.last': 'Using last copied location',
    'xmedia.lastLocationPreview': 'Saved last location',
    'xmedia.confirm.copyLocationAllTitle': 'Copy location to all media?',
    'xmedia.confirm.copyLocationAllMessage': 'This will update location coordinates for all media in this xperience. Continue?',
    'xmedia.confirm.copyLocationAllConfirm': 'Yes, update all media',
    'xmedia.confirm.copyLocationAllCancel': 'Cancel',
    'xmedia.success.locationCopiedToAll': 'Location copied to {count} media items.',
    'xmedia.error.noXperienceForBulkLocation': 'Could not find the parent xperience for bulk location update.',
    'xmedia.error.noLocationToCopyAll': 'Set a location first before copying it to all media.',
    'xmedia.error.invalidLocationToCopyAll': 'Current location coordinates are invalid.',
    'xmedia.error.noMediaToCopyLocationAll': 'No media items found to update in this xperience.',
    'xmedia.error.locationCopiedToAllPartial': 'Updated {success} media items, but {failed} failed.',
    'xmedia.error.locationCopiedToAllFailed': 'Could not update location for all media.',
    'locationPicker.searchLabel': 'Search address',
    'locationPicker.searchPlaceholder': 'Type an address, city, or place',
    'locationPicker.longitude': 'Longitude',
    'locationPicker.latitude': 'Latitude',
    'locationPicker.clear': 'Clear location',
    'locationPicker.useCurrent': 'Use my current location',
    'locationPicker.locating': 'Locating...',
    'locationPicker.geoNotSupported': 'Your browser does not support geolocation.',
    'locationPicker.geoError': 'Could not get your current location. Check browser permissions.',
    'locationPicker.selectedAddress': 'Selected address',
    'locationPicker.loadingMap': 'Loading map...',
    'locationPicker.noApiKey': 'Google Maps API key is missing',
    'locationPicker.noApiKeyHelp': 'Set REACT_APP_GOOGLE_MAPS_API_KEY in frontend env to enable map and address search.',
    'locationPicker.loadError': 'Could not load Google Maps',
  },
  'en-GB': {
    'common.loading': 'Loading...',
    'common.email': 'Email',
    'common.password': 'Password',
    'common.confirmPassword': 'Confirm Password',
    'common.backToLogin': 'Back to Sign in',
    'common.signIn': 'Sign in',
    'common.emailExample': 'creator@example.com',
    'common.clearSearch': 'Clear search',
    'login.title': 'Welcome back',
    'login.subtitle': 'Sign in to your creator account',
    'login.passwordPlaceholder': 'Enter your password',
    'login.forgotPassword': 'Forgot password?',
    'login.submit': 'Sign In',
    'login.createOne': 'Create one',
    'login.error.verifyEmail': 'Please verify your email before logging in. Check your inbox for the verification link.',
    'login.error.invalidCredentials': 'Invalid email or password.',
    'login.resend.button': 'Resend verification email',
    'login.resend.success': 'If your account exists and is not verified, a new verification email has been sent.',
    'login.resend.error': 'Failed to resend verification email. Please try again shortly.',
    'login.resend.wait': 'Please wait a moment before requesting another verification email.',
    'login.resend.waitWithSeconds': 'Resend available in',
    'register.title': 'Create your account',
    'register.titleSuccess': 'Check your email',
    'register.subtitle': 'Join the X-periences creator community',
    'register.subtitleSuccess': 'We sent you a verification link',
    'register.alias': 'Alias',
    'register.aliasPlaceholder': 'Your creator alias',
    'register.passwordPlaceholder': 'At least 6 characters',
    'register.confirmPasswordPlaceholder': 'Confirm your password',
    'register.acceptPrefix': 'I have read and accept the',
    'register.terms': 'Terms of Use',
    'register.and': 'and',
    'register.privacy': 'Privacy Policy',
    'register.acceptSuffix': '.',
    'register.submit': 'Create Account',
    'register.successCreated': 'Account created successfully!',
    'register.successCheckInbox': 'Please check your inbox (and spam folder) and click the verification link to activate your account.',
    'register.successEmailIssue': 'Your account was created, but verification email delivery is temporarily unavailable. Use the resend verification button from login in a moment.',
    'register.successBackToLogin': 'Back to Login',
    'register.haveAccount': 'Already have an account?',
    'register.signIn': 'Sign in',
    'register.error.passwordsMismatch': 'Passwords do not match',
    'register.error.passwordMin': 'Password must be at least 6 characters',
    'register.error.acceptTerms': 'You must read and accept the Terms of Use and Privacy Policy',
    'register.error.generic': 'Registration failed',
    'forgot.title': 'Reset Password',
    'forgot.subtitle': 'Enter your email to receive a reset link',
    'forgot.submit': 'Send Reset Link',
    'forgot.success': 'Check your email for a password reset link.',
    'forgot.devMode': 'Development mode:',
    'forgot.devGoReset': 'Go to Reset Password',
    'forgot.remember': 'Remember your password?',
    'forgot.error.generic': 'Failed to send reset email',
    'reset.title': 'Reset Password',
    'reset.subtitle': 'Enter your new password',
    'reset.newPassword': 'New Password',
    'reset.confirmPassword': 'Confirm Password',
    'reset.confirmPlaceholder': 'Confirm your new password',
    'reset.submit': 'Reset Password',
    'reset.success': 'Password reset successfully! Redirecting to login...',
    'reset.error.invalidLink': 'Invalid reset link',
    'reset.error.passwordsMismatch': 'Passwords do not match',
    'reset.error.passwordMin': 'Password must be at least 6 characters',
    'reset.error.invalidToken': 'Invalid reset token',
    'reset.error.generic': 'Failed to reset password',
    'verify.title': 'Email Verification',
    'verify.loading': 'Verifying your email...',
    'verify.successLine1': 'Your email has been verified successfully!',
    'verify.successLine2': 'You can now log in to your account.',
    'verify.redirecting': 'Redirecting to login...',
    'verify.alreadyLine1': 'Your email was already verified!',
    'verify.alreadyLine2': 'You can log in to your account.',
    'verify.goLogin': 'Go to Login',
    'verify.error.noToken': 'No verification token provided',
    'verify.error.generic': 'Verification failed',
    'navbar.subtitle': 'Creator Portal',
    'navbar.dashboard': 'Dashboard',
    'navbar.modXperiences': 'Mod. Xperiences',
    'navbar.manageCreators': 'Manage Creators',
    'navbar.newXperience': 'New Xperience',
    'navbar.generateCreators': 'Generate Creators',
    'navbar.generateXperiences': 'Generate Xperiences',
    'navbar.generate': 'Generate',
    'navbar.generating': 'Generating',
    'navbar.profile': 'Profile',
    'navbar.logout': 'Logout',
    'navbar.confirmGenerateCreators': 'Are you sure you want to generate creators JSON?',
    'navbar.confirmGenerateXperiences': 'Are you sure you want to generate xperiences JSON?',
    'navbar.successGenerateCreators': 'Creators generated successfully!',
    'navbar.successGenerateXperiences': 'Xperiences generated successfully!',
    'navbar.error.endpoint': 'Endpoint not found. The API service might need a restart.',
    'navbar.error.noBody': 'No response body',
    'navbar.error.generateCreators': 'Failed to generate creators',
    'navbar.error.generateXperiences': 'Failed to generate xperiences',
    'navbar.roleDefault': 'Creator',
    'navbar.statusPending': 'Pending',
    'navbar.statusTitle': 'Status',
    'navbar.totalViews': 'Total Views',
    'navbar.avgRating': 'Average Rating',
    'navbar.roleTitle': 'Role',
    'navbar.languageLabel': 'Language',
    'navbar.lang.en': 'English',
    'navbar.lang.es': 'Spanish',
    'locale.en': 'English',
    'locale.zhHk': 'Chinese (Hong Kong)',
    'locale.zhHans': 'Chinese, Simplified',
    'locale.zhHant': 'Chinese, Traditional',
    'locale.enAu': 'English (Australia)',
    'locale.enGb': 'English (United Kingdom)',
    'locale.fr': 'French',
    'locale.frCa': 'French (Canada)',
    'locale.de': 'German',
    'locale.ja': 'Japanese',
    'locale.es': 'Spanish',
    'home.profileIncomplete': 'Please complete your profile before managing xperiences',
    'home.error.load': 'Failed to load xperiences',
    'home.title': 'Your Xperiences',
    'home.subtitle': 'Manage your immersive content for Apple Vision Pro',
    'home.newXperience': '+ New Xperience',
    'home.searchPlaceholder': 'Search by title or description...',
    'home.clearSearch': 'Clear search',
    'home.allMediaTypes': 'All Media Types',
    'home.loading': 'Loading xperiences...',
    'home.emptyTitle': 'No xperiences yet',
    'home.emptyText': 'Create your first immersive xperience for Apple Vision Pro',
    'home.createFirst': 'Create First Xperience',
    'home.noResultsTitle': 'No results found',
    'home.noResultsText': 'Try adjusting your search criteria or filters',
    'home.clearFilters': 'Clear Filters',
    'home.privateTitle': 'Private Xperience',
    'home.categoryTitle': 'Category',
    'home.viewsTitle': 'Views',
    'home.likesTitle': 'Likes',
    'home.dislikesTitle': 'Dislikes',
    'home.ratingTitle': 'Rating',
    'home.viewDetails': 'View Details',
    'home.moreTags': 'more tags',
    'home.files': 'file',
    'home.filesPlural': 'files',
    'beCreator.title': 'Be a Creator on X-periences',
    'beCreator.subtitle': 'Share immersive experiences for Apple Vision Pro',
    'beCreator.point1': 'Publish your own xperiences and build your audience.',
    'beCreator.point2': 'Track views, likes, and ratings from your dashboard.',
    'beCreator.point3': 'Manage media and updates from one creator portal.',
    'beCreator.ctaPrimary': 'Create Creator Account',
    'beCreator.ctaSecondary': 'I already have an account',
    'beCreator.heroTitle': 'Become a Creator',
    'beCreator.heroSubtitle': 'Share your unique X-periences with the world and turn your passion into reality.',
    'beCreator.heroCta': 'Join as a Creator',
    'beCreator.benefitsTitle': 'Why Join X-periences?',
    'beCreator.benefit.audienceTitle': 'Reach a Global Audience',
    'beCreator.benefit.audienceText': 'Connect with users worldwide who are eager to discover and engage with your unique content and X-periences.',
    'beCreator.benefit.recognitionTitle': 'Earn Recognition',
    'beCreator.benefit.recognitionText': 'Build your reputation as a creator by sharing immersive stories that inspire users around the world.',
    'beCreator.benefit.toolsTitle': 'Powerful Creator Tools',
    'beCreator.benefit.toolsText': 'Access advanced analytics, seamless media management, and easy-to-use publishing tools tailored for creators.',
    'beCreator.benefit.communityTitle': 'Supportive Community',
    'beCreator.benefit.communityText': 'Join a network of passionate creators. Share ideas, collaborate, and grow together in a safe environment.',
    'beCreator.howItWorksTitle': 'How It Works',
    'beCreator.step.signupTitle': 'Sign Up',
    'beCreator.step.signupText': 'Create your creator profile in just a few clicks.',
    'beCreator.step.createTitle': 'Create',
    'beCreator.step.createText': 'Upload your content and build your engaging X-periences.',
    'beCreator.step.recognizedTitle': 'Get Recognized',
    'beCreator.step.recognizedText': 'Share your xperiences globally, grow your audience, and become a reference creator in immersive content.',
    'beCreator.footerTitle': 'Ready to start your journey?',
    'beCreator.footerText': 'Take the first step to share immersive xperiences with the world.',
    'beCreator.footerCta': 'Get Started Now',
    'profile.loading': 'Loading profile...',
    'profile.title': 'Creator Profile',
    'profile.subtitle': 'Manage your creator information',
    'profile.requiredFieldsLabel': 'Required fields*:',
    'profile.requiredFieldsText': 'Full Name, Avatar, Biography, and Country are required to access the Xperiences dashboard.',
    'profile.section.accountInfo': 'Account Information',
    'profile.section.changePassword': 'Change Password',
    'profile.section.personalInfo': 'Personal Information',
    'profile.section.appSocial': 'App & Social Media',
    'profile.section.creatorStats': 'Creator Statistics',
    'profile.field.usernameAlias': 'Username (Alias)',
    'profile.field.currentPassword': 'Current Password',
    'profile.field.newPassword': 'New Password',
    'profile.field.confirmNewPassword': 'Confirm New Password',
    'profile.field.fullNameRequired': 'Full Name *',
    'profile.field.phone': 'Phone',
    'profile.field.countryRequired': 'Country *',
    'profile.field.avatarRequired': 'Avatar *',
    'profile.field.biographyRequired': 'Biography *',
    'profile.field.appName': 'App Name',
    'profile.field.appUrl': 'App URL',
    'profile.field.youtubeUrl': 'YouTube URL',
    'profile.field.instagramUrl': 'Instagram URL',
    'profile.field.otherUrl': 'Other URL',
    'profile.placeholder.username': 'Your username',
    'profile.placeholder.currentPassword': 'Enter your current password',
    'profile.placeholder.newPassword': 'Enter new password',
    'profile.placeholder.confirmNewPassword': 'Confirm new password',
    'profile.placeholder.fullName': 'Your full name',
    'profile.placeholder.phone': '+1 (555) 000-0000',
    'profile.placeholder.searchCountries': 'Type to search countries...',
    'profile.placeholder.biography': 'Tell us about yourself...',
    'profile.placeholder.appName': 'e.g., My App',
    'profile.placeholder.appUrl': 'https://myapp.com',
    'profile.placeholder.youtubeUrl': 'https://youtube.com/@yourusername',
    'profile.placeholder.instagramUrl': 'https://instagram.com/yourusername',
    'profile.placeholder.otherUrl': 'https://example.com',
    'profile.note.publicUsername': 'Your public username',
    'profile.note.emailImmutable': 'Email address cannot be changed in profile',
    'profile.note.passwordMin': 'Minimum 6 characters',
    'profile.note.requiredForDashboard': 'Required to access dashboard',
    'profile.note.countryRequired': 'Required to access dashboard • Select from list or type to search',
    'profile.note.avatarRequired': 'Required to access dashboard • JPG, PNG, or GIF (max 20MB)',
    'profile.note.biographyRequiredPrefix': 'Required to access dashboard •',
    'profile.note.characters': 'characters',
    'profile.optional': 'Optional',
    'profile.allOptional': 'All Optional',
    'profile.uploading': 'Uploading...',
    'profile.uploadingAvatar': 'Uploading avatar...',
    'profile.chooseAvatarImage': 'Choose Avatar Image',
    'profile.avatarPreviewAlt': 'Avatar Preview',
    'profile.preview': 'PREVIEW',
    'profile.openInNewTab': 'Open in new tab',
    'profile.view': 'View',
    'profile.stats.rating': 'Rating',
    'profile.stats.credits': 'Credits',
    'profile.stats.views': 'Views',
    'profile.stats.votes': 'Votes',
    'profile.saving': 'Saving...',
    'profile.saveChanges': 'Save Changes',
    'profile.success.profileAndPasswordUpdated': 'Profile and password updated successfully!',
    'profile.success.profileUpdatedComplete': 'Profile updated successfully! All required fields are complete. You can now access the Xperiences dashboard.',
    'profile.success.profileUpdatedIncomplete': 'Profile updated successfully! Please complete all required fields (Name, Avatar, Biography, Country) to access the dashboard.',
    'profile.error.loadProfile': 'Failed to load profile',
    'profile.error.avatarUpload': 'Failed to upload avatar. Profile NOT saved.',
    'profile.error.fillAllPasswordFields': 'Please fill all password fields to change your password',
    'profile.error.passwordsMismatch': 'New passwords do not match',
    'profile.error.passwordMin': 'New password must be at least 6 characters',
    'profile.error.changePassword': 'Failed to change password',
    'profile.error.profileUpdatedPasswordFailed': 'Profile updated but password change failed',
    'profile.error.updateProfile': 'Failed to update profile. Please try again.',
    'adminCreators.title': 'Manage Creators',
    'adminCreators.loading': 'Loading creators...',
    'adminCreators.error.load': 'Failed to load creators',
    'adminCreators.error.roleUpdate': 'Failed to update role',
    'adminCreators.error.statusUpdate': 'Failed to update status',
    'adminCreators.error.trustUpdate': 'Failed to update trust flag',
    'adminCreators.success.roleUpdated': 'Role updated successfully!',
    'adminCreators.success.statusUpdated': 'Status updated successfully!',
    'adminCreators.success.trustUpdated': 'Trust flag updated successfully!',
    'adminCreators.table.alias': 'Alias',
    'adminCreators.table.email': 'Email',
    'adminCreators.table.emailVerified': 'Email Verified',
    'adminCreators.table.hidden': 'Hidden',
    'adminCreators.table.joinDate': 'Join Date',
    'adminCreators.table.role': 'Role',
    'adminCreators.table.status': 'Status',
    'adminCreators.table.trusted': 'Trusted',
    'adminCreators.yes': 'Yes',
    'adminCreators.no': 'No',
    'adminCreators.hidden': 'Hidden',
    'adminCreators.visible': 'Visible',
    'adminCreators.trusted': 'Trusted',
    'adminCreators.standard': 'Standard',
    'adminCreators.role.creator': 'Creator',
    'adminCreators.role.manager': 'Manager',
    'adminCreators.role.administrator': 'Administrator',
    'adminCreators.status.pending': 'Pending',
    'adminCreators.status.approved': 'Approved',
    'adminCreators.status.rejected': 'Banned / Rejected',
    'adminCreators.empty': 'No creators found.',
    'adminCreators.pagination.page': 'Page',
    'adminCreators.pagination.of': 'of',
    'adminCreators.pagination.total': 'Total',
    'adminCreators.pagination.rowsPerPage': 'Rows per page',
    'adminCreators.pagination.previous': 'Previous',
    'adminCreators.pagination.next': 'Next',
    'adminCreatorDetail.title': 'Edit Creator:',
    'adminCreatorDetail.back': 'Back',
    'adminCreatorDetail.id': 'ID',
    'adminCreatorDetail.email': 'Email',
    'adminCreatorDetail.alias': 'Alias',
    'adminCreatorDetail.fullName': 'Full Name',
    'adminCreatorDetail.phone': 'Phone',
    'adminCreatorDetail.countryCode': 'Country Code',
    'adminCreatorDetail.countryPlaceholder': 'Type to search countries...',
    'adminCreatorDetail.flags': 'Profile Flags',
    'adminCreatorDetail.emailVerified': 'Email Verified',
    'adminCreatorDetail.resendEmail': 'Resend Email',
    'adminCreatorDetail.sending': 'Sending...',
    'adminCreatorDetail.hideProfile': 'Hide Profile (Incomplete)',
    'adminCreatorDetail.isTrusted': 'Trusted Creator',
    'adminCreatorDetail.bio': 'Bio / Description',
    'adminCreatorDetail.linksApps': 'Links & Apps',
    'adminCreatorDetail.appName': 'App Name',
    'adminCreatorDetail.appUrl': 'App URL',
    'adminCreatorDetail.youtubeUrl': 'YouTube URL',
    'adminCreatorDetail.instagramUrl': 'Instagram URL',
    'adminCreatorDetail.otherUrl': 'Other URL',
    'adminCreatorDetail.saveProfile': 'Save Profile',
    'adminCreatorDetail.saving': 'Saving...',
    'adminCreatorDetail.error.load': 'Failed to load creator',
    'adminCreatorDetail.error.verificationSend': 'Failed to send verification email.',
    'adminCreatorDetail.error.update': 'Failed to update creator',
    'adminCreatorDetail.success.verificationSent': 'Verification email sent successfully.',
    'adminCreatorDetail.success.updated': 'Creator updated successfully',
    'moderation.back': 'Back',
    'moderation.title.single': 'Moderating Xperience Content',
    'moderation.title.global': 'Content Moderation',
    'moderation.searchPlaceholder': 'Search by title, description, or creator...',
    'moderation.filter.allMedia': 'All Media',
    'moderation.filter.pending': 'Pending',
    'moderation.filter.approved': 'Approved',
    'moderation.filter.rejected': 'Rejected',
    'moderation.loading': 'Loading media...',
    'moderation.empty.search': 'No media match your search.',
    'moderation.empty.filter': 'No media found for the selected filter.',
    'moderation.noPoster': 'No Poster',
    'moderation.untitled': 'Untitled',
    'moderation.noDescription': 'No description',
    'moderation.creator': 'Creator',
    'moderation.email': 'Email',
    'moderation.date': 'Date',
    'moderation.na': 'N/A',
    'moderation.viewOriginal': 'View Original File',
    'moderation.action.approve': 'Approve',
    'moderation.action.reject': 'Reject',
    'moderation.action.setPending': 'Set Pending',
    'moderation.success.markedAs': 'Media successfully marked as',
    'moderation.error.loadMedia': 'Error loading media for moderation.',
    'moderation.error.updateStatus': 'Failed to update media status.',
    'adminXperiences.backDashboard': 'Back to Dashboard',
    'adminXperiences.title': 'Global Xperiences Moderation',
    'adminXperiences.searchPlaceholder': 'Search by title, description, or creator...',
    'adminXperiences.filter.all': 'All Xperiences',
    'adminXperiences.filter.pending': 'Pending',
    'adminXperiences.filter.approved': 'Approved',
    'adminXperiences.filter.rejected': 'Rejected',
    'adminXperiences.loading': 'Loading xperiences...',
    'adminXperiences.empty.search': 'No xperiences match your search.',
    'adminXperiences.empty.filter': 'No xperiences found for the selected filter.',
    'adminXperiences.noPoster': 'No Poster',
    'adminXperiences.noDescription': 'No description',
    'adminXperiences.creator': 'Creator',
    'adminXperiences.email': 'Email',
    'adminXperiences.date': 'Date',
    'adminXperiences.na': 'N/A',
    'adminXperiences.mediaCount': 'Media Count',
    'adminXperiences.items': 'items',
    'adminXperiences.action.moderateMedia': 'Moderate Media',
    'adminXperiences.action.approveAll': 'Approve All',
    'adminXperiences.action.rejectAll': 'Reject All',
    'adminXperiences.action.setPending': 'Set Pending',
    'adminXperiences.success.markedAs': 'Xperience successfully marked as',
    'adminXperiences.error.fetch': 'Failed to fetch xperiences',
    'adminXperiences.error.updateStatus': 'Failed to update status',
    'createXperience.profileIncomplete': 'Please complete your profile before creating a xperience',
    'createXperience.error.create': 'Failed to create xperience',
    'createXperience.title': 'Create New Xperience',
    'createXperience.subtitle': 'Start building your immersive content',
    'createXperience.field.title': 'Title',
    'createXperience.placeholder.title': 'Xperience title',
    'createXperience.field.description': 'Description',
    'createXperience.placeholder.description': 'Describe your xperience...',
    'createXperience.field.location': 'Location',
    'createXperience.field.tags': 'Tags',
    'createXperience.copyLastLocation': 'Copy last location',
    'createXperience.error.noLastLocation': 'No previous location available yet.',
    'createXperience.placeholder.tags': 'Select or search tags...',
    'createXperience.help.tags': 'Choose one or more tags to improve discovery.',
    'createXperience.cancel': 'Cancel',
    'createXperience.submit': 'Create Xperience',
    'xperienceDetail.success.mediaOrderSaved': 'Media order saved successfully.',
    'xperienceDetail.error.mediaOrderSave': 'Failed to save media order.',
    'xperienceDetail.error.load': 'Failed to load xperience',
    'xperienceDetail.success.updated': 'Xperience updated successfully.',
    'xperienceDetail.error.update': 'Failed to update xperience',
    'xperienceDetail.sendingEmail': 'Sending email...',
    'xperienceDetail.success.emailSent': 'QR access email sent successfully.',
    'xperienceDetail.success.locationCopiedToAll': 'Location copied to {count} media items.',
    'xperienceDetail.error.sendEmail': 'Failed to send QR email.',
    'xperienceDetail.error.uploadMedia': 'Failed to upload media',
    'xperienceDetail.error.deleteMedia': 'Failed to delete media',
    'xperienceDetail.error.deleteXperience': 'Failed to delete xperience',
    'xperienceDetail.error.noLocationToCopyAll': 'Set a location first before copying it to all media.',
    'xperienceDetail.error.invalidLocationToCopyAll': 'Current location coordinates are invalid.',
    'xperienceDetail.error.noMediaToCopyLocationAll': 'No media items found to update in this xperience.',
    'xperienceDetail.error.locationCopiedToAllPartial': 'Updated {success} media items, but {failed} failed.',
    'xperienceDetail.error.locationCopiedToAllFailed': 'Could not update location for all media.',
    'xperienceDetail.loading': 'Loading xperience...',
    'xperienceDetail.notFound': 'Xperience not found',
    'xperienceDetail.backDashboard': 'Back to Dashboard',
    'xperienceDetail.editTitle': 'Edit Xperience',
    'xperienceDetail.field.title': 'Title',
    'xperienceDetail.field.description': 'Description',
    'xperienceDetail.field.location': 'Location',
    'xperienceDetail.field.tags': 'Tags',
    'xperienceDetail.copyLastLocation': 'Copy last location',
    'xperienceDetail.copyLocationToAll': 'Copy location to all media',
    'xperienceDetail.copyLocationToAllLoading': 'Copying to all media...',
    'xperienceDetail.error.noLastLocation': 'No previous location available yet.',
    'xperienceDetail.success.lastLocationCopied': 'Last location copied.',
    'xperienceDetail.placeholder.tags': 'Select or search tags...',
    'xperienceDetail.help.tags': 'Choose one or more tags to improve discovery.',
    'xperienceDetail.privateToggle': 'Private xperience (requires password)',
    'xperienceDetail.cancel': 'Cancel',
    'xperienceDetail.saveChanges': 'Save Changes',
    'xperienceDetail.edit': 'Edit',
    'xperienceDetail.deleteXperience': 'Delete Xperience',
    'xperienceDetail.info.status': 'Status',
    'xperienceDetail.pending': 'Pending',
    'xperienceDetail.info.views': 'Views',
    'xperienceDetail.info.rating': 'Rating',
    'xperienceDetail.info.reactions': 'Reactions',
    'xperienceDetail.info.tags': 'Tags',
    'xperienceDetail.info.category': 'Category',
    'xperienceDetail.info.created': 'Created',
    'xperienceDetail.noDate': 'N/A',
    'xperienceDetail.info.mediaCount': 'Media Count',
    'xperienceDetail.info.visibility': 'Visibility',
    'xperienceDetail.visibility.private': 'Private',
    'xperienceDetail.visibility.public': 'Public',
    'xperienceDetail.privateQR.title': 'Private Access QR',
    'xperienceDetail.privateQR.description': 'Share this QR or password to grant private access to your xperience.',
    'xperienceDetail.privateQR.alt': 'Private access QR code',
    'xperienceDetail.success.passwordCopied': 'Password copied to clipboard.',
    'xperienceDetail.copyPassword': 'Copy Password',
    'xperienceDetail.wait': 'Wait',
    'xperienceDetail.emailQR': 'Email QR',
    'xperienceDetail.mediaSectionTitle': 'Xperience Media',
    'xperienceDetail.createMedia': '+ Create Media',
    'xperienceDetail.uploading': 'Uploading',
    'xperienceDetail.noMedia': 'No media added yet.',
    'xperienceDetail.noMediaHelp': 'No media files yet. Upload images, videos, or audio.',
    'xperienceDetail.mediaCard.added': 'Added',
    'xperienceDetail.mediaCard.na': 'N/A',
    'xperienceDetail.mediaCard.viewDetails': 'View Details',
    'xperienceDetail.confirm.deleteMediaTitle': 'Delete media?',
    'xperienceDetail.confirm.deleteMediaMessage': 'This media item will be permanently deleted. This action cannot be undone.',
    'xperienceDetail.confirm.deleteXperienceTitle': 'Delete xperience?',
    'xperienceDetail.confirm.deleteXperienceMessage': 'This xperience and all associated media will be permanently deleted. This action cannot be undone.',
    'xperienceDetail.confirm.delete': 'Delete',
    'xperienceDetail.confirm.cancel': 'Cancel',
    'xperienceDetail.confirm.copyLocationAllTitle': 'Copy location to all media?',
    'xperienceDetail.confirm.copyLocationAllMessage': 'This will update location coordinates for all media in this xperience. Continue?',
    'xperienceDetail.confirm.copyLocationAllConfirm': 'Yes, update all media',
    'xperienceDetail.confirm.copyLocationAllCancel': 'Cancel',
    'xmedia.error.loadData': 'Failed to load data',
    'xmedia.error.delete': 'Failed to delete media',
    'xmedia.error.save': 'Failed to save xperience media',
    'xmedia.error.noXperienceLocation': 'The parent xperience has no location to copy yet.',
    'xmedia.error.noLastLocation': 'No previous location available yet.',
    'xmedia.error.requiredPrefix': 'The following fields are required:',
    'xmedia.success.posterSelected': 'Poster selected locally. It will be uploaded on save.',
    'xmedia.success.mediaSelected': 'Media selected locally. It will be uploaded on save.',
    'xmedia.success.deleted': 'Media deleted successfully!',
    'xmedia.success.created': 'Xperience media created and files uploaded successfully!',
    'xmedia.success.updated': 'Xperience media updated successfully!',
    'xmedia.success.locationCopied': 'Location copied from xperience.',
    'xmedia.success.lastLocationCopied': 'Last location copied.',
    'xmedia.confirm.deleteMessage': 'Are you sure you want to permanently delete this media item and its associated files? This action cannot be undone.',
    'xmedia.loading': 'Loading xperience media...',
    'xmedia.notFound': 'Xperience media not found',
    'xmedia.back': 'Back',
    'xmedia.title.create': 'Create New Media',
    'xmedia.title.edit': 'Edit Xperience Media',
    'xmedia.subtitle': 'Update all metadata and files for this media item.',
    'xmedia.field.title': 'Title',
    'xmedia.field.description': 'Description',
    'xmedia.field.type': 'Type',
    'xmedia.field.format': 'Format',
    'xmedia.field.category': 'Category',
    'xmedia.field.mediaFile': 'Media File',
    'xmedia.field.posterUrl': 'Poster URL',
    'xmedia.field.order': 'Order',
    'xmedia.field.runtime': 'Runtime',
    'xmedia.field.credits': 'Credits / Points required',
    'xmedia.field.location': 'Location',
    'xmedia.field.createdDate': 'Created Date',
    'xmedia.placeholder.title': 'Enter a title',
    'xmedia.placeholder.description': 'Enter description...',
    'xmedia.placeholder.mediaUrl': 'URL will be generated safely on save',
    'xmedia.placeholder.posterUrl': 'Poster path will be generated on save',
    'xmedia.placeholder.order': 'e.g., 1',
    'xmedia.placeholder.runtime': 'e.g., 3600',
    'xmedia.placeholder.credits': 'e.g., 0',
    'xmedia.selectFile': 'Select File',
    'xmedia.changeFile': 'Change File',
    'xmedia.viewMedia': 'View Media',
    'xmedia.selectImage': 'Select Image',
    'xmedia.changeImage': 'Change Image',
    'xmedia.thumbnail': 'Thumbnail Image',
    'xmedia.seconds': 'seconds',
    'xmedia.requiresDownload': 'Requires Download',
    'xmedia.isPublic': 'Is Public',
    'xmedia.isPremium': 'Is Premium',
    'xmedia.hide': 'Hide',
    'xmedia.deleteMedia': 'Delete Media',
    'xmedia.cancel': 'Cancel',
    'xmedia.saving': 'Saving...',
    'xmedia.saveChanges': 'Save Changes',
    'xmedia.copyXperienceLocation': 'Copy xperience location',
    'xmedia.copyLastLocation': 'Copy last location',
    'xmedia.copyLocationToAll': 'Copy location to all media',
    'xmedia.copyLocationToAllLoading': 'Copying to all media...',
    'xmedia.locationSource.xperience': 'Using xperience primary location',
    'xmedia.locationSource.last': 'Using last copied location',
    'xmedia.lastLocationPreview': 'Saved last location',
    'xmedia.confirm.copyLocationAllTitle': 'Copy location to all media?',
    'xmedia.confirm.copyLocationAllMessage': 'This will update location coordinates for all media in this xperience. Continue?',
    'xmedia.confirm.copyLocationAllConfirm': 'Yes, update all media',
    'xmedia.confirm.copyLocationAllCancel': 'Cancel',
    'xmedia.success.locationCopiedToAll': 'Location copied to {count} media items.',
    'xmedia.error.noXperienceForBulkLocation': 'Could not find the parent xperience for bulk location update.',
    'xmedia.error.noLocationToCopyAll': 'Set a location first before copying it to all media.',
    'xmedia.error.invalidLocationToCopyAll': 'Current location coordinates are invalid.',
    'xmedia.error.noMediaToCopyLocationAll': 'No media items found to update in this xperience.',
    'xmedia.error.locationCopiedToAllPartial': 'Updated {success} media items, but {failed} failed.',
    'xmedia.error.locationCopiedToAllFailed': 'Could not update location for all media.',
    'locationPicker.searchLabel': 'Search address',
    'locationPicker.searchPlaceholder': 'Type an address, city, or place',
    'locationPicker.longitude': 'Longitude',
    'locationPicker.latitude': 'Latitude',
    'locationPicker.clear': 'Clear location',
    'locationPicker.useCurrent': 'Use my current location',
    'locationPicker.locating': 'Locating...',
    'locationPicker.geoNotSupported': 'Your browser does not support geolocation.',
    'locationPicker.geoError': 'Could not get your current location. Check browser permissions.',
    'locationPicker.selectedAddress': 'Selected address',
    'locationPicker.loadingMap': 'Loading map...',
    'locationPicker.noApiKey': 'Google Maps API key is missing',
    'locationPicker.noApiKeyHelp': 'Set REACT_APP_GOOGLE_MAPS_API_KEY in frontend env to enable map and address search.',
    'locationPicker.loadError': 'Could not load Google Maps',
  },
  'fr': {
    'common.loading': 'Chargement...',
    'common.email': 'Courriel',
    'common.password': 'Mot de passe',
    'common.confirmPassword': 'Confirmer le mot de passe',
    'common.backToLogin': 'Retour à la connexion',
    'common.signIn': 'Connectez-vous',
    'common.emailExample': 'créateur@exemple.com',
    'common.clearSearch': 'Effacer la recherche',
    'login.title': 'Bon retour',
    'login.subtitle': 'Connectez-vous à votre compte créateur',
    'login.passwordPlaceholder': 'Entrez votre mot de passe',
    'login.forgotPassword': 'Mot de passe oublié ?',
    'login.submit': 'Connectez-vous',
    'login.createOne': 'Créez-en un',
    'login.error.verifyEmail': 'Veuillez vérifier votre adresse e-mail avant de vous connecter. Vérifiez votre boîte de réception pour le lien de vérification.',
    'login.error.invalidCredentials': 'Email ou mot de passe invalide.',
    'login.resend.button': 'Renvoyer l\'e-mail de vérification',
    'login.resend.success': 'Si votre compte existe et n\'est pas vérifié, un nouvel e-mail de vérification a été envoyé.',
    'login.resend.error': 'Échec du renvoi de l\'e-mail de vérification. Veuillez réessayer sous peu.',
    'login.resend.wait': 'Veuillez patienter un moment avant de demander un autre e-mail de vérification.',
    'login.resend.waitWithSeconds': 'Renvoyer disponible dans',
    'register.title': 'Créez votre compte',
    'register.titleSuccess': 'Vérifiez votre courrier électronique',
    'register.subtitle': 'Rejoignez la communauté des créateurs X-periences',
    'register.subtitleSuccess': 'Nous vous avons envoyé un lien de vérification',
    'register.alias': 'Alias',
    'register.aliasPlaceholder': 'Votre pseudo de créateur',
    'register.passwordPlaceholder': 'Au moins 6 caractères',
    'register.confirmPasswordPlaceholder': 'Confirmez votre mot de passe',
    'register.acceptPrefix': 'J\'ai lu et j\'accepte le',
    'register.terms': 'Conditions d\'utilisation',
    'register.and': 'et',
    'register.privacy': 'Politique de confidentialité',
    'register.acceptSuffix': '.',
    'register.submit': 'Créer un compte',
    'register.successCreated': 'Compte créé avec succès !',
    'register.successCheckInbox': 'Veuillez vérifier votre boîte de réception (et votre dossier spam) et cliquez sur le lien de vérification pour activer votre compte.',
    'register.successEmailIssue': 'Votre compte a été créé, mais l\'envoi d\'e-mails de vérification est temporairement indisponible. Utilisez le bouton de vérification de renvoi depuis la connexion dans un instant.',
    'register.successBackToLogin': 'Retour à la connexion',
    'register.haveAccount': 'Vous avez déjà un compte ?',
    'register.signIn': 'Connectez-vous',
    'register.error.passwordsMismatch': 'Les mots de passe ne correspondent pas',
    'register.error.passwordMin': 'Le mot de passe doit contenir au moins 6 caractères',
    'register.error.acceptTerms': 'Vous devez lire et accepter les conditions d\'utilisation et la politique de confidentialité',
    'register.error.generic': 'L\'inscription a échoué',
    'forgot.title': 'Réinitialiser le mot de passe',
    'forgot.subtitle': 'Entrez votre email pour recevoir un lien de réinitialisation',
    'forgot.submit': 'Envoyer le lien de réinitialisation',
    'forgot.success': 'Vérifiez votre courrier électronique pour un lien de réinitialisation du mot de passe.',
    'forgot.devMode': 'Mode de développement :',
    'forgot.devGoReset': 'Accédez à Réinitialiser le mot de passe',
    'forgot.remember': 'Vous vous souvenez de votre mot de passe ?',
    'forgot.error.generic': 'Échec de l\'envoi de l\'e-mail de réinitialisation',
    'reset.title': 'Réinitialiser le mot de passe',
    'reset.subtitle': 'Entrez votre nouveau mot de passe',
    'reset.newPassword': 'Nouveau mot de passe',
    'reset.confirmPassword': 'Confirmer le mot de passe',
    'reset.confirmPlaceholder': 'Confirmez votre nouveau mot de passe',
    'reset.submit': 'Réinitialiser le mot de passe',
    'reset.success': 'Réinitialisation du mot de passe réussie ! Redirection vers la connexion...',
    'reset.error.invalidLink': 'Lien de réinitialisation invalide',
    'reset.error.passwordsMismatch': 'Les mots de passe ne correspondent pas',
    'reset.error.passwordMin': 'Le mot de passe doit contenir au moins 6 caractères',
    'reset.error.invalidToken': 'Jeton de réinitialisation invalide',
    'reset.error.generic': 'Échec de la réinitialisation du mot de passe',
    'verify.title': 'Vérification par e-mail',
    'verify.loading': 'Vérification de votre e-mail...',
    'verify.successLine1': 'Votre email a été vérifié avec succès !',
    'verify.successLine2': 'Vous pouvez maintenant vous connecter à votre compte.',
    'verify.redirecting': 'Redirection vers la connexion...',
    'verify.alreadyLine1': 'Votre email a déjà été vérifié !',
    'verify.alreadyLine2': 'Vous pouvez vous connecter à votre compte.',
    'verify.goLogin': 'Allez dans Connexion',
    'verify.error.noToken': 'Aucun jeton de vérification fourni',
    'verify.error.generic': 'La vérification a échoué',
    'navbar.subtitle': 'Portail des créateurs',
    'navbar.dashboard': 'Tableau de bord',
    'navbar.modXperiences': 'Mod. Expériences',
    'navbar.manageCreators': 'Gérer les créateurs',
    'navbar.newXperience': 'Nouvelle expérience',
    'navbar.generateCreators': 'Générer des créateurs',
    'navbar.generateXperiences': 'Générer des expériences',
    'navbar.generate': 'Générer',
    'navbar.generating': 'Génération',
    'navbar.profile': 'Profil',
    'navbar.logout': 'Déconnexion',
    'navbar.confirmGenerateCreators': 'Etes-vous sûr de vouloir générer du JSON pour les créateurs ?',
    'navbar.confirmGenerateXperiences': 'Êtes-vous sûr de vouloir générer des xperiences JSON ?',
    'navbar.successGenerateCreators': 'Créateurs générés avec succès !',
    'navbar.successGenerateXperiences': 'Xpériences générées avec succès !',
    'navbar.error.endpoint': 'Point de terminaison introuvable. Le service API devra peut-être être redémarré.',
    'navbar.error.noBody': 'Aucun corps de réponse',
    'navbar.error.generateCreators': 'Échec de la génération des créateurs',
    'navbar.error.generateXperiences': 'Échec de la génération d\'expériences',
    'navbar.roleDefault': 'Créateur',
    'navbar.statusPending': 'En attente',
    'navbar.statusTitle': 'Statut',
    'navbar.totalViews': 'Vues totales',
    'navbar.avgRating': 'Note moyenne',
    'navbar.roleTitle': 'Rôle',
    'navbar.languageLabel': 'Langue',
    'navbar.lang.en': 'Anglais',
    'navbar.lang.es': 'Espagnol',
    'locale.en': 'Anglais',
    'locale.zhHk': 'Chinois (Hong Kong)',
    'locale.zhHans': 'Chinois, simplifié',
    'locale.zhHant': 'Chinois, Traditionnel',
    'locale.enAu': 'Anglais (Australie)',
    'locale.enGb': 'Anglais (Royaume-Uni)',
    'locale.fr': 'Français',
    'locale.frCa': 'Français (Canada)',
    'locale.de': 'Allemand',
    'locale.ja': 'Japonais',
    'locale.es': 'Espagnol',
    'home.profileIncomplete': 'Veuillez compléter votre profil avant de gérer des expériences',
    'home.error.load': 'Échec du chargement des expériences',
    'home.title': 'Vos expériences',
    'home.subtitle': 'Gérez votre contenu immersif pour Apple Vision Pro',
    'home.newXperience': '+ Nouvelle expérience',
    'home.searchPlaceholder': 'Recherche par titre ou description...',
    'home.clearSearch': 'Effacer la recherche',
    'home.allMediaTypes': 'Tous les types de médias',
    'home.loading': 'Chargement des expériences...',
    'home.emptyTitle': 'Aucune expérience pour l\'instant',
    'home.emptyText': 'Créez votre première expérience immersive pour Apple Vision Pro',
    'home.createFirst': 'Créez votre première expérience',
    'home.noResultsTitle': 'Aucun résultat trouvé',
    'home.noResultsText': 'Essayez d\'ajuster vos critères de recherche ou vos filtres',
    'home.clearFilters': 'Effacer les filtres',
    'home.privateTitle': 'Expérience privée',
    'home.categoryTitle': 'Catégorie',
    'home.viewsTitle': 'Vues',
    'home.likesTitle': 'J\'aime',
    'home.dislikesTitle': 'Je n\'aime pas',
    'home.ratingTitle': 'Note',
    'home.viewDetails': 'Afficher les détails',
    'home.moreTags': 'plus de balises',
    'home.files': 'fichier',
    'home.filesPlural': 'fichiers',
    'beCreator.title': 'Soyez un créateur sur X-periences',
    'beCreator.subtitle': 'Partagez des expériences immersives pour Apple Vision Pro',
    'beCreator.point1': 'Publiez vos propres expériences et développez votre audience.',
    'beCreator.point2': 'Suivez les vues, les likes et les notes depuis votre tableau de bord.',
    'beCreator.point3': 'Gérez les médias et les mises à jour à partir d\'un seul portail de créateur.',
    'beCreator.ctaPrimary': 'Créer un compte créateur',
    'beCreator.ctaSecondary': 'J\'ai déjà un compte',
    'beCreator.heroTitle': 'Devenez un créateur',
    'beCreator.heroSubtitle': 'Partagez vos expériences X uniques avec le monde et transformez votre passion en réalité.',
    'beCreator.heroCta': 'Rejoignez-nous en tant que créateur',
    'beCreator.benefitsTitle': 'Pourquoi rejoindre les X-périences ?',
    'beCreator.benefit.audienceTitle': 'Atteignez un public mondial',
    'beCreator.benefit.audienceText': 'Connectez-vous avec des utilisateurs du monde entier désireux de découvrir et d\'interagir avec votre contenu unique et vos X-periences.',
    'beCreator.benefit.recognitionTitle': 'Gagnez de la reconnaissance',
    'beCreator.benefit.recognitionText': 'Construisez votre réputation de créateur en partageant des histoires immersives qui inspirent les utilisateurs du monde entier.',
    'beCreator.benefit.toolsTitle': 'Outils de création puissants',
    'beCreator.benefit.toolsText': 'Accédez à des analyses avancées, à une gestion transparente des médias et à des outils de publication faciles à utiliser et adaptés aux créateurs.',
    'beCreator.benefit.communityTitle': 'Communauté de soutien',
    'beCreator.benefit.communityText': 'Rejoignez un réseau de créateurs passionnés. Partagez des idées, collaborez et grandissez ensemble dans un environnement sûr.',
    'beCreator.howItWorksTitle': 'Comment ça marche',
    'beCreator.step.signupTitle': 'S\'inscrire',
    'beCreator.step.signupText': 'Créez votre profil de créateur en quelques clics.',
    'beCreator.step.createTitle': 'Créer',
    'beCreator.step.createText': 'Téléchargez votre contenu et créez vos expériences X engageantes.',
    'beCreator.step.recognizedTitle': 'Faites-vous reconnaître',
    'beCreator.step.recognizedText': 'Partagez vos expériences à l\'échelle mondiale, développez votre audience et devenez un créateur de référence en matière de contenu immersif.',
    'beCreator.footerTitle': 'Prêt à commencer votre voyage ?',
    'beCreator.footerText': 'Faites le premier pas pour partager des expériences immersives avec le monde.',
    'beCreator.footerCta': 'Commencez maintenant',
    'profile.loading': 'Chargement du profil...',
    'profile.title': 'Profil de créateur',
    'profile.subtitle': 'Gérer les informations de votre créateur',
    'profile.requiredFieldsLabel': 'Champs obligatoires* :',
    'profile.requiredFieldsText': 'Le nom complet, l\'avatar, la biographie et le pays sont requis pour accéder au tableau de bord Xperiences.',
    'profile.section.accountInfo': 'Informations sur le compte',
    'profile.section.changePassword': 'Changer le mot de passe',
    'profile.section.personalInfo': 'Informations personnelles',
    'profile.section.appSocial': 'Applications et réseaux sociaux',
    'profile.section.creatorStats': 'Statistiques des créateurs',
    'profile.field.usernameAlias': 'Nom d\'utilisateur (alias)',
    'profile.field.currentPassword': 'Mot de passe actuel',
    'profile.field.newPassword': 'Nouveau mot de passe',
    'profile.field.confirmNewPassword': 'Confirmer le nouveau mot de passe',
    'profile.field.fullNameRequired': 'Nom complet *',
    'profile.field.phone': 'Téléphone',
    'profile.field.countryRequired': 'Pays *',
    'profile.field.avatarRequired': 'Avatar*',
    'profile.field.biographyRequired': 'Biographie *',
    'profile.field.appName': 'Nom de l\'application',
    'profile.field.appUrl': 'URL de l\'application',
    'profile.field.youtubeUrl': 'URL YouTube',
    'profile.field.instagramUrl': 'URL Instagram',
    'profile.field.otherUrl': 'Autre URL',
    'profile.placeholder.username': 'Votre nom d\'utilisateur',
    'profile.placeholder.currentPassword': 'Entrez votre mot de passe actuel',
    'profile.placeholder.newPassword': 'Entrez le nouveau mot de passe',
    'profile.placeholder.confirmNewPassword': 'Confirmer le nouveau mot de passe',
    'profile.placeholder.fullName': 'Votre nom complet',
    'profile.placeholder.phone': '+1 (555) 000-0000',
    'profile.placeholder.searchCountries': 'Tapez pour rechercher des pays...',
    'profile.placeholder.biography': 'Parlez-nous de vous...',
    'profile.placeholder.appName': 'par exemple, Mon application',
    'profile.placeholder.appUrl': 'https://myapp.com',
    'profile.placeholder.youtubeUrl': 'https://youtube.com/@votrenom d\'utilisateur',
    'profile.placeholder.instagramUrl': 'https://instagram.com/votrenom d\'utilisateur',
    'profile.placeholder.otherUrl': 'https://exemple.com',
    'profile.note.publicUsername': 'Votre nom d\'utilisateur public',
    'profile.note.emailImmutable': 'L\'adresse e-mail ne peut pas être modifiée dans le profil',
    'profile.note.passwordMin': 'Minimum 6 caractères',
    'profile.note.requiredForDashboard': 'Obligatoire pour accéder au tableau de bord',
    'profile.note.countryRequired': 'Obligatoire pour accéder au tableau de bord • Sélectionnez dans la liste ou saisissez pour rechercher',
    'profile.note.avatarRequired': 'Obligatoire pour accéder au tableau de bord • JPG, PNG ou GIF (max 20 Mo)',
    'profile.note.biographyRequiredPrefix': 'Obligatoire pour accéder au tableau de bord •',
    'profile.note.characters': 'personnages',
    'profile.optional': 'Facultatif',
    'profile.allOptional': 'Tout en option',
    'profile.uploading': 'Téléchargement...',
    'profile.uploadingAvatar': 'Téléchargement de l\'avatar...',
    'profile.chooseAvatarImage': 'Choisissez l\'image de l\'avatar',
    'profile.avatarPreviewAlt': 'Aperçu de l\'avatar',
    'profile.preview': 'APERÇU',
    'profile.openInNewTab': 'Ouvrir dans un nouvel onglet',
    'profile.view': 'Voir',
    'profile.stats.rating': 'Note',
    'profile.stats.credits': 'Crédits',
    'profile.stats.views': 'Vues',
    'profile.stats.votes': 'Votes',
    'profile.saving': 'Sauvegarde...',
    'profile.saveChanges': 'Enregistrer les modifications',
    'profile.success.profileAndPasswordUpdated': 'Profil et mot de passe mis à jour avec succès !',
    'profile.success.profileUpdatedComplete': 'Profil mis à jour avec succès ! Tous les champs obligatoires sont remplis. Vous pouvez désormais accéder au tableau de bord Xperiences.',
    'profile.success.profileUpdatedIncomplete': 'Profil mis à jour avec succès ! Veuillez remplir tous les champs obligatoires (Nom, Avatar, Biographie, Pays) pour accéder au tableau de bord.',
    'profile.error.loadProfile': 'Échec du chargement du profil',
    'profile.error.avatarUpload': 'Échec du téléchargement de l\'avatar. Profil NON enregistré.',
    'profile.error.fillAllPasswordFields': 'Veuillez remplir tous les champs de mot de passe pour modifier votre mot de passe',
    'profile.error.passwordsMismatch': 'Les nouveaux mots de passe ne correspondent pas',
    'profile.error.passwordMin': 'Le nouveau mot de passe doit contenir au moins 6 caractères',
    'profile.error.changePassword': 'Échec de la modification du mot de passe',
    'profile.error.profileUpdatedPasswordFailed': 'Profil mis à jour mais le changement de mot de passe a échoué',
    'profile.error.updateProfile': 'Échec de la mise à jour du profil. Veuillez réessayer.',
    'adminCreators.title': 'Gérer les créateurs',
    'adminCreators.loading': 'Chargement des créateurs...',
    'adminCreators.error.load': 'Échec du chargement des créateurs',
    'adminCreators.error.roleUpdate': 'Échec de la mise à jour du rôle',
    'adminCreators.error.statusUpdate': 'Échec de la mise à jour du statut',
    'adminCreators.error.trustUpdate': 'Échec de la mise à jour de l\'indicateur de confiance',
    'adminCreators.success.roleUpdated': 'Rôle mis à jour avec succès !',
    'adminCreators.success.statusUpdated': 'Statut mis à jour avec succès !',
    'adminCreators.success.trustUpdated': 'Indicateur de confiance mis à jour avec succès !',
    'adminCreators.table.alias': 'Alias',
    'adminCreators.table.email': 'Courriel',
    'adminCreators.table.emailVerified': 'E-mail vérifié',
    'adminCreators.table.hidden': 'Caché',
    'adminCreators.table.joinDate': 'Date d\'adhésion',
    'adminCreators.table.role': 'Rôle',
    'adminCreators.table.status': 'Statut',
    'adminCreators.table.trusted': 'Confiance',
    'adminCreators.yes': 'Oui',
    'adminCreators.no': 'Non',
    'adminCreators.hidden': 'Caché',
    'adminCreators.visible': 'Visible',
    'adminCreators.trusted': 'Confiance',
    'adminCreators.standard': 'Norme',
    'adminCreators.role.creator': 'Créateur',
    'adminCreators.role.manager': 'Gestionnaire',
    'adminCreators.role.administrator': 'Administrateur',
    'adminCreators.status.pending': 'En attente',
    'adminCreators.status.approved': 'Approuvé',
    'adminCreators.status.rejected': 'Interdit / Rejeté',
    'adminCreators.empty': 'Aucun créateur trouvé.',
    'adminCreators.pagination.page': 'Pages',
    'adminCreators.pagination.of': 'de',
    'adminCreators.pagination.total': 'Total',
    'adminCreators.pagination.rowsPerPage': 'Lignes par page',
    'adminCreators.pagination.previous': 'Précédent',
    'adminCreators.pagination.next': 'Suivant',
    'adminCreatorDetail.title': 'Modifier le créateur :',
    'adminCreatorDetail.back': 'Retour',
    'adminCreatorDetail.id': 'pièce d\'identité',
    'adminCreatorDetail.email': 'Courriel',
    'adminCreatorDetail.alias': 'Alias',
    'adminCreatorDetail.fullName': 'Nom complet',
    'adminCreatorDetail.phone': 'Téléphone',
    'adminCreatorDetail.countryCode': 'Indicatif du pays',
    'adminCreatorDetail.countryPlaceholder': 'Tapez pour rechercher des pays...',
    'adminCreatorDetail.flags': 'Indicateurs de profil',
    'adminCreatorDetail.emailVerified': 'E-mail vérifié',
    'adminCreatorDetail.resendEmail': 'Renvoyer l\'e-mail',
    'adminCreatorDetail.sending': 'Envoi...',
    'adminCreatorDetail.hideProfile': 'Masquer le profil (incomplet)',
    'adminCreatorDetail.isTrusted': 'Créateur de confiance',
    'adminCreatorDetail.bio': 'Biographie / Description',
    'adminCreatorDetail.linksApps': 'Liens et applications',
    'adminCreatorDetail.appName': 'Nom de l\'application',
    'adminCreatorDetail.appUrl': 'URL de l\'application',
    'adminCreatorDetail.youtubeUrl': 'URL YouTube',
    'adminCreatorDetail.instagramUrl': 'URL Instagram',
    'adminCreatorDetail.otherUrl': 'Autre URL',
    'adminCreatorDetail.saveProfile': 'Enregistrer le profil',
    'adminCreatorDetail.saving': 'Sauvegarde...',
    'adminCreatorDetail.error.load': 'Échec du chargement du créateur',
    'adminCreatorDetail.error.verificationSend': 'Échec de l\'envoi de l\'e-mail de vérification.',
    'adminCreatorDetail.error.update': 'Échec de la mise à jour du créateur',
    'adminCreatorDetail.success.verificationSent': 'E-mail de vérification envoyé avec succès.',
    'adminCreatorDetail.success.updated': 'Créateur mis à jour avec succès',
    'moderation.back': 'Retour',
    'moderation.title.single': 'Modération du contenu Xperience',
    'moderation.title.global': 'Modération du contenu',
    'moderation.searchPlaceholder': 'Recherchez par titre, description ou créateur...',
    'moderation.filter.allMedia': 'Tous les médias',
    'moderation.filter.pending': 'En attente',
    'moderation.filter.approved': 'Approuvé',
    'moderation.filter.rejected': 'Rejeté',
    'moderation.loading': 'Chargement du média...',
    'moderation.empty.search': 'Aucun média ne correspond à votre recherche.',
    'moderation.empty.filter': 'Aucun média trouvé pour le filtre sélectionné.',
    'moderation.noPoster': 'Aucune affiche',
    'moderation.untitled': 'Sans titre',
    'moderation.noDescription': 'Pas de description',
    'moderation.creator': 'Créateur',
    'moderation.email': 'Courriel',
    'moderation.date': 'Date',
    'moderation.na': 'N/D',
    'moderation.viewOriginal': 'Afficher le fichier d\'origine',
    'moderation.action.approve': 'Approuver',
    'moderation.action.reject': 'Rejeter',
    'moderation.action.setPending': 'Définir en attente',
    'moderation.success.markedAs': 'Média marqué avec succès comme',
    'moderation.error.loadMedia': 'Erreur lors du chargement du média pour modération.',
    'moderation.error.updateStatus': 'Échec de la mise à jour de l\'état du média.',
    'adminXperiences.backDashboard': 'Retour au tableau de bord',
    'adminXperiences.title': 'Modération des expériences mondiales',
    'adminXperiences.searchPlaceholder': 'Recherchez par titre, description ou créateur...',
    'adminXperiences.filter.all': 'Toutes les expériences',
    'adminXperiences.filter.pending': 'En attente',
    'adminXperiences.filter.approved': 'Approuvé',
    'adminXperiences.filter.rejected': 'Rejeté',
    'adminXperiences.loading': 'Chargement des expériences...',
    'adminXperiences.empty.search': 'Aucune expérience ne correspond à votre recherche.',
    'adminXperiences.empty.filter': 'Aucune expérience trouvée pour le filtre sélectionné.',
    'adminXperiences.noPoster': 'Aucune affiche',
    'adminXperiences.noDescription': 'Pas de description',
    'adminXperiences.creator': 'Créateur',
    'adminXperiences.email': 'Courriel',
    'adminXperiences.date': 'Date',
    'adminXperiences.na': 'N/D',
    'adminXperiences.mediaCount': 'Nombre de médias',
    'adminXperiences.items': 'articles',
    'adminXperiences.action.moderateMedia': 'Médias modérés',
    'adminXperiences.action.approveAll': 'Tout approuver',
    'adminXperiences.action.rejectAll': 'Tout rejeter',
    'adminXperiences.action.setPending': 'Définir en attente',
    'adminXperiences.success.markedAs': 'Expérience marquée avec succès comme',
    'adminXperiences.error.fetch': 'Échec de la récupération des expériences',
    'adminXperiences.error.updateStatus': 'Échec de la mise à jour du statut',
    'createXperience.profileIncomplete': 'Veuillez compléter votre profil avant de créer une expérience',
    'createXperience.error.create': 'Échec de la création de l\'expérience',
    'createXperience.title': 'Créez une nouvelle expérience',
    'createXperience.subtitle': 'Commencez à créer votre contenu immersif',
    'createXperience.field.title': 'Titre',
    'createXperience.placeholder.title': 'Titre de l\'expérience',
    'createXperience.field.description': 'Descriptif',
    'createXperience.placeholder.description': 'Décrivez votre expérience...',
    'createXperience.field.location': 'Emplacement',
    'createXperience.field.tags': 'Balises',
    'createXperience.copyLastLocation': 'Copier le dernier emplacement',
    'createXperience.error.noLastLocation': 'Aucun emplacement précédent n\'est encore disponible.',
    'createXperience.placeholder.tags': 'Sélectionnez ou recherchez des balises...',
    'createXperience.help.tags': 'Choisissez une ou plusieurs balises pour améliorer la découverte.',
    'createXperience.cancel': 'Annuler',
    'createXperience.submit': 'Créer une expérience',
    'xperienceDetail.success.mediaOrderSaved': 'L\'ordre des médias a été enregistré avec succès.',
    'xperienceDetail.error.mediaOrderSave': 'Échec de l\'enregistrement de l\'ordre des médias.',
    'xperienceDetail.error.load': 'Échec du chargement de l\'expérience',
    'xperienceDetail.success.updated': 'Xperience a été mis à jour avec succès.',
    'xperienceDetail.error.update': 'Échec de la mise à jour de l\'expérience',
    'xperienceDetail.sendingEmail': 'Envoi d\'e-mail...',
    'xperienceDetail.success.emailSent': 'E-mail d\'accès QR envoyé avec succès.',
    'xperienceDetail.success.locationCopiedToAll': 'Emplacement copié dans {count} éléments multimédias.',
    'xperienceDetail.error.sendEmail': 'Échec de l\'envoi de l\'e-mail QR.',
    'xperienceDetail.error.uploadMedia': 'Échec du téléchargement du média',
    'xperienceDetail.error.deleteMedia': 'Échec de la suppression du média',
    'xperienceDetail.error.deleteXperience': 'Échec de la suppression de l\'expérience',
    'xperienceDetail.error.noLocationToCopyAll': 'Définissez d’abord un emplacement avant de le copier sur tous les supports.',
    'xperienceDetail.error.invalidLocationToCopyAll': 'Les coordonnées de l\'emplacement actuel ne sont pas valides.',
    'xperienceDetail.error.noMediaToCopyLocationAll': 'Aucun élément multimédia trouvé à mettre à jour dans cette expérience.',
    'xperienceDetail.error.locationCopiedToAllPartial': 'Mise à jour des éléments multimédias {success}, mais {failed} a échoué.',
    'xperienceDetail.error.locationCopiedToAllFailed': 'Impossible de mettre à jour l\'emplacement de tous les médias.',
    'xperienceDetail.loading': 'Chargement de l\'expérience...',
    'xperienceDetail.notFound': 'Expérience introuvable',
    'xperienceDetail.backDashboard': 'Retour au tableau de bord',
    'xperienceDetail.editTitle': 'Modifier l\'expérience',
    'xperienceDetail.field.title': 'Titre',
    'xperienceDetail.field.description': 'Descriptif',
    'xperienceDetail.field.location': 'Emplacement',
    'xperienceDetail.field.tags': 'Balises',
    'xperienceDetail.copyLastLocation': 'Copier le dernier emplacement',
    'xperienceDetail.copyLocationToAll': 'Copier l\'emplacement sur tous les médias',
    'xperienceDetail.copyLocationToAllLoading': 'Copie sur tous les supports...',
    'xperienceDetail.error.noLastLocation': 'Aucun emplacement précédent n\'est encore disponible.',
    'xperienceDetail.success.lastLocationCopied': 'Dernier emplacement copié.',
    'xperienceDetail.placeholder.tags': 'Sélectionnez ou recherchez des balises...',
    'xperienceDetail.help.tags': 'Choisissez une ou plusieurs balises pour améliorer la découverte.',
    'xperienceDetail.privateToggle': 'Expérience privée (nécessite un mot de passe)',
    'xperienceDetail.cancel': 'Annuler',
    'xperienceDetail.saveChanges': 'Enregistrer les modifications',
    'xperienceDetail.edit': 'Modifier',
    'xperienceDetail.deleteXperience': 'Supprimer l\'expérience',
    'xperienceDetail.info.status': 'Statut',
    'xperienceDetail.pending': 'En attente',
    'xperienceDetail.info.views': 'Vues',
    'xperienceDetail.info.rating': 'Note',
    'xperienceDetail.info.reactions': 'Réactions',
    'xperienceDetail.info.tags': 'Balises',
    'xperienceDetail.info.category': 'Catégorie',
    'xperienceDetail.info.created': 'Créé',
    'xperienceDetail.noDate': 'N/D',
    'xperienceDetail.info.mediaCount': 'Nombre de médias',
    'xperienceDetail.info.visibility': 'Visibilité',
    'xperienceDetail.visibility.private': 'Privé',
    'xperienceDetail.visibility.public': 'Publique',
    'xperienceDetail.privateQR.title': 'QR d\'accès privé',
    'xperienceDetail.privateQR.description': 'Partagez ce QR ou ce mot de passe pour accorder un accès privé à votre expérience.',
    'xperienceDetail.privateQR.alt': 'Code QR d\'accès privé',
    'xperienceDetail.success.passwordCopied': 'Mot de passe copié dans le presse-papiers.',
    'xperienceDetail.copyPassword': 'Copier le mot de passe',
    'xperienceDetail.wait': 'Attends',
    'xperienceDetail.emailQR': 'Envoyer un code QR par e-mail',
    'xperienceDetail.mediaSectionTitle': 'Xpérience Média',
    'xperienceDetail.createMedia': '+ Créer un média',
    'xperienceDetail.uploading': 'Téléchargement',
    'xperienceDetail.noMedia': 'Aucun média ajouté pour l\'instant.',
    'xperienceDetail.noMediaHelp': 'Aucun fichier multimédia pour l\'instant. Téléchargez des images, des vidéos ou de l\'audio.',
    'xperienceDetail.mediaCard.added': 'Ajouté',
    'xperienceDetail.mediaCard.na': 'N/D',
    'xperienceDetail.mediaCard.viewDetails': 'Afficher les détails',
    'xperienceDetail.confirm.deleteMediaTitle': 'Supprimer le média ?',
    'xperienceDetail.confirm.deleteMediaMessage': 'Cet élément multimédia sera définitivement supprimé. Cette action ne peut pas être annulée.',
    'xperienceDetail.confirm.deleteXperienceTitle': 'Supprimer l\'expérience ?',
    'xperienceDetail.confirm.deleteXperienceMessage': 'Cette expérience et tous les médias associés seront définitivement supprimés. Cette action ne peut pas être annulée.',
    'xperienceDetail.confirm.delete': 'Supprimer',
    'xperienceDetail.confirm.cancel': 'Annuler',
    'xperienceDetail.confirm.copyLocationAllTitle': 'Copier l\'emplacement sur tous les médias ?',
    'xperienceDetail.confirm.copyLocationAllMessage': 'Cela mettra à jour les coordonnées de localisation de tous les médias de cette expérience. Continuer?',
    'xperienceDetail.confirm.copyLocationAllConfirm': 'Oui, mettre à jour tous les médias',
    'xperienceDetail.confirm.copyLocationAllCancel': 'Annuler',
    'xmedia.error.loadData': 'Échec du chargement des données',
    'xmedia.error.delete': 'Échec de la suppression du média',
    'xmedia.error.save': 'Échec de l\'enregistrement du support xperience',
    'xmedia.error.noXperienceLocation': 'L\'expérience parent n\'a pas encore d\'emplacement à copier.',
    'xmedia.error.noLastLocation': 'Aucun emplacement précédent n\'est encore disponible.',
    'xmedia.error.requiredPrefix': 'Les champs suivants sont obligatoires :',
    'xmedia.success.posterSelected': 'Affiche sélectionnée localement. Il sera téléchargé lors de la sauvegarde.',
    'xmedia.success.mediaSelected': 'Médias sélectionnés localement. Il sera téléchargé lors de la sauvegarde.',
    'xmedia.success.deleted': 'Média supprimé avec succès !',
    'xmedia.success.created': 'Médias Xperience créés et fichiers téléchargés avec succès !',
    'xmedia.success.updated': 'Média Xperience mis à jour avec succès !',
    'xmedia.success.locationCopied': 'Emplacement copié de xperience.',
    'xmedia.success.lastLocationCopied': 'Dernier emplacement copié.',
    'xmedia.confirm.deleteMessage': 'Êtes-vous sûr de vouloir supprimer définitivement cet élément multimédia et ses fichiers associés ? Cette action ne peut pas être annulée.',
    'xmedia.loading': 'Chargement du média xperience...',
    'xmedia.notFound': 'Média Xperience introuvable',
    'xmedia.back': 'Retour',
    'xmedia.title.create': 'Créer un nouveau média',
    'xmedia.title.edit': 'Modifier le média Xperience',
    'xmedia.subtitle': 'Mettez à jour toutes les métadonnées et tous les fichiers de cet élément multimédia.',
    'xmedia.field.title': 'Titre',
    'xmedia.field.description': 'Descriptif',
    'xmedia.field.type': 'Tapez',
    'xmedia.field.format': 'Formater',
    'xmedia.field.category': 'Catégorie',
    'xmedia.field.mediaFile': 'Fichier multimédia',
    'xmedia.field.posterUrl': 'URL de l\'affiche',
    'xmedia.field.order': 'Commande',
    'xmedia.field.runtime': 'Durée d\'exécution',
    'xmedia.field.credits': 'Crédits / Points requis',
    'xmedia.field.location': 'Emplacement',
    'xmedia.field.createdDate': 'Date de création',
    'xmedia.placeholder.title': 'Entrez un titre',
    'xmedia.placeholder.description': 'Entrez la description...',
    'xmedia.placeholder.mediaUrl': 'L\'URL sera générée en toute sécurité lors de la sauvegarde',
    'xmedia.placeholder.posterUrl': 'Le chemin de l\'affiche sera généré lors de l\'enregistrement',
    'xmedia.placeholder.order': 'par exemple, 1',
    'xmedia.placeholder.runtime': 'par exemple, 3600',
    'xmedia.placeholder.credits': 'par exemple, 0',
    'xmedia.selectFile': 'Sélectionnez un fichier',
    'xmedia.changeFile': 'Changer de fichier',
    'xmedia.viewMedia': 'Afficher les médias',
    'xmedia.selectImage': 'Sélectionnez une image',
    'xmedia.changeImage': 'Changer l\'image',
    'xmedia.thumbnail': 'Image miniature',
    'xmedia.seconds': 'secondes',
    'xmedia.requiresDownload': 'Nécessite un téléchargement',
    'xmedia.isPublic': 'est public',
    'xmedia.isPremium': 'Est Premium',
    'xmedia.hide': 'Masquer',
    'xmedia.deleteMedia': 'Supprimer le média',
    'xmedia.cancel': 'Annuler',
    'xmedia.saving': 'Sauvegarde...',
    'xmedia.saveChanges': 'Enregistrer les modifications',
    'xmedia.copyXperienceLocation': 'Copier l\'emplacement de l\'expérience',
    'xmedia.copyLastLocation': 'Copier le dernier emplacement',
    'xmedia.copyLocationToAll': 'Copier l\'emplacement sur tous les médias',
    'xmedia.copyLocationToAllLoading': 'Copie sur tous les supports...',
    'xmedia.locationSource.xperience': 'Utilisation de l\'emplacement principal xperience',
    'xmedia.locationSource.last': 'Utilisation du dernier emplacement copié',
    'xmedia.lastLocationPreview': 'Dernier emplacement enregistré',
    'xmedia.confirm.copyLocationAllTitle': 'Copier l\'emplacement sur tous les médias ?',
    'xmedia.confirm.copyLocationAllMessage': 'Cela mettra à jour les coordonnées de localisation de tous les médias de cette expérience. Continuer?',
    'xmedia.confirm.copyLocationAllConfirm': 'Oui, mettre à jour tous les médias',
    'xmedia.confirm.copyLocationAllCancel': 'Annuler',
    'xmedia.success.locationCopiedToAll': 'Emplacement copié dans {count} éléments multimédias.',
    'xmedia.error.noXperienceForBulkLocation': 'Impossible de trouver l\'expérience parent pour la mise à jour groupée de l\'emplacement.',
    'xmedia.error.noLocationToCopyAll': 'Définissez d’abord un emplacement avant de le copier sur tous les supports.',
    'xmedia.error.invalidLocationToCopyAll': 'Les coordonnées de l\'emplacement actuel ne sont pas valides.',
    'xmedia.error.noMediaToCopyLocationAll': 'Aucun élément multimédia trouvé à mettre à jour dans cette expérience.',
    'xmedia.error.locationCopiedToAllPartial': 'Mise à jour des éléments multimédias {success}, mais {failed} a échoué.',
    'xmedia.error.locationCopiedToAllFailed': 'Impossible de mettre à jour l\'emplacement de tous les médias.',
    'locationPicker.searchLabel': 'Rechercher une adresse',
    'locationPicker.searchPlaceholder': 'Saisissez une adresse, une ville ou un lieu',
    'locationPicker.longitude': 'Longitude',
    'locationPicker.latitude': 'Latitude',
    'locationPicker.clear': 'Emplacement clair',
    'locationPicker.useCurrent': 'Utiliser ma position actuelle',
    'locationPicker.locating': 'Localisation...',
    'locationPicker.geoNotSupported': 'Votre navigateur ne prend pas en charge la géolocalisation.',
    'locationPicker.geoError': 'Impossible d\'obtenir votre position actuelle. Vérifiez les autorisations du navigateur.',
    'locationPicker.selectedAddress': 'Adresse sélectionnée',
    'locationPicker.loadingMap': 'Chargement de la carte...',
    'locationPicker.noApiKey': 'La clé API Google Maps est manquante',
    'locationPicker.noApiKeyHelp': 'Définissez REACT_APP_GOOGLE_MAPS_API_KEY dans l\'environnement frontend pour activer la recherche de carte et d\'adresse.',
    'locationPicker.loadError': 'Impossible de charger Google Maps',
  },
  'fr-CA': {
    'common.loading': 'Chargement...',
    'common.email': 'Courriel',
    'common.password': 'Mot de passe',
    'common.confirmPassword': 'Confirmer le mot de passe',
    'common.backToLogin': 'Retour à la connexion',
    'common.signIn': 'Connectez-vous',
    'common.emailExample': 'créateur@exemple.com',
    'common.clearSearch': 'Effacer la recherche',
    'login.title': 'Bon retour',
    'login.subtitle': 'Connectez-vous à votre compte créateur',
    'login.passwordPlaceholder': 'Entrez votre mot de passe',
    'login.forgotPassword': 'Mot de passe oublié ?',
    'login.submit': 'Connectez-vous',
    'login.createOne': 'Créez-en un',
    'login.error.verifyEmail': 'Veuillez vérifier votre adresse e-mail avant de vous connecter. Vérifiez votre boîte de réception pour le lien de vérification.',
    'login.error.invalidCredentials': 'Email ou mot de passe invalide.',
    'login.resend.button': 'Renvoyer l\'e-mail de vérification',
    'login.resend.success': 'Si votre compte existe et n\'est pas vérifié, un nouvel e-mail de vérification a été envoyé.',
    'login.resend.error': 'Échec du renvoi de l\'e-mail de vérification. Veuillez réessayer sous peu.',
    'login.resend.wait': 'Veuillez patienter un moment avant de demander un autre e-mail de vérification.',
    'login.resend.waitWithSeconds': 'Renvoyer disponible dans',
    'register.title': 'Créez votre compte',
    'register.titleSuccess': 'Vérifiez votre courrier électronique',
    'register.subtitle': 'Rejoignez la communauté des créateurs X-periences',
    'register.subtitleSuccess': 'Nous vous avons envoyé un lien de vérification',
    'register.alias': 'Alias',
    'register.aliasPlaceholder': 'Votre pseudo de créateur',
    'register.passwordPlaceholder': 'Au moins 6 caractères',
    'register.confirmPasswordPlaceholder': 'Confirmez votre mot de passe',
    'register.acceptPrefix': 'J\'ai lu et j\'accepte le',
    'register.terms': 'Conditions d\'utilisation',
    'register.and': 'et',
    'register.privacy': 'Politique de confidentialité',
    'register.acceptSuffix': '.',
    'register.submit': 'Créer un compte',
    'register.successCreated': 'Compte créé avec succès !',
    'register.successCheckInbox': 'Veuillez vérifier votre boîte de réception (et votre dossier spam) et cliquez sur le lien de vérification pour activer votre compte.',
    'register.successEmailIssue': 'Votre compte a été créé, mais l\'envoi d\'e-mails de vérification est temporairement indisponible. Utilisez le bouton de vérification de renvoi depuis la connexion dans un instant.',
    'register.successBackToLogin': 'Retour à la connexion',
    'register.haveAccount': 'Vous avez déjà un compte ?',
    'register.signIn': 'Connectez-vous',
    'register.error.passwordsMismatch': 'Les mots de passe ne correspondent pas',
    'register.error.passwordMin': 'Le mot de passe doit contenir au moins 6 caractères',
    'register.error.acceptTerms': 'Vous devez lire et accepter les conditions d\'utilisation et la politique de confidentialité',
    'register.error.generic': 'L\'inscription a échoué',
    'forgot.title': 'Réinitialiser le mot de passe',
    'forgot.subtitle': 'Entrez votre email pour recevoir un lien de réinitialisation',
    'forgot.submit': 'Envoyer le lien de réinitialisation',
    'forgot.success': 'Vérifiez votre courrier électronique pour un lien de réinitialisation du mot de passe.',
    'forgot.devMode': 'Mode de développement :',
    'forgot.devGoReset': 'Accédez à Réinitialiser le mot de passe',
    'forgot.remember': 'Vous vous souvenez de votre mot de passe ?',
    'forgot.error.generic': 'Échec de l\'envoi de l\'e-mail de réinitialisation',
    'reset.title': 'Réinitialiser le mot de passe',
    'reset.subtitle': 'Entrez votre nouveau mot de passe',
    'reset.newPassword': 'Nouveau mot de passe',
    'reset.confirmPassword': 'Confirmer le mot de passe',
    'reset.confirmPlaceholder': 'Confirmez votre nouveau mot de passe',
    'reset.submit': 'Réinitialiser le mot de passe',
    'reset.success': 'Réinitialisation du mot de passe réussie ! Redirection vers la connexion...',
    'reset.error.invalidLink': 'Lien de réinitialisation invalide',
    'reset.error.passwordsMismatch': 'Les mots de passe ne correspondent pas',
    'reset.error.passwordMin': 'Le mot de passe doit contenir au moins 6 caractères',
    'reset.error.invalidToken': 'Jeton de réinitialisation invalide',
    'reset.error.generic': 'Échec de la réinitialisation du mot de passe',
    'verify.title': 'Vérification par e-mail',
    'verify.loading': 'Vérification de votre e-mail...',
    'verify.successLine1': 'Votre email a été vérifié avec succès !',
    'verify.successLine2': 'Vous pouvez maintenant vous connecter à votre compte.',
    'verify.redirecting': 'Redirection vers la connexion...',
    'verify.alreadyLine1': 'Votre email a déjà été vérifié !',
    'verify.alreadyLine2': 'Vous pouvez vous connecter à votre compte.',
    'verify.goLogin': 'Allez dans Connexion',
    'verify.error.noToken': 'Aucun jeton de vérification fourni',
    'verify.error.generic': 'La vérification a échoué',
    'navbar.subtitle': 'Portail des créateurs',
    'navbar.dashboard': 'Tableau de bord',
    'navbar.modXperiences': 'Mod. Expériences',
    'navbar.manageCreators': 'Gérer les créateurs',
    'navbar.newXperience': 'Nouvelle expérience',
    'navbar.generateCreators': 'Générer des créateurs',
    'navbar.generateXperiences': 'Générer des expériences',
    'navbar.generate': 'Générer',
    'navbar.generating': 'Génération',
    'navbar.profile': 'Profil',
    'navbar.logout': 'Déconnexion',
    'navbar.confirmGenerateCreators': 'Etes-vous sûr de vouloir générer du JSON pour les créateurs ?',
    'navbar.confirmGenerateXperiences': 'Êtes-vous sûr de vouloir générer des xperiences JSON ?',
    'navbar.successGenerateCreators': 'Créateurs générés avec succès !',
    'navbar.successGenerateXperiences': 'Xpériences générées avec succès !',
    'navbar.error.endpoint': 'Point de terminaison introuvable. Le service API devra peut-être être redémarré.',
    'navbar.error.noBody': 'Aucun corps de réponse',
    'navbar.error.generateCreators': 'Échec de la génération des créateurs',
    'navbar.error.generateXperiences': 'Échec de la génération d\'expériences',
    'navbar.roleDefault': 'Créateur',
    'navbar.statusPending': 'En attente',
    'navbar.statusTitle': 'Statut',
    'navbar.totalViews': 'Vues totales',
    'navbar.avgRating': 'Note moyenne',
    'navbar.roleTitle': 'Rôle',
    'navbar.languageLabel': 'Langue',
    'navbar.lang.en': 'Anglais',
    'navbar.lang.es': 'Espagnol',
    'locale.en': 'Anglais',
    'locale.zhHk': 'Chinois (Hong Kong)',
    'locale.zhHans': 'Chinois, simplifié',
    'locale.zhHant': 'Chinois, Traditionnel',
    'locale.enAu': 'Anglais (Australie)',
    'locale.enGb': 'Anglais (Royaume-Uni)',
    'locale.fr': 'Français',
    'locale.frCa': 'Français (Canada)',
    'locale.de': 'Allemand',
    'locale.ja': 'Japonais',
    'locale.es': 'Espagnol',
    'home.profileIncomplete': 'Veuillez compléter votre profil avant de gérer des expériences',
    'home.error.load': 'Échec du chargement des expériences',
    'home.title': 'Vos expériences',
    'home.subtitle': 'Gérez votre contenu immersif pour Apple Vision Pro',
    'home.newXperience': '+ Nouvelle expérience',
    'home.searchPlaceholder': 'Recherche par titre ou description...',
    'home.clearSearch': 'Effacer la recherche',
    'home.allMediaTypes': 'Tous les types de médias',
    'home.loading': 'Chargement des expériences...',
    'home.emptyTitle': 'Aucune expérience pour l\'instant',
    'home.emptyText': 'Créez votre première expérience immersive pour Apple Vision Pro',
    'home.createFirst': 'Créez votre première expérience',
    'home.noResultsTitle': 'Aucun résultat trouvé',
    'home.noResultsText': 'Essayez d\'ajuster vos critères de recherche ou vos filtres',
    'home.clearFilters': 'Effacer les filtres',
    'home.privateTitle': 'Expérience privée',
    'home.categoryTitle': 'Catégorie',
    'home.viewsTitle': 'Vues',
    'home.likesTitle': 'J\'aime',
    'home.dislikesTitle': 'Je n\'aime pas',
    'home.ratingTitle': 'Note',
    'home.viewDetails': 'Afficher les détails',
    'home.moreTags': 'plus de balises',
    'home.files': 'fichier',
    'home.filesPlural': 'fichiers',
    'beCreator.title': 'Soyez un créateur sur X-periences',
    'beCreator.subtitle': 'Partagez des expériences immersives pour Apple Vision Pro',
    'beCreator.point1': 'Publiez vos propres expériences et développez votre audience.',
    'beCreator.point2': 'Suivez les vues, les likes et les notes depuis votre tableau de bord.',
    'beCreator.point3': 'Gérez les médias et les mises à jour à partir d\'un seul portail de créateur.',
    'beCreator.ctaPrimary': 'Créer un compte créateur',
    'beCreator.ctaSecondary': 'J\'ai déjà un compte',
    'beCreator.heroTitle': 'Devenez un créateur',
    'beCreator.heroSubtitle': 'Partagez vos expériences X uniques avec le monde et transformez votre passion en réalité.',
    'beCreator.heroCta': 'Rejoignez-nous en tant que créateur',
    'beCreator.benefitsTitle': 'Pourquoi rejoindre les X-périences ?',
    'beCreator.benefit.audienceTitle': 'Atteignez un public mondial',
    'beCreator.benefit.audienceText': 'Connectez-vous avec des utilisateurs du monde entier désireux de découvrir et d\'interagir avec votre contenu unique et vos X-periences.',
    'beCreator.benefit.recognitionTitle': 'Gagnez de la reconnaissance',
    'beCreator.benefit.recognitionText': 'Construisez votre réputation de créateur en partageant des histoires immersives qui inspirent les utilisateurs du monde entier.',
    'beCreator.benefit.toolsTitle': 'Outils de création puissants',
    'beCreator.benefit.toolsText': 'Accédez à des analyses avancées, à une gestion transparente des médias et à des outils de publication faciles à utiliser et adaptés aux créateurs.',
    'beCreator.benefit.communityTitle': 'Communauté de soutien',
    'beCreator.benefit.communityText': 'Rejoignez un réseau de créateurs passionnés. Partagez des idées, collaborez et grandissez ensemble dans un environnement sûr.',
    'beCreator.howItWorksTitle': 'Comment ça marche',
    'beCreator.step.signupTitle': 'S\'inscrire',
    'beCreator.step.signupText': 'Créez votre profil de créateur en quelques clics.',
    'beCreator.step.createTitle': 'Créer',
    'beCreator.step.createText': 'Téléchargez votre contenu et créez vos expériences X engageantes.',
    'beCreator.step.recognizedTitle': 'Faites-vous reconnaître',
    'beCreator.step.recognizedText': 'Partagez vos expériences à l\'échelle mondiale, développez votre audience et devenez un créateur de référence en matière de contenu immersif.',
    'beCreator.footerTitle': 'Prêt à commencer votre voyage ?',
    'beCreator.footerText': 'Faites le premier pas pour partager des expériences immersives avec le monde.',
    'beCreator.footerCta': 'Commencez maintenant',
    'profile.loading': 'Chargement du profil...',
    'profile.title': 'Profil de créateur',
    'profile.subtitle': 'Gérer les informations de votre créateur',
    'profile.requiredFieldsLabel': 'Champs obligatoires* :',
    'profile.requiredFieldsText': 'Le nom complet, l\'avatar, la biographie et le pays sont requis pour accéder au tableau de bord Xperiences.',
    'profile.section.accountInfo': 'Informations sur le compte',
    'profile.section.changePassword': 'Changer le mot de passe',
    'profile.section.personalInfo': 'Informations personnelles',
    'profile.section.appSocial': 'Applications et réseaux sociaux',
    'profile.section.creatorStats': 'Statistiques des créateurs',
    'profile.field.usernameAlias': 'Nom d\'utilisateur (alias)',
    'profile.field.currentPassword': 'Mot de passe actuel',
    'profile.field.newPassword': 'Nouveau mot de passe',
    'profile.field.confirmNewPassword': 'Confirmer le nouveau mot de passe',
    'profile.field.fullNameRequired': 'Nom complet *',
    'profile.field.phone': 'Téléphone',
    'profile.field.countryRequired': 'Pays *',
    'profile.field.avatarRequired': 'Avatar*',
    'profile.field.biographyRequired': 'Biographie *',
    'profile.field.appName': 'Nom de l\'application',
    'profile.field.appUrl': 'URL de l\'application',
    'profile.field.youtubeUrl': 'URL YouTube',
    'profile.field.instagramUrl': 'URL Instagram',
    'profile.field.otherUrl': 'Autre URL',
    'profile.placeholder.username': 'Votre nom d\'utilisateur',
    'profile.placeholder.currentPassword': 'Entrez votre mot de passe actuel',
    'profile.placeholder.newPassword': 'Entrez le nouveau mot de passe',
    'profile.placeholder.confirmNewPassword': 'Confirmer le nouveau mot de passe',
    'profile.placeholder.fullName': 'Votre nom complet',
    'profile.placeholder.phone': '+1 (555) 000-0000',
    'profile.placeholder.searchCountries': 'Tapez pour rechercher des pays...',
    'profile.placeholder.biography': 'Parlez-nous de vous...',
    'profile.placeholder.appName': 'par exemple, Mon application',
    'profile.placeholder.appUrl': 'https://myapp.com',
    'profile.placeholder.youtubeUrl': 'https://youtube.com/@votrenom d\'utilisateur',
    'profile.placeholder.instagramUrl': 'https://instagram.com/votrenom d\'utilisateur',
    'profile.placeholder.otherUrl': 'https://exemple.com',
    'profile.note.publicUsername': 'Votre nom d\'utilisateur public',
    'profile.note.emailImmutable': 'L\'adresse e-mail ne peut pas être modifiée dans le profil',
    'profile.note.passwordMin': 'Minimum 6 caractères',
    'profile.note.requiredForDashboard': 'Obligatoire pour accéder au tableau de bord',
    'profile.note.countryRequired': 'Obligatoire pour accéder au tableau de bord • Sélectionnez dans la liste ou saisissez pour rechercher',
    'profile.note.avatarRequired': 'Obligatoire pour accéder au tableau de bord • JPG, PNG ou GIF (max 20 Mo)',
    'profile.note.biographyRequiredPrefix': 'Obligatoire pour accéder au tableau de bord •',
    'profile.note.characters': 'personnages',
    'profile.optional': 'Facultatif',
    'profile.allOptional': 'Tout en option',
    'profile.uploading': 'Téléchargement...',
    'profile.uploadingAvatar': 'Téléchargement de l\'avatar...',
    'profile.chooseAvatarImage': 'Choisissez l\'image de l\'avatar',
    'profile.avatarPreviewAlt': 'Aperçu de l\'avatar',
    'profile.preview': 'APERÇU',
    'profile.openInNewTab': 'Ouvrir dans un nouvel onglet',
    'profile.view': 'Voir',
    'profile.stats.rating': 'Note',
    'profile.stats.credits': 'Crédits',
    'profile.stats.views': 'Vues',
    'profile.stats.votes': 'Votes',
    'profile.saving': 'Sauvegarde...',
    'profile.saveChanges': 'Enregistrer les modifications',
    'profile.success.profileAndPasswordUpdated': 'Profil et mot de passe mis à jour avec succès !',
    'profile.success.profileUpdatedComplete': 'Profil mis à jour avec succès ! Tous les champs obligatoires sont remplis. Vous pouvez désormais accéder au tableau de bord Xperiences.',
    'profile.success.profileUpdatedIncomplete': 'Profil mis à jour avec succès ! Veuillez remplir tous les champs obligatoires (Nom, Avatar, Biographie, Pays) pour accéder au tableau de bord.',
    'profile.error.loadProfile': 'Échec du chargement du profil',
    'profile.error.avatarUpload': 'Échec du téléchargement de l\'avatar. Profil NON enregistré.',
    'profile.error.fillAllPasswordFields': 'Veuillez remplir tous les champs de mot de passe pour modifier votre mot de passe',
    'profile.error.passwordsMismatch': 'Les nouveaux mots de passe ne correspondent pas',
    'profile.error.passwordMin': 'Le nouveau mot de passe doit contenir au moins 6 caractères',
    'profile.error.changePassword': 'Échec de la modification du mot de passe',
    'profile.error.profileUpdatedPasswordFailed': 'Profil mis à jour mais le changement de mot de passe a échoué',
    'profile.error.updateProfile': 'Échec de la mise à jour du profil. Veuillez réessayer.',
    'adminCreators.title': 'Gérer les créateurs',
    'adminCreators.loading': 'Chargement des créateurs...',
    'adminCreators.error.load': 'Échec du chargement des créateurs',
    'adminCreators.error.roleUpdate': 'Échec de la mise à jour du rôle',
    'adminCreators.error.statusUpdate': 'Échec de la mise à jour du statut',
    'adminCreators.error.trustUpdate': 'Échec de la mise à jour de l\'indicateur de confiance',
    'adminCreators.success.roleUpdated': 'Rôle mis à jour avec succès !',
    'adminCreators.success.statusUpdated': 'Statut mis à jour avec succès !',
    'adminCreators.success.trustUpdated': 'Indicateur de confiance mis à jour avec succès !',
    'adminCreators.table.alias': 'Alias',
    'adminCreators.table.email': 'Courriel',
    'adminCreators.table.emailVerified': 'E-mail vérifié',
    'adminCreators.table.hidden': 'Caché',
    'adminCreators.table.joinDate': 'Date d\'adhésion',
    'adminCreators.table.role': 'Rôle',
    'adminCreators.table.status': 'Statut',
    'adminCreators.table.trusted': 'Confiance',
    'adminCreators.yes': 'Oui',
    'adminCreators.no': 'Non',
    'adminCreators.hidden': 'Caché',
    'adminCreators.visible': 'Visible',
    'adminCreators.trusted': 'Confiance',
    'adminCreators.standard': 'Norme',
    'adminCreators.role.creator': 'Créateur',
    'adminCreators.role.manager': 'Gestionnaire',
    'adminCreators.role.administrator': 'Administrateur',
    'adminCreators.status.pending': 'En attente',
    'adminCreators.status.approved': 'Approuvé',
    'adminCreators.status.rejected': 'Interdit / Rejeté',
    'adminCreators.empty': 'Aucun créateur trouvé.',
    'adminCreators.pagination.page': 'Pages',
    'adminCreators.pagination.of': 'de',
    'adminCreators.pagination.total': 'Total',
    'adminCreators.pagination.rowsPerPage': 'Lignes par page',
    'adminCreators.pagination.previous': 'Précédent',
    'adminCreators.pagination.next': 'Suivant',
    'adminCreatorDetail.title': 'Modifier le créateur :',
    'adminCreatorDetail.back': 'Retour',
    'adminCreatorDetail.id': 'pièce d\'identité',
    'adminCreatorDetail.email': 'Courriel',
    'adminCreatorDetail.alias': 'Alias',
    'adminCreatorDetail.fullName': 'Nom complet',
    'adminCreatorDetail.phone': 'Téléphone',
    'adminCreatorDetail.countryCode': 'Indicatif du pays',
    'adminCreatorDetail.countryPlaceholder': 'Tapez pour rechercher des pays...',
    'adminCreatorDetail.flags': 'Indicateurs de profil',
    'adminCreatorDetail.emailVerified': 'E-mail vérifié',
    'adminCreatorDetail.resendEmail': 'Renvoyer l\'e-mail',
    'adminCreatorDetail.sending': 'Envoi...',
    'adminCreatorDetail.hideProfile': 'Masquer le profil (incomplet)',
    'adminCreatorDetail.isTrusted': 'Créateur de confiance',
    'adminCreatorDetail.bio': 'Biographie / Description',
    'adminCreatorDetail.linksApps': 'Liens et applications',
    'adminCreatorDetail.appName': 'Nom de l\'application',
    'adminCreatorDetail.appUrl': 'URL de l\'application',
    'adminCreatorDetail.youtubeUrl': 'URL YouTube',
    'adminCreatorDetail.instagramUrl': 'URL Instagram',
    'adminCreatorDetail.otherUrl': 'Autre URL',
    'adminCreatorDetail.saveProfile': 'Enregistrer le profil',
    'adminCreatorDetail.saving': 'Sauvegarde...',
    'adminCreatorDetail.error.load': 'Échec du chargement du créateur',
    'adminCreatorDetail.error.verificationSend': 'Échec de l\'envoi de l\'e-mail de vérification.',
    'adminCreatorDetail.error.update': 'Échec de la mise à jour du créateur',
    'adminCreatorDetail.success.verificationSent': 'E-mail de vérification envoyé avec succès.',
    'adminCreatorDetail.success.updated': 'Créateur mis à jour avec succès',
    'moderation.back': 'Retour',
    'moderation.title.single': 'Modération du contenu Xperience',
    'moderation.title.global': 'Modération du contenu',
    'moderation.searchPlaceholder': 'Recherchez par titre, description ou créateur...',
    'moderation.filter.allMedia': 'Tous les médias',
    'moderation.filter.pending': 'En attente',
    'moderation.filter.approved': 'Approuvé',
    'moderation.filter.rejected': 'Rejeté',
    'moderation.loading': 'Chargement du média...',
    'moderation.empty.search': 'Aucun média ne correspond à votre recherche.',
    'moderation.empty.filter': 'Aucun média trouvé pour le filtre sélectionné.',
    'moderation.noPoster': 'Aucune affiche',
    'moderation.untitled': 'Sans titre',
    'moderation.noDescription': 'Pas de description',
    'moderation.creator': 'Créateur',
    'moderation.email': 'Courriel',
    'moderation.date': 'Date',
    'moderation.na': 'N/D',
    'moderation.viewOriginal': 'Afficher le fichier d\'origine',
    'moderation.action.approve': 'Approuver',
    'moderation.action.reject': 'Rejeter',
    'moderation.action.setPending': 'Définir en attente',
    'moderation.success.markedAs': 'Média marqué avec succès comme',
    'moderation.error.loadMedia': 'Erreur lors du chargement du média pour modération.',
    'moderation.error.updateStatus': 'Échec de la mise à jour de l\'état du média.',
    'adminXperiences.backDashboard': 'Retour au tableau de bord',
    'adminXperiences.title': 'Modération des expériences mondiales',
    'adminXperiences.searchPlaceholder': 'Recherchez par titre, description ou créateur...',
    'adminXperiences.filter.all': 'Toutes les expériences',
    'adminXperiences.filter.pending': 'En attente',
    'adminXperiences.filter.approved': 'Approuvé',
    'adminXperiences.filter.rejected': 'Rejeté',
    'adminXperiences.loading': 'Chargement des expériences...',
    'adminXperiences.empty.search': 'Aucune expérience ne correspond à votre recherche.',
    'adminXperiences.empty.filter': 'Aucune expérience trouvée pour le filtre sélectionné.',
    'adminXperiences.noPoster': 'Aucune affiche',
    'adminXperiences.noDescription': 'Pas de description',
    'adminXperiences.creator': 'Créateur',
    'adminXperiences.email': 'Courriel',
    'adminXperiences.date': 'Date',
    'adminXperiences.na': 'N/D',
    'adminXperiences.mediaCount': 'Nombre de médias',
    'adminXperiences.items': 'articles',
    'adminXperiences.action.moderateMedia': 'Médias modérés',
    'adminXperiences.action.approveAll': 'Tout approuver',
    'adminXperiences.action.rejectAll': 'Tout rejeter',
    'adminXperiences.action.setPending': 'Définir en attente',
    'adminXperiences.success.markedAs': 'Expérience marquée avec succès comme',
    'adminXperiences.error.fetch': 'Échec de la récupération des expériences',
    'adminXperiences.error.updateStatus': 'Échec de la mise à jour du statut',
    'createXperience.profileIncomplete': 'Veuillez compléter votre profil avant de créer une expérience',
    'createXperience.error.create': 'Échec de la création de l\'expérience',
    'createXperience.title': 'Créez une nouvelle expérience',
    'createXperience.subtitle': 'Commencez à créer votre contenu immersif',
    'createXperience.field.title': 'Titre',
    'createXperience.placeholder.title': 'Titre de l\'expérience',
    'createXperience.field.description': 'Descriptif',
    'createXperience.placeholder.description': 'Décrivez votre expérience...',
    'createXperience.field.location': 'Emplacement',
    'createXperience.field.tags': 'Balises',
    'createXperience.copyLastLocation': 'Copier le dernier emplacement',
    'createXperience.error.noLastLocation': 'Aucun emplacement précédent n\'est encore disponible.',
    'createXperience.placeholder.tags': 'Sélectionnez ou recherchez des balises...',
    'createXperience.help.tags': 'Choisissez une ou plusieurs balises pour améliorer la découverte.',
    'createXperience.cancel': 'Annuler',
    'createXperience.submit': 'Créer une expérience',
    'xperienceDetail.success.mediaOrderSaved': 'L\'ordre des médias a été enregistré avec succès.',
    'xperienceDetail.error.mediaOrderSave': 'Échec de l\'enregistrement de l\'ordre des médias.',
    'xperienceDetail.error.load': 'Échec du chargement de l\'expérience',
    'xperienceDetail.success.updated': 'Xperience a été mis à jour avec succès.',
    'xperienceDetail.error.update': 'Échec de la mise à jour de l\'expérience',
    'xperienceDetail.sendingEmail': 'Envoi d\'e-mail...',
    'xperienceDetail.success.emailSent': 'E-mail d\'accès QR envoyé avec succès.',
    'xperienceDetail.success.locationCopiedToAll': 'Emplacement copié dans {count} éléments multimédias.',
    'xperienceDetail.error.sendEmail': 'Échec de l\'envoi de l\'e-mail QR.',
    'xperienceDetail.error.uploadMedia': 'Échec du téléchargement du média',
    'xperienceDetail.error.deleteMedia': 'Échec de la suppression du média',
    'xperienceDetail.error.deleteXperience': 'Échec de la suppression de l\'expérience',
    'xperienceDetail.error.noLocationToCopyAll': 'Définissez d’abord un emplacement avant de le copier sur tous les supports.',
    'xperienceDetail.error.invalidLocationToCopyAll': 'Les coordonnées de l\'emplacement actuel ne sont pas valides.',
    'xperienceDetail.error.noMediaToCopyLocationAll': 'Aucun élément multimédia trouvé à mettre à jour dans cette expérience.',
    'xperienceDetail.error.locationCopiedToAllPartial': 'Mise à jour des éléments multimédias {success}, mais {failed} a échoué.',
    'xperienceDetail.error.locationCopiedToAllFailed': 'Impossible de mettre à jour l\'emplacement de tous les médias.',
    'xperienceDetail.loading': 'Chargement de l\'expérience...',
    'xperienceDetail.notFound': 'Expérience introuvable',
    'xperienceDetail.backDashboard': 'Retour au tableau de bord',
    'xperienceDetail.editTitle': 'Modifier l\'expérience',
    'xperienceDetail.field.title': 'Titre',
    'xperienceDetail.field.description': 'Descriptif',
    'xperienceDetail.field.location': 'Emplacement',
    'xperienceDetail.field.tags': 'Balises',
    'xperienceDetail.copyLastLocation': 'Copier le dernier emplacement',
    'xperienceDetail.copyLocationToAll': 'Copier l\'emplacement sur tous les médias',
    'xperienceDetail.copyLocationToAllLoading': 'Copie sur tous les supports...',
    'xperienceDetail.error.noLastLocation': 'Aucun emplacement précédent n\'est encore disponible.',
    'xperienceDetail.success.lastLocationCopied': 'Dernier emplacement copié.',
    'xperienceDetail.placeholder.tags': 'Sélectionnez ou recherchez des balises...',
    'xperienceDetail.help.tags': 'Choisissez une ou plusieurs balises pour améliorer la découverte.',
    'xperienceDetail.privateToggle': 'Expérience privée (nécessite un mot de passe)',
    'xperienceDetail.cancel': 'Annuler',
    'xperienceDetail.saveChanges': 'Enregistrer les modifications',
    'xperienceDetail.edit': 'Modifier',
    'xperienceDetail.deleteXperience': 'Supprimer l\'expérience',
    'xperienceDetail.info.status': 'Statut',
    'xperienceDetail.pending': 'En attente',
    'xperienceDetail.info.views': 'Vues',
    'xperienceDetail.info.rating': 'Note',
    'xperienceDetail.info.reactions': 'Réactions',
    'xperienceDetail.info.tags': 'Balises',
    'xperienceDetail.info.category': 'Catégorie',
    'xperienceDetail.info.created': 'Créé',
    'xperienceDetail.noDate': 'N/D',
    'xperienceDetail.info.mediaCount': 'Nombre de médias',
    'xperienceDetail.info.visibility': 'Visibilité',
    'xperienceDetail.visibility.private': 'Privé',
    'xperienceDetail.visibility.public': 'Publique',
    'xperienceDetail.privateQR.title': 'QR d\'accès privé',
    'xperienceDetail.privateQR.description': 'Partagez ce QR ou ce mot de passe pour accorder un accès privé à votre expérience.',
    'xperienceDetail.privateQR.alt': 'Code QR d\'accès privé',
    'xperienceDetail.success.passwordCopied': 'Mot de passe copié dans le presse-papiers.',
    'xperienceDetail.copyPassword': 'Copier le mot de passe',
    'xperienceDetail.wait': 'Attends',
    'xperienceDetail.emailQR': 'Envoyer un code QR par e-mail',
    'xperienceDetail.mediaSectionTitle': 'Xpérience Média',
    'xperienceDetail.createMedia': '+ Créer un média',
    'xperienceDetail.uploading': 'Téléchargement',
    'xperienceDetail.noMedia': 'Aucun média ajouté pour l\'instant.',
    'xperienceDetail.noMediaHelp': 'Aucun fichier multimédia pour l\'instant. Téléchargez des images, des vidéos ou de l\'audio.',
    'xperienceDetail.mediaCard.added': 'Ajouté',
    'xperienceDetail.mediaCard.na': 'N/D',
    'xperienceDetail.mediaCard.viewDetails': 'Afficher les détails',
    'xperienceDetail.confirm.deleteMediaTitle': 'Supprimer le média ?',
    'xperienceDetail.confirm.deleteMediaMessage': 'Cet élément multimédia sera définitivement supprimé. Cette action ne peut pas être annulée.',
    'xperienceDetail.confirm.deleteXperienceTitle': 'Supprimer l\'expérience ?',
    'xperienceDetail.confirm.deleteXperienceMessage': 'Cette expérience et tous les médias associés seront définitivement supprimés. Cette action ne peut pas être annulée.',
    'xperienceDetail.confirm.delete': 'Supprimer',
    'xperienceDetail.confirm.cancel': 'Annuler',
    'xperienceDetail.confirm.copyLocationAllTitle': 'Copier l\'emplacement sur tous les médias ?',
    'xperienceDetail.confirm.copyLocationAllMessage': 'Cela mettra à jour les coordonnées de localisation de tous les médias de cette expérience. Continuer?',
    'xperienceDetail.confirm.copyLocationAllConfirm': 'Oui, mettre à jour tous les médias',
    'xperienceDetail.confirm.copyLocationAllCancel': 'Annuler',
    'xmedia.error.loadData': 'Échec du chargement des données',
    'xmedia.error.delete': 'Échec de la suppression du média',
    'xmedia.error.save': 'Échec de l\'enregistrement du support xperience',
    'xmedia.error.noXperienceLocation': 'L\'expérience parent n\'a pas encore d\'emplacement à copier.',
    'xmedia.error.noLastLocation': 'Aucun emplacement précédent n\'est encore disponible.',
    'xmedia.error.requiredPrefix': 'Les champs suivants sont obligatoires :',
    'xmedia.success.posterSelected': 'Affiche sélectionnée localement. Il sera téléchargé lors de la sauvegarde.',
    'xmedia.success.mediaSelected': 'Médias sélectionnés localement. Il sera téléchargé lors de la sauvegarde.',
    'xmedia.success.deleted': 'Média supprimé avec succès !',
    'xmedia.success.created': 'Médias Xperience créés et fichiers téléchargés avec succès !',
    'xmedia.success.updated': 'Média Xperience mis à jour avec succès !',
    'xmedia.success.locationCopied': 'Emplacement copié de xperience.',
    'xmedia.success.lastLocationCopied': 'Dernier emplacement copié.',
    'xmedia.confirm.deleteMessage': 'Êtes-vous sûr de vouloir supprimer définitivement cet élément multimédia et ses fichiers associés ? Cette action ne peut pas être annulée.',
    'xmedia.loading': 'Chargement du média xperience...',
    'xmedia.notFound': 'Média Xperience introuvable',
    'xmedia.back': 'Retour',
    'xmedia.title.create': 'Créer un nouveau média',
    'xmedia.title.edit': 'Modifier le média Xperience',
    'xmedia.subtitle': 'Mettez à jour toutes les métadonnées et tous les fichiers de cet élément multimédia.',
    'xmedia.field.title': 'Titre',
    'xmedia.field.description': 'Descriptif',
    'xmedia.field.type': 'Tapez',
    'xmedia.field.format': 'Formater',
    'xmedia.field.category': 'Catégorie',
    'xmedia.field.mediaFile': 'Fichier multimédia',
    'xmedia.field.posterUrl': 'URL de l\'affiche',
    'xmedia.field.order': 'Commande',
    'xmedia.field.runtime': 'Durée d\'exécution',
    'xmedia.field.credits': 'Crédits / Points requis',
    'xmedia.field.location': 'Emplacement',
    'xmedia.field.createdDate': 'Date de création',
    'xmedia.placeholder.title': 'Entrez un titre',
    'xmedia.placeholder.description': 'Entrez la description...',
    'xmedia.placeholder.mediaUrl': 'L\'URL sera générée en toute sécurité lors de la sauvegarde',
    'xmedia.placeholder.posterUrl': 'Le chemin de l\'affiche sera généré lors de l\'enregistrement',
    'xmedia.placeholder.order': 'par exemple, 1',
    'xmedia.placeholder.runtime': 'par exemple, 3600',
    'xmedia.placeholder.credits': 'par exemple, 0',
    'xmedia.selectFile': 'Sélectionnez un fichier',
    'xmedia.changeFile': 'Changer de fichier',
    'xmedia.viewMedia': 'Afficher les médias',
    'xmedia.selectImage': 'Sélectionnez une image',
    'xmedia.changeImage': 'Changer l\'image',
    'xmedia.thumbnail': 'Image miniature',
    'xmedia.seconds': 'secondes',
    'xmedia.requiresDownload': 'Nécessite un téléchargement',
    'xmedia.isPublic': 'est public',
    'xmedia.isPremium': 'Est Premium',
    'xmedia.hide': 'Masquer',
    'xmedia.deleteMedia': 'Supprimer le média',
    'xmedia.cancel': 'Annuler',
    'xmedia.saving': 'Sauvegarde...',
    'xmedia.saveChanges': 'Enregistrer les modifications',
    'xmedia.copyXperienceLocation': 'Copier l\'emplacement de l\'expérience',
    'xmedia.copyLastLocation': 'Copier le dernier emplacement',
    'xmedia.copyLocationToAll': 'Copier l\'emplacement sur tous les médias',
    'xmedia.copyLocationToAllLoading': 'Copie sur tous les supports...',
    'xmedia.locationSource.xperience': 'Utilisation de l\'emplacement principal xperience',
    'xmedia.locationSource.last': 'Utilisation du dernier emplacement copié',
    'xmedia.lastLocationPreview': 'Dernier emplacement enregistré',
    'xmedia.confirm.copyLocationAllTitle': 'Copier l\'emplacement sur tous les médias ?',
    'xmedia.confirm.copyLocationAllMessage': 'Cela mettra à jour les coordonnées de localisation de tous les médias de cette expérience. Continuer?',
    'xmedia.confirm.copyLocationAllConfirm': 'Oui, mettre à jour tous les médias',
    'xmedia.confirm.copyLocationAllCancel': 'Annuler',
    'xmedia.success.locationCopiedToAll': 'Emplacement copié dans {count} éléments multimédias.',
    'xmedia.error.noXperienceForBulkLocation': 'Impossible de trouver l\'expérience parent pour la mise à jour groupée de l\'emplacement.',
    'xmedia.error.noLocationToCopyAll': 'Définissez d’abord un emplacement avant de le copier sur tous les supports.',
    'xmedia.error.invalidLocationToCopyAll': 'Les coordonnées de l\'emplacement actuel ne sont pas valides.',
    'xmedia.error.noMediaToCopyLocationAll': 'Aucun élément multimédia trouvé à mettre à jour dans cette expérience.',
    'xmedia.error.locationCopiedToAllPartial': 'Mise à jour des éléments multimédias {success}, mais {failed} a échoué.',
    'xmedia.error.locationCopiedToAllFailed': 'Impossible de mettre à jour l\'emplacement de tous les médias.',
    'locationPicker.searchLabel': 'Rechercher une adresse',
    'locationPicker.searchPlaceholder': 'Saisissez une adresse, une ville ou un lieu',
    'locationPicker.longitude': 'Longitude',
    'locationPicker.latitude': 'Latitude',
    'locationPicker.clear': 'Emplacement clair',
    'locationPicker.useCurrent': 'Utiliser ma position actuelle',
    'locationPicker.locating': 'Localisation...',
    'locationPicker.geoNotSupported': 'Votre navigateur ne prend pas en charge la géolocalisation.',
    'locationPicker.geoError': 'Impossible d\'obtenir votre position actuelle. Vérifiez les autorisations du navigateur.',
    'locationPicker.selectedAddress': 'Adresse sélectionnée',
    'locationPicker.loadingMap': 'Chargement de la carte...',
    'locationPicker.noApiKey': 'La clé API Google Maps est manquante',
    'locationPicker.noApiKeyHelp': 'Définissez REACT_APP_GOOGLE_MAPS_API_KEY dans l\'environnement frontend pour activer la recherche de carte et d\'adresse.',
    'locationPicker.loadError': 'Impossible de charger Google Maps',
  },
  'de': {
    'common.loading': 'Laden...',
    'common.email': 'E-Mail',
    'common.password': 'Passwort',
    'common.confirmPassword': 'Passwort bestätigen',
    'common.backToLogin': 'Zurück zu Anmelden',
    'common.signIn': 'Melden Sie sich an',
    'common.emailExample': 'Creator@example.com',
    'common.clearSearch': 'Suche löschen',
    'login.title': 'Willkommen zurück',
    'login.subtitle': 'Melden Sie sich bei Ihrem Erstellerkonto an',
    'login.passwordPlaceholder': 'Geben Sie Ihr Passwort ein',
    'login.forgotPassword': 'Passwort vergessen?',
    'login.submit': 'Anmelden',
    'login.createOne': 'Erstellen Sie eins',
    'login.error.verifyEmail': 'Bitte überprüfen Sie Ihre E-Mail-Adresse, bevor Sie sich anmelden. Überprüfen Sie Ihren Posteingang auf den Bestätigungslink.',
    'login.error.invalidCredentials': 'Ungültige E-Mail-Adresse oder ungültiges Passwort.',
    'login.resend.button': 'Bestätigungs-E-Mail erneut senden',
    'login.resend.success': 'Wenn Ihr Konto existiert und nicht verifiziert ist, wurde eine neue Bestätigungs-E-Mail gesendet.',
    'login.resend.error': 'Das erneute Senden der Bestätigungs-E-Mail ist fehlgeschlagen. Bitte versuchen Sie es in Kürze noch einmal.',
    'login.resend.wait': 'Bitte warten Sie einen Moment, bevor Sie eine weitere Bestätigungs-E-Mail anfordern.',
    'login.resend.waitWithSeconds': 'Erneut senden verfügbar in',
    'register.title': 'Erstellen Sie Ihr Konto',
    'register.titleSuccess': 'Überprüfen Sie Ihre E-Mails',
    'register.subtitle': 'Treten Sie der X-periences-Ersteller-Community bei',
    'register.subtitleSuccess': 'Wir haben Ihnen einen Bestätigungslink gesendet',
    'register.alias': 'Alias',
    'register.aliasPlaceholder': 'Dein Ersteller-Alias',
    'register.passwordPlaceholder': 'Mindestens 6 Zeichen',
    'register.confirmPasswordPlaceholder': 'Bestätigen Sie Ihr Passwort',
    'register.acceptPrefix': 'Ich habe die gelesen und akzeptiere sie',
    'register.terms': 'Nutzungsbedingungen',
    'register.and': 'und',
    'register.privacy': 'Datenschutzrichtlinie',
    'register.acceptSuffix': '.',
    'register.submit': 'Konto erstellen',
    'register.successCreated': 'Konto erfolgreich erstellt!',
    'register.successCheckInbox': 'Bitte überprüfen Sie Ihren Posteingang (und Spam-Ordner) und klicken Sie auf den Bestätigungslink, um Ihr Konto zu aktivieren.',
    'register.successEmailIssue': 'Ihr Konto wurde erstellt, aber der Versand einer Bestätigungs-E-Mail ist vorübergehend nicht möglich. Benutzen Sie gleich die Schaltfläche „Bestätigung erneut senden“ aus der Anmeldung.',
    'register.successBackToLogin': 'Zurück zum Anmelden',
    'register.haveAccount': 'Sie haben bereits ein Konto?',
    'register.signIn': 'Melden Sie sich an',
    'register.error.passwordsMismatch': 'Passwörter stimmen nicht überein',
    'register.error.passwordMin': 'Das Passwort muss mindestens 6 Zeichen lang sein',
    'register.error.acceptTerms': 'Sie müssen die Nutzungsbedingungen und Datenschutzbestimmungen lesen und akzeptieren',
    'register.error.generic': 'Die Registrierung ist fehlgeschlagen',
    'forgot.title': 'Passwort zurücksetzen',
    'forgot.subtitle': 'Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen zu erhalten',
    'forgot.submit': 'Link zum Zurücksetzen senden',
    'forgot.success': 'Suchen Sie in Ihren E-Mails nach einem Link zum Zurücksetzen des Passworts.',
    'forgot.devMode': 'Entwicklungsmodus:',
    'forgot.devGoReset': 'Gehen Sie zu Passwort zurücksetzen',
    'forgot.remember': 'Erinnern Sie sich an Ihr Passwort?',
    'forgot.error.generic': 'E-Mail zum Zurücksetzen konnte nicht gesendet werden',
    'reset.title': 'Passwort zurücksetzen',
    'reset.subtitle': 'Geben Sie Ihr neues Passwort ein',
    'reset.newPassword': 'Neues Passwort',
    'reset.confirmPassword': 'Passwort bestätigen',
    'reset.confirmPlaceholder': 'Bestätigen Sie Ihr neues Passwort',
    'reset.submit': 'Passwort zurücksetzen',
    'reset.success': 'Passwort erfolgreich zurückgesetzt! Weiterleitung zum Login...',
    'reset.error.invalidLink': 'Ungültiger Link zum Zurücksetzen',
    'reset.error.passwordsMismatch': 'Passwörter stimmen nicht überein',
    'reset.error.passwordMin': 'Das Passwort muss mindestens 6 Zeichen lang sein',
    'reset.error.invalidToken': 'Ungültiges Reset-Token',
    'reset.error.generic': 'Passwort konnte nicht zurückgesetzt werden',
    'verify.title': 'E-Mail-Verifizierung',
    'verify.loading': 'Ihre E-Mail-Adresse wird überprüft...',
    'verify.successLine1': 'Ihre E-Mail-Adresse wurde erfolgreich bestätigt!',
    'verify.successLine2': 'Sie können sich jetzt bei Ihrem Konto anmelden.',
    'verify.redirecting': 'Weiterleitung zum Login...',
    'verify.alreadyLine1': 'Ihre E-Mail-Adresse wurde bereits bestätigt!',
    'verify.alreadyLine2': 'Sie können sich bei Ihrem Konto anmelden.',
    'verify.goLogin': 'Gehen Sie zu Anmelden',
    'verify.error.noToken': 'Kein Verifizierungstoken bereitgestellt',
    'verify.error.generic': 'Die Überprüfung ist fehlgeschlagen',
    'navbar.subtitle': 'Erstellerportal',
    'navbar.dashboard': 'Armaturenbrett',
    'navbar.modXperiences': 'Mod. Erfahrungen',
    'navbar.manageCreators': 'Ersteller verwalten',
    'navbar.newXperience': 'Neue Erfahrung',
    'navbar.generateCreators': 'Ersteller generieren',
    'navbar.generateXperiences': 'Erfahrungen generieren',
    'navbar.generate': 'Generieren',
    'navbar.generating': 'Generieren',
    'navbar.profile': 'Profil',
    'navbar.logout': 'Abmelden',
    'navbar.confirmGenerateCreators': 'Sind Sie sicher, dass Sie JSON für Ersteller generieren möchten?',
    'navbar.confirmGenerateXperiences': 'Sind Sie sicher, dass Sie Xperiences JSON generieren möchten?',
    'navbar.successGenerateCreators': 'Creators erfolgreich generiert!',
    'navbar.successGenerateXperiences': 'Erfahrungen erfolgreich generiert!',
    'navbar.error.endpoint': 'Endpunkt nicht gefunden. Der API-Dienst muss möglicherweise neu gestartet werden.',
    'navbar.error.noBody': 'Kein Antworttext',
    'navbar.error.generateCreators': 'Ersteller konnten nicht generiert werden',
    'navbar.error.generateXperiences': 'Erfahrungen konnten nicht generiert werden',
    'navbar.roleDefault': 'Schöpfer',
    'navbar.statusPending': 'Ausstehend',
    'navbar.statusTitle': 'Status',
    'navbar.totalViews': 'Gesamtansichten',
    'navbar.avgRating': 'Durchschnittliche Bewertung',
    'navbar.roleTitle': 'Rolle',
    'navbar.languageLabel': 'Sprache',
    'navbar.lang.en': 'Englisch',
    'navbar.lang.es': 'Spanisch',
    'locale.en': 'Englisch',
    'locale.zhHk': 'Chinesisch (Hongkong)',
    'locale.zhHans': 'Chinesisch, vereinfacht',
    'locale.zhHant': 'Chinesisch, traditionell',
    'locale.enAu': 'Englisch (Australien)',
    'locale.enGb': 'Englisch (Vereinigtes Königreich)',
    'locale.fr': 'Französisch',
    'locale.frCa': 'Französisch (Kanada)',
    'locale.de': 'Deutsch',
    'locale.ja': 'Japanisch',
    'locale.es': 'Spanisch',
    'home.profileIncomplete': 'Bitte vervollständigen Sie Ihr Profil, bevor Sie xperiences verwalten',
    'home.error.load': 'Erfahrungen konnten nicht geladen werden',
    'home.title': 'Ihre Erfahrungen',
    'home.subtitle': 'Verwalten Sie Ihre immersiven Inhalte für Apple Vision Pro',
    'home.newXperience': '+ Neue Erfahrung',
    'home.searchPlaceholder': 'Nach Titel oder Beschreibung suchen...',
    'home.clearSearch': 'Suche löschen',
    'home.allMediaTypes': 'Alle Medientypen',
    'home.loading': 'Lade Erfahrungen...',
    'home.emptyTitle': 'Noch keine Erfahrungen',
    'home.emptyText': 'Erstellen Sie Ihr erstes immersives Erlebnis für Apple Vision Pro',
    'home.createFirst': 'Schaffen Sie erste Erfahrungen',
    'home.noResultsTitle': 'Keine Ergebnisse gefunden',
    'home.noResultsText': 'Versuchen Sie, Ihre Suchkriterien oder Filter anzupassen',
    'home.clearFilters': 'Filter löschen',
    'home.privateTitle': 'Private Erfahrung',
    'home.categoryTitle': 'Kategorie',
    'home.viewsTitle': 'Ansichten',
    'home.likesTitle': 'Gefällt mir',
    'home.dislikesTitle': 'Abneigungen',
    'home.ratingTitle': 'Bewertung',
    'home.viewDetails': 'Details anzeigen',
    'home.moreTags': 'weitere Tags',
    'home.files': 'Datei',
    'home.filesPlural': 'Dateien',
    'beCreator.title': 'Seien Sie ein Schöpfer von X-periences',
    'beCreator.subtitle': 'Teilen Sie immersive Erlebnisse für Apple Vision Pro',
    'beCreator.point1': 'Veröffentlichen Sie Ihre eigenen Erfahrungen und bauen Sie Ihr Publikum auf.',
    'beCreator.point2': 'Verfolgen Sie Aufrufe, Likes und Bewertungen über Ihr Dashboard.',
    'beCreator.point3': 'Verwalten Sie Medien und Updates über ein einziges Erstellerportal.',
    'beCreator.ctaPrimary': 'Erstellen Sie ein Erstellerkonto',
    'beCreator.ctaSecondary': 'Ich habe bereits ein Konto',
    'beCreator.heroTitle': 'Werde ein Schöpfer',
    'beCreator.heroSubtitle': 'Teilen Sie Ihre einzigartigen X-Erlebnisse mit der Welt und lassen Sie Ihre Leidenschaft Wirklichkeit werden.',
    'beCreator.heroCta': 'Treten Sie als Schöpfer bei',
    'beCreator.benefitsTitle': 'Warum X-periences beitreten?',
    'beCreator.benefit.audienceTitle': 'Erreichen Sie ein globales Publikum',
    'beCreator.benefit.audienceText': 'Vernetzen Sie sich mit Benutzern auf der ganzen Welt, die Ihre einzigartigen Inhalte und X-Erlebnisse entdecken und mit ihnen interagieren möchten.',
    'beCreator.benefit.recognitionTitle': 'Verdienen Sie Anerkennung',
    'beCreator.benefit.recognitionText': 'Bauen Sie Ihren Ruf als YouTuber auf, indem Sie fesselnde Geschichten teilen, die Benutzer auf der ganzen Welt inspirieren.',
    'beCreator.benefit.toolsTitle': 'Leistungsstarke Creator-Tools',
    'beCreator.benefit.toolsText': 'Greifen Sie auf erweiterte Analysen, nahtloses Medienmanagement und benutzerfreundliche, auf YouTuber zugeschnittene Veröffentlichungstools zu.',
    'beCreator.benefit.communityTitle': 'Unterstützende Gemeinschaft',
    'beCreator.benefit.communityText': 'Treten Sie einem Netzwerk leidenschaftlicher Schöpfer bei. Teilen Sie Ideen, arbeiten Sie zusammen und wachsen Sie gemeinsam in einer sicheren Umgebung.',
    'beCreator.howItWorksTitle': 'Wie es funktioniert',
    'beCreator.step.signupTitle': 'Melden Sie sich an',
    'beCreator.step.signupText': 'Erstellen Sie mit nur wenigen Klicks Ihr Erstellerprofil.',
    'beCreator.step.createTitle': 'Erstellen',
    'beCreator.step.createText': 'Laden Sie Ihre Inhalte hoch und bauen Sie Ihre fesselnden X-Erlebnisse auf.',
    'beCreator.step.recognizedTitle': 'Werden Sie anerkannt',
    'beCreator.step.recognizedText': 'Teilen Sie Ihre Erfahrungen weltweit, vergrößern Sie Ihr Publikum und werden Sie zum Referenzersteller für immersive Inhalte.',
    'beCreator.footerTitle': 'Sind Sie bereit, Ihre Reise zu beginnen?',
    'beCreator.footerText': 'Machen Sie den ersten Schritt, um immersive Erfahrungen mit der Welt zu teilen.',
    'beCreator.footerCta': 'Legen Sie jetzt los',
    'profile.loading': 'Profil wird geladen...',
    'profile.title': 'Erstellerprofil',
    'profile.subtitle': 'Verwalten Sie Ihre Erstellerinformationen',
    'profile.requiredFieldsLabel': 'Erforderliche Felder*:',
    'profile.requiredFieldsText': 'Für den Zugriff auf das Xperiences-Dashboard sind der vollständige Name, der Avatar, die Biografie und das Land erforderlich.',
    'profile.section.accountInfo': 'Kontoinformationen',
    'profile.section.changePassword': 'Passwort ändern',
    'profile.section.personalInfo': 'Persönliche Informationen',
    'profile.section.appSocial': 'App und soziale Medien',
    'profile.section.creatorStats': 'Erstellerstatistiken',
    'profile.field.usernameAlias': 'Benutzername (Alias)',
    'profile.field.currentPassword': 'Aktuelles Passwort',
    'profile.field.newPassword': 'Neues Passwort',
    'profile.field.confirmNewPassword': 'Bestätigen Sie das neue Passwort',
    'profile.field.fullNameRequired': 'Vollständiger Name *',
    'profile.field.phone': 'Telefon',
    'profile.field.countryRequired': 'Land *',
    'profile.field.avatarRequired': 'Avatar *',
    'profile.field.biographyRequired': 'Biografie *',
    'profile.field.appName': 'App-Name',
    'profile.field.appUrl': 'App-URL',
    'profile.field.youtubeUrl': 'YouTube-URL',
    'profile.field.instagramUrl': 'Instagram-URL',
    'profile.field.otherUrl': 'Andere URL',
    'profile.placeholder.username': 'Ihr Benutzername',
    'profile.placeholder.currentPassword': 'Geben Sie Ihr aktuelles Passwort ein',
    'profile.placeholder.newPassword': 'Geben Sie ein neues Passwort ein',
    'profile.placeholder.confirmNewPassword': 'Bestätigen Sie das neue Passwort',
    'profile.placeholder.fullName': 'Ihr vollständiger Name',
    'profile.placeholder.phone': '+1 (555) 000-0000',
    'profile.placeholder.searchCountries': 'Geben Sie ein, um nach Ländern zu suchen...',
    'profile.placeholder.biography': 'Erzählen Sie uns etwas über sich...',
    'profile.placeholder.appName': 'z. B. „Meine App“.',
    'profile.placeholder.appUrl': 'https://myapp.com',
    'profile.placeholder.youtubeUrl': 'https://youtube.com/@IhrBenutzername',
    'profile.placeholder.instagramUrl': 'https://instagram.com/IhrBenutzername',
    'profile.placeholder.otherUrl': 'https://example.com',
    'profile.note.publicUsername': 'Ihr öffentlicher Benutzername',
    'profile.note.emailImmutable': 'Die E-Mail-Adresse kann im Profil nicht geändert werden',
    'profile.note.passwordMin': 'Mindestens 6 Zeichen',
    'profile.note.requiredForDashboard': 'Erforderlich für den Zugriff auf das Dashboard',
    'profile.note.countryRequired': 'Erforderlich für den Zugriff auf das Dashboard. • Wählen Sie aus der Liste aus oder geben Sie den Suchtyp ein',
    'profile.note.avatarRequired': 'Erforderlich für den Zugriff auf das Dashboard • JPG, PNG oder GIF (max. 20 MB)',
    'profile.note.biographyRequiredPrefix': 'Erforderlich für den Zugriff auf das Dashboard •',
    'profile.note.characters': 'Charaktere',
    'profile.optional': 'Optional',
    'profile.allOptional': 'Alles optional',
    'profile.uploading': 'Hochladen...',
    'profile.uploadingAvatar': 'Avatar wird hochgeladen...',
    'profile.chooseAvatarImage': 'Wählen Sie Avatar-Bild',
    'profile.avatarPreviewAlt': 'Avatar-Vorschau',
    'profile.preview': 'VORSCHAU',
    'profile.openInNewTab': 'In neuem Tab öffnen',
    'profile.view': 'Ansicht',
    'profile.stats.rating': 'Bewertung',
    'profile.stats.credits': 'Credits',
    'profile.stats.views': 'Ansichten',
    'profile.stats.votes': 'Stimmen',
    'profile.saving': 'Sparen...',
    'profile.saveChanges': 'Änderungen speichern',
    'profile.success.profileAndPasswordUpdated': 'Profil und Passwort erfolgreich aktualisiert!',
    'profile.success.profileUpdatedComplete': 'Profil erfolgreich aktualisiert! Alle erforderlichen Felder sind vollständig. Sie können jetzt auf das Xperiences-Dashboard zugreifen.',
    'profile.success.profileUpdatedIncomplete': 'Profil erfolgreich aktualisiert! Bitte füllen Sie alle erforderlichen Felder (Name, Avatar, Biografie, Land) aus, um auf das Dashboard zuzugreifen.',
    'profile.error.loadProfile': 'Profil konnte nicht geladen werden',
    'profile.error.avatarUpload': 'Avatar konnte nicht hochgeladen werden. Profil NICHT gespeichert.',
    'profile.error.fillAllPasswordFields': 'Bitte füllen Sie alle Passwortfelder aus, um Ihr Passwort zu ändern',
    'profile.error.passwordsMismatch': 'Neue Passwörter stimmen nicht überein',
    'profile.error.passwordMin': 'Das neue Passwort muss mindestens 6 Zeichen lang sein',
    'profile.error.changePassword': 'Das Passwort konnte nicht geändert werden',
    'profile.error.profileUpdatedPasswordFailed': 'Profil aktualisiert, aber die Passwortänderung ist fehlgeschlagen',
    'profile.error.updateProfile': 'Profil konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
    'adminCreators.title': 'Ersteller verwalten',
    'adminCreators.loading': 'Ersteller werden geladen...',
    'adminCreators.error.load': 'Die Ersteller konnten nicht geladen werden',
    'adminCreators.error.roleUpdate': 'Die Rolle konnte nicht aktualisiert werden',
    'adminCreators.error.statusUpdate': 'Status konnte nicht aktualisiert werden',
    'adminCreators.error.trustUpdate': 'Das Vertrauensflag konnte nicht aktualisiert werden',
    'adminCreators.success.roleUpdated': 'Rolle erfolgreich aktualisiert!',
    'adminCreators.success.statusUpdated': 'Status erfolgreich aktualisiert!',
    'adminCreators.success.trustUpdated': 'Vertrauensflagge erfolgreich aktualisiert!',
    'adminCreators.table.alias': 'Alias',
    'adminCreators.table.email': 'E-Mail',
    'adminCreators.table.emailVerified': 'E-Mail bestätigt',
    'adminCreators.table.hidden': 'Versteckt',
    'adminCreators.table.joinDate': 'Beitrittsdatum',
    'adminCreators.table.role': 'Rolle',
    'adminCreators.table.status': 'Status',
    'adminCreators.table.trusted': 'Vertrauenswürdig',
    'adminCreators.yes': 'Ja',
    'adminCreators.no': 'Nein',
    'adminCreators.hidden': 'Versteckt',
    'adminCreators.visible': 'Sichtbar',
    'adminCreators.trusted': 'Vertrauenswürdig',
    'adminCreators.standard': 'Standard',
    'adminCreators.role.creator': 'Schöpfer',
    'adminCreators.role.manager': 'Manager',
    'adminCreators.role.administrator': 'Administrator',
    'adminCreators.status.pending': 'Ausstehend',
    'adminCreators.status.approved': 'Genehmigt',
    'adminCreators.status.rejected': 'Gesperrt/Abgelehnt',
    'adminCreators.empty': 'Keine Ersteller gefunden.',
    'adminCreators.pagination.page': 'Seite',
    'adminCreators.pagination.of': 'von',
    'adminCreators.pagination.total': 'Insgesamt',
    'adminCreators.pagination.rowsPerPage': 'Zeilen pro Seite',
    'adminCreators.pagination.previous': 'Zurück',
    'adminCreators.pagination.next': 'Als nächstes',
    'adminCreatorDetail.title': 'Ersteller bearbeiten:',
    'adminCreatorDetail.back': 'Zurück',
    'adminCreatorDetail.id': 'Ausweis',
    'adminCreatorDetail.email': 'E-Mail',
    'adminCreatorDetail.alias': 'Alias',
    'adminCreatorDetail.fullName': 'Vollständiger Name',
    'adminCreatorDetail.phone': 'Telefon',
    'adminCreatorDetail.countryCode': 'Ländercode',
    'adminCreatorDetail.countryPlaceholder': 'Geben Sie ein, um nach Ländern zu suchen...',
    'adminCreatorDetail.flags': 'Profilflaggen',
    'adminCreatorDetail.emailVerified': 'E-Mail bestätigt',
    'adminCreatorDetail.resendEmail': 'E-Mail erneut senden',
    'adminCreatorDetail.sending': 'Senden...',
    'adminCreatorDetail.hideProfile': 'Profil ausblenden (unvollständig)',
    'adminCreatorDetail.isTrusted': 'Vertrauenswürdiger Schöpfer',
    'adminCreatorDetail.bio': 'Bio / Beschreibung',
    'adminCreatorDetail.linksApps': 'Links und Apps',
    'adminCreatorDetail.appName': 'App-Name',
    'adminCreatorDetail.appUrl': 'App-URL',
    'adminCreatorDetail.youtubeUrl': 'YouTube-URL',
    'adminCreatorDetail.instagramUrl': 'Instagram-URL',
    'adminCreatorDetail.otherUrl': 'Andere URL',
    'adminCreatorDetail.saveProfile': 'Profil speichern',
    'adminCreatorDetail.saving': 'Sparen...',
    'adminCreatorDetail.error.load': 'Der Ersteller konnte nicht geladen werden',
    'adminCreatorDetail.error.verificationSend': 'Bestätigungs-E-Mail konnte nicht gesendet werden.',
    'adminCreatorDetail.error.update': 'Der Ersteller konnte nicht aktualisiert werden',
    'adminCreatorDetail.success.verificationSent': 'Bestätigungs-E-Mail erfolgreich gesendet.',
    'adminCreatorDetail.success.updated': 'Der Ersteller wurde erfolgreich aktualisiert',
    'moderation.back': 'Zurück',
    'moderation.title.single': 'Moderation von Xperience-Inhalten',
    'moderation.title.global': 'Inhaltsmoderation',
    'moderation.searchPlaceholder': 'Suche nach Titel, Beschreibung oder Ersteller...',
    'moderation.filter.allMedia': 'Alle Medien',
    'moderation.filter.pending': 'Ausstehend',
    'moderation.filter.approved': 'Genehmigt',
    'moderation.filter.rejected': 'Abgelehnt',
    'moderation.loading': 'Medien werden geladen...',
    'moderation.empty.search': 'Zu Ihrer Suche passen keine Medien.',
    'moderation.empty.filter': 'Für den ausgewählten Filter wurden keine Medien gefunden.',
    'moderation.noPoster': 'Kein Poster',
    'moderation.untitled': 'Ohne Titel',
    'moderation.noDescription': 'Keine Beschreibung',
    'moderation.creator': 'Schöpfer',
    'moderation.email': 'E-Mail',
    'moderation.date': 'Datum',
    'moderation.na': 'N/A',
    'moderation.viewOriginal': 'Originaldatei anzeigen',
    'moderation.action.approve': 'Genehmigen',
    'moderation.action.reject': 'Ablehnen',
    'moderation.action.setPending': 'Als ausstehend festlegen',
    'moderation.success.markedAs': 'Medien erfolgreich markiert als',
    'moderation.error.loadMedia': 'Fehler beim Laden der Medien zur Moderation.',
    'moderation.error.updateStatus': 'Der Medienstatus konnte nicht aktualisiert werden.',
    'adminXperiences.backDashboard': 'Zurück zum Dashboard',
    'adminXperiences.title': 'Global Xperiences Moderation',
    'adminXperiences.searchPlaceholder': 'Suche nach Titel, Beschreibung oder Ersteller...',
    'adminXperiences.filter.all': 'Alle Erfahrungen',
    'adminXperiences.filter.pending': 'Ausstehend',
    'adminXperiences.filter.approved': 'Genehmigt',
    'adminXperiences.filter.rejected': 'Abgelehnt',
    'adminXperiences.loading': 'Lade Erfahrungen...',
    'adminXperiences.empty.search': 'Zu Ihrer Suche passen keine Erfahrungen.',
    'adminXperiences.empty.filter': 'Für den ausgewählten Filter wurden keine Erlebnisse gefunden.',
    'adminXperiences.noPoster': 'Kein Poster',
    'adminXperiences.noDescription': 'Keine Beschreibung',
    'adminXperiences.creator': 'Schöpfer',
    'adminXperiences.email': 'E-Mail',
    'adminXperiences.date': 'Datum',
    'adminXperiences.na': 'N/A',
    'adminXperiences.mediaCount': 'Medienanzahl',
    'adminXperiences.items': 'Artikel',
    'adminXperiences.action.moderateMedia': 'Moderate Medien',
    'adminXperiences.action.approveAll': 'Alle genehmigen',
    'adminXperiences.action.rejectAll': 'Alle ablehnen',
    'adminXperiences.action.setPending': 'Als ausstehend festlegen',
    'adminXperiences.success.markedAs': 'Xperience erfolgreich markiert als',
    'adminXperiences.error.fetch': 'Erfahrungen konnten nicht abgerufen werden',
    'adminXperiences.error.updateStatus': 'Status konnte nicht aktualisiert werden',
    'createXperience.profileIncomplete': 'Bitte vervollständigen Sie Ihr Profil, bevor Sie ein Erlebnis erstellen',
    'createXperience.error.create': 'Erfahrung konnte nicht erstellt werden',
    'createXperience.title': 'Schaffen Sie neue Erfahrungen',
    'createXperience.subtitle': 'Beginnen Sie mit der Erstellung Ihrer immersiven Inhalte',
    'createXperience.field.title': 'Titel',
    'createXperience.placeholder.title': 'Xperience-Titel',
    'createXperience.field.description': 'Beschreibung',
    'createXperience.placeholder.description': 'Beschreiben Sie Ihre Erfahrungen...',
    'createXperience.field.location': 'Standort',
    'createXperience.field.tags': 'Schlagworte',
    'createXperience.copyLastLocation': 'Letzten Standort kopieren',
    'createXperience.error.noLastLocation': 'Noch kein vorheriger Standort verfügbar.',
    'createXperience.placeholder.tags': 'Tags auswählen oder suchen...',
    'createXperience.help.tags': 'Wählen Sie ein oder mehrere Tags aus, um die Erkennung zu verbessern.',
    'createXperience.cancel': 'Abbrechen',
    'createXperience.submit': 'Schaffen Sie Erfahrung',
    'xperienceDetail.success.mediaOrderSaved': 'Medienbestellung erfolgreich gespeichert.',
    'xperienceDetail.error.mediaOrderSave': 'Die Medienreihenfolge konnte nicht gespeichert werden.',
    'xperienceDetail.error.load': 'xperience konnte nicht geladen werden',
    'xperienceDetail.success.updated': 'Xperience wurde erfolgreich aktualisiert.',
    'xperienceDetail.error.update': 'Xperience konnte nicht aktualisiert werden',
    'xperienceDetail.sendingEmail': 'E-Mail wird gesendet...',
    'xperienceDetail.success.emailSent': 'QR-Zugriffs-E-Mail erfolgreich gesendet.',
    'xperienceDetail.success.locationCopiedToAll': 'Der Standort wurde in {count} Medienelemente kopiert.',
    'xperienceDetail.error.sendEmail': 'QR-E-Mail konnte nicht gesendet werden.',
    'xperienceDetail.error.uploadMedia': 'Das Hochladen der Medien ist fehlgeschlagen',
    'xperienceDetail.error.deleteMedia': 'Das Löschen des Mediums ist fehlgeschlagen',
    'xperienceDetail.error.deleteXperience': 'xperience konnte nicht gelöscht werden',
    'xperienceDetail.error.noLocationToCopyAll': 'Legen Sie zunächst einen Speicherort fest, bevor Sie ihn auf alle Medien kopieren.',
    'xperienceDetail.error.invalidLocationToCopyAll': 'Die aktuellen Standortkoordinaten sind ungültig.',
    'xperienceDetail.error.noMediaToCopyLocationAll': 'Es wurden keine Medienelemente gefunden, die in diesem Erlebnis aktualisiert werden können.',
    'xperienceDetail.error.locationCopiedToAllPartial': '{success} Medienelemente wurden aktualisiert, aber {failed} ist fehlgeschlagen.',
    'xperienceDetail.error.locationCopiedToAllFailed': 'Der Standort konnte nicht für alle Medien aktualisiert werden.',
    'xperienceDetail.loading': 'Erfahrung wird geladen...',
    'xperienceDetail.notFound': 'Xperience nicht gefunden',
    'xperienceDetail.backDashboard': 'Zurück zum Dashboard',
    'xperienceDetail.editTitle': 'Xperience bearbeiten',
    'xperienceDetail.field.title': 'Titel',
    'xperienceDetail.field.description': 'Beschreibung',
    'xperienceDetail.field.location': 'Standort',
    'xperienceDetail.field.tags': 'Schlagworte',
    'xperienceDetail.copyLastLocation': 'Letzten Standort kopieren',
    'xperienceDetail.copyLocationToAll': 'Speicherort auf alle Medien kopieren',
    'xperienceDetail.copyLocationToAllLoading': 'Auf alle Medien kopieren...',
    'xperienceDetail.error.noLastLocation': 'Noch kein vorheriger Standort verfügbar.',
    'xperienceDetail.success.lastLocationCopied': 'Letzter Standort kopiert.',
    'xperienceDetail.placeholder.tags': 'Tags auswählen oder suchen...',
    'xperienceDetail.help.tags': 'Wählen Sie ein oder mehrere Tags aus, um die Erkennung zu verbessern.',
    'xperienceDetail.privateToggle': 'Private Erfahrung (Passwort erforderlich)',
    'xperienceDetail.cancel': 'Abbrechen',
    'xperienceDetail.saveChanges': 'Änderungen speichern',
    'xperienceDetail.edit': 'Bearbeiten',
    'xperienceDetail.deleteXperience': 'Xperience löschen',
    'xperienceDetail.info.status': 'Status',
    'xperienceDetail.pending': 'Ausstehend',
    'xperienceDetail.info.views': 'Ansichten',
    'xperienceDetail.info.rating': 'Bewertung',
    'xperienceDetail.info.reactions': 'Reaktionen',
    'xperienceDetail.info.tags': 'Schlagworte',
    'xperienceDetail.info.category': 'Kategorie',
    'xperienceDetail.info.created': 'Erstellt',
    'xperienceDetail.noDate': 'N/A',
    'xperienceDetail.info.mediaCount': 'Medienanzahl',
    'xperienceDetail.info.visibility': 'Sichtbarkeit',
    'xperienceDetail.visibility.private': 'Privat',
    'xperienceDetail.visibility.public': 'Öffentlich',
    'xperienceDetail.privateQR.title': 'Privater Zugang QR',
    'xperienceDetail.privateQR.description': 'Teilen Sie diesen QR oder dieses Passwort, um privaten Zugriff auf Ihr Erlebnis zu gewähren.',
    'xperienceDetail.privateQR.alt': 'QR-Code für den privaten Zugang',
    'xperienceDetail.success.passwordCopied': 'Passwort in die Zwischenablage kopiert.',
    'xperienceDetail.copyPassword': 'Passwort kopieren',
    'xperienceDetail.wait': 'Warte',
    'xperienceDetail.emailQR': 'E-Mail-QR',
    'xperienceDetail.mediaSectionTitle': 'Xperience-Medien',
    'xperienceDetail.createMedia': '+ Medien erstellen',
    'xperienceDetail.uploading': 'Hochladen',
    'xperienceDetail.noMedia': 'Noch keine Medien hinzugefügt.',
    'xperienceDetail.noMediaHelp': 'Noch keine Mediendateien. Laden Sie Bilder, Videos oder Audio hoch.',
    'xperienceDetail.mediaCard.added': 'Hinzugefügt',
    'xperienceDetail.mediaCard.na': 'N/A',
    'xperienceDetail.mediaCard.viewDetails': 'Details anzeigen',
    'xperienceDetail.confirm.deleteMediaTitle': 'Medien löschen?',
    'xperienceDetail.confirm.deleteMediaMessage': 'Dieses Medienelement wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    'xperienceDetail.confirm.deleteXperienceTitle': 'xperience löschen?',
    'xperienceDetail.confirm.deleteXperienceMessage': 'Dieses Erlebnis und alle zugehörigen Medien werden dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    'xperienceDetail.confirm.delete': 'Löschen',
    'xperienceDetail.confirm.cancel': 'Abbrechen',
    'xperienceDetail.confirm.copyLocationAllTitle': 'Speicherort auf alle Medien kopieren?',
    'xperienceDetail.confirm.copyLocationAllMessage': 'Dadurch werden die Standortkoordinaten für alle Medien in diesem Erlebnis aktualisiert. Weitermachen?',
    'xperienceDetail.confirm.copyLocationAllConfirm': 'Ja, alle Medien aktualisieren',
    'xperienceDetail.confirm.copyLocationAllCancel': 'Abbrechen',
    'xmedia.error.loadData': 'Daten konnten nicht geladen werden',
    'xmedia.error.delete': 'Das Löschen des Mediums ist fehlgeschlagen',
    'xmedia.error.save': 'Xperience-Medien konnten nicht gespeichert werden',
    'xmedia.error.noXperienceLocation': 'Das übergeordnete Xperience hat noch keinen Speicherort zum Kopieren.',
    'xmedia.error.noLastLocation': 'Noch kein vorheriger Standort verfügbar.',
    'xmedia.error.requiredPrefix': 'Die folgenden Felder sind erforderlich:',
    'xmedia.success.posterSelected': 'Plakat vor Ort ausgewählt. Es wird beim Speichern hochgeladen.',
    'xmedia.success.mediaSelected': 'Lokal ausgewählte Medien. Es wird beim Speichern hochgeladen.',
    'xmedia.success.deleted': 'Medien erfolgreich gelöscht!',
    'xmedia.success.created': 'Xperience-Medien erstellt und Dateien erfolgreich hochgeladen!',
    'xmedia.success.updated': 'Xperience-Medien erfolgreich aktualisiert!',
    'xmedia.success.locationCopied': 'Standort von xperience übernommen.',
    'xmedia.success.lastLocationCopied': 'Letzter Standort kopiert.',
    'xmedia.confirm.deleteMessage': 'Sind Sie sicher, dass Sie dieses Medienelement und die zugehörigen Dateien dauerhaft löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    'xmedia.loading': 'Xperience-Medien werden geladen...',
    'xmedia.notFound': 'Xperience-Medien nicht gefunden',
    'xmedia.back': 'Zurück',
    'xmedia.title.create': 'Erstellen Sie neue Medien',
    'xmedia.title.edit': 'Xperience-Medien bearbeiten',
    'xmedia.subtitle': 'Aktualisieren Sie alle Metadaten und Dateien für dieses Medienelement.',
    'xmedia.field.title': 'Titel',
    'xmedia.field.description': 'Beschreibung',
    'xmedia.field.type': 'Typ',
    'xmedia.field.format': 'Formatieren',
    'xmedia.field.category': 'Kategorie',
    'xmedia.field.mediaFile': 'Mediendatei',
    'xmedia.field.posterUrl': 'Poster-URL',
    'xmedia.field.order': 'Bestellen',
    'xmedia.field.runtime': 'Laufzeit',
    'xmedia.field.credits': 'Credits/Punkte erforderlich',
    'xmedia.field.location': 'Standort',
    'xmedia.field.createdDate': 'Erstellungsdatum',
    'xmedia.placeholder.title': 'Geben Sie einen Titel ein',
    'xmedia.placeholder.description': 'Beschreibung eingeben...',
    'xmedia.placeholder.mediaUrl': 'Die URL wird beim Speichern sicher generiert',
    'xmedia.placeholder.posterUrl': 'Der Posterpfad wird beim Speichern generiert',
    'xmedia.placeholder.order': 'z.B. 1',
    'xmedia.placeholder.runtime': 'z. B. 3600',
    'xmedia.placeholder.credits': 'z.B. 0',
    'xmedia.selectFile': 'Wählen Sie Datei',
    'xmedia.changeFile': 'Datei ändern',
    'xmedia.viewMedia': 'Medien anzeigen',
    'xmedia.selectImage': 'Wählen Sie Bild aus',
    'xmedia.changeImage': 'Bild ändern',
    'xmedia.thumbnail': 'Miniaturbild',
    'xmedia.seconds': 'Sekunden',
    'xmedia.requiresDownload': 'Erfordert Download',
    'xmedia.isPublic': 'Ist öffentlich',
    'xmedia.isPremium': 'Ist Premium',
    'xmedia.hide': 'Verstecken',
    'xmedia.deleteMedia': 'Medien löschen',
    'xmedia.cancel': 'Abbrechen',
    'xmedia.saving': 'Sparen...',
    'xmedia.saveChanges': 'Änderungen speichern',
    'xmedia.copyXperienceLocation': 'Xperience-Standort kopieren',
    'xmedia.copyLastLocation': 'Letzten Standort kopieren',
    'xmedia.copyLocationToAll': 'Speicherort auf alle Medien kopieren',
    'xmedia.copyLocationToAllLoading': 'Auf alle Medien kopieren...',
    'xmedia.locationSource.xperience': 'Verwendung des primären Xperience-Standorts',
    'xmedia.locationSource.last': 'Zuletzt kopierten Speicherort verwenden',
    'xmedia.lastLocationPreview': 'Letzter Standort gespeichert',
    'xmedia.confirm.copyLocationAllTitle': 'Speicherort auf alle Medien kopieren?',
    'xmedia.confirm.copyLocationAllMessage': 'Dadurch werden die Standortkoordinaten für alle Medien in diesem Erlebnis aktualisiert. Weitermachen?',
    'xmedia.confirm.copyLocationAllConfirm': 'Ja, alle Medien aktualisieren',
    'xmedia.confirm.copyLocationAllCancel': 'Abbrechen',
    'xmedia.success.locationCopiedToAll': 'Der Standort wurde in {count} Medienelemente kopiert.',
    'xmedia.error.noXperienceForBulkLocation': 'Das übergeordnete Xperience für die Massenaktualisierung des Standorts konnte nicht gefunden werden.',
    'xmedia.error.noLocationToCopyAll': 'Legen Sie zunächst einen Speicherort fest, bevor Sie ihn auf alle Medien kopieren.',
    'xmedia.error.invalidLocationToCopyAll': 'Die aktuellen Standortkoordinaten sind ungültig.',
    'xmedia.error.noMediaToCopyLocationAll': 'Es wurden keine Medienelemente gefunden, die in diesem Erlebnis aktualisiert werden können.',
    'xmedia.error.locationCopiedToAllPartial': '{success} Medienelemente wurden aktualisiert, aber {failed} ist fehlgeschlagen.',
    'xmedia.error.locationCopiedToAllFailed': 'Der Standort konnte nicht für alle Medien aktualisiert werden.',
    'locationPicker.searchLabel': 'Adresse suchen',
    'locationPicker.searchPlaceholder': 'Geben Sie eine Adresse, eine Stadt oder einen Ort ein',
    'locationPicker.longitude': 'Längengrad',
    'locationPicker.latitude': 'Breitengrad',
    'locationPicker.clear': 'Klarer Standort',
    'locationPicker.useCurrent': 'Verwenden Sie meinen aktuellen Standort',
    'locationPicker.locating': 'Lokalisierung...',
    'locationPicker.geoNotSupported': 'Ihr Browser unterstützt keine Geolokalisierung.',
    'locationPicker.geoError': 'Ihr aktueller Standort konnte nicht ermittelt werden. Überprüfen Sie die Browserberechtigungen.',
    'locationPicker.selectedAddress': 'Ausgewählte Adresse',
    'locationPicker.loadingMap': 'Karte wird geladen...',
    'locationPicker.noApiKey': 'Der Google Maps-API-Schlüssel fehlt',
    'locationPicker.noApiKeyHelp': 'Legen Sie REACT_APP_GOOGLE_MAPS_API_KEY in der Frontend-Umgebung fest, um die Karten- und Adresssuche zu aktivieren.',
    'locationPicker.loadError': 'Google Maps konnte nicht geladen werden',
  },
  'ja': {
    'common.loading': '読み込み中...',
    'common.email': '電子メール',
    'common.password': 'パスワード',
    'common.confirmPassword': 'パスワードの確認',
    'common.backToLogin': 'サインインに戻る',
    'common.signIn': 'サインイン',
    'common.emailExample': 'クリエーター@example.com',
    'common.clearSearch': '検索をクリア',
    'login.title': 'おかえりなさい',
    'login.subtitle': 'クリエイターアカウントにサインインする',
    'login.passwordPlaceholder': 'パスワードを入力してください',
    'login.forgotPassword': 'パスワードをお忘れですか?',
    'login.submit': 'サインイン',
    'login.createOne': '作成する',
    'login.error.verifyEmail': 'ログインする前にメールアドレスを確認してください。受信トレイで確認リンクを確認してください。',
    'login.error.invalidCredentials': 'メールアドレスまたはパスワードが無効です。',
    'login.resend.button': '確認メールを再送信する',
    'login.resend.success': 'アカウントが存在しても認証されていない場合は、新しい認証メールが送信されています。',
    'login.resend.error': '確認メールの再送信に失敗しました。しばらくしてからもう一度お試しください。',
    'login.resend.wait': '別の確認メールをリクエストする前に、しばらくお待ちください。',
    'login.resend.waitWithSeconds': '再送信が可能な時間帯',
    'register.title': 'アカウントを作成する',
    'register.titleSuccess': 'メールを確認してください',
    'register.subtitle': 'X-perience クリエイター コミュニティに参加しましょう',
    'register.subtitleSuccess': '確認リンクを送信しました',
    'register.alias': 'エイリアス',
    'register.aliasPlaceholder': '作成者のエイリアス',
    'register.passwordPlaceholder': '少なくとも6文字',
    'register.confirmPasswordPlaceholder': 'パスワードを確認してください',
    'register.acceptPrefix': '読んで同意します',
    'register.terms': '利用規約',
    'register.and': 'そして',
    'register.privacy': 'プライバシーポリシー',
    'register.acceptSuffix': '。',
    'register.submit': 'アカウントの作成',
    'register.successCreated': 'アカウントが正常に作成されました。',
    'register.successCheckInbox': '受信箱 (およびスパム フォルダー) を確認し、確認リンクをクリックしてアカウントを有効にしてください。',
    'register.successEmailIssue': 'アカウントは作成されましたが、確認メールの配信が一時的に利用できなくなりました。すぐにログインから再送信確認ボタンを使用してください。',
    'register.successBackToLogin': 'ログインに戻る',
    'register.haveAccount': 'すでにアカウントをお持ちですか?',
    'register.signIn': 'サインイン',
    'register.error.passwordsMismatch': 'パスワードが一致しません',
    'register.error.passwordMin': 'パスワードは6文字以上である必要があります',
    'register.error.acceptTerms': '利用規約とプライバシーポリシーを読んで同意する必要があります',
    'register.error.generic': '登録に失敗しました',
    'forgot.title': 'パスワードのリセット',
    'forgot.subtitle': 'メールアドレスを入力してリセットリンクを受信してください',
    'forgot.submit': 'リセットリンクを送信する',
    'forgot.success': 'メールにパスワード リセット リンクがあるかどうかを確認してください。',
    'forgot.devMode': '開発モード:',
    'forgot.devGoReset': 'パスワードのリセットに移動',
    'forgot.remember': 'パスワードを覚えていますか?',
    'forgot.error.generic': 'リセットメールの送信に失敗しました',
    'reset.title': 'パスワードのリセット',
    'reset.subtitle': '新しいパスワードを入力してください',
    'reset.newPassword': '新しいパスワード',
    'reset.confirmPassword': 'パスワードの確認',
    'reset.confirmPlaceholder': '新しいパスワードを確認します',
    'reset.submit': 'パスワードのリセット',
    'reset.success': 'パスワードのリセットが成功しました。ログインにリダイレクトしています...',
    'reset.error.invalidLink': '無効なリセットリンクです',
    'reset.error.passwordsMismatch': 'パスワードが一致しません',
    'reset.error.passwordMin': 'パスワードは6文字以上である必要があります',
    'reset.error.invalidToken': '無効なリセットトークン',
    'reset.error.generic': 'パスワードのリセットに失敗しました',
    'verify.title': 'メール認証',
    'verify.loading': 'メールを確認しています...',
    'verify.successLine1': 'あなたのメールアドレスは正常に認証されました。',
    'verify.successLine2': 'これでアカウントにログインできるようになりました。',
    'verify.redirecting': 'ログインにリダイレクトしています...',
    'verify.alreadyLine1': 'あなたのメールアドレスはすでに認証されています。',
    'verify.alreadyLine2': '自分のアカウントにログインできます。',
    'verify.goLogin': 'ログインに移動',
    'verify.error.noToken': '検証トークンが���供されていません',
    'verify.error.generic': '検証に失敗しました',
    'navbar.subtitle': 'クリエイターポータル',
    'navbar.dashboard': 'ダッシュボード',
    'navbar.modXperiences': 'モジュール。体験',
    'navbar.manageCreators': 'クリエイターの管理',
    'navbar.newXperience': '新しい体験',
    'navbar.generateCreators': 'クリエイターの生成',
    'navbar.generateXperiences': '体験を生成する',
    'navbar.generate': '生成する',
    'navbar.generating': '生成中',
    'navbar.profile': 'プロフィール',
    'navbar.logout': 'ログアウト',
    'navbar.confirmGenerateCreators': 'クリエーター JSON を生成してもよろしいですか?',
    'navbar.confirmGenerateXperiences': 'xperiences JSON を生成してもよろしいですか?',
    'navbar.successGenerateCreators': 'クリエイターが正常に生成されました。',
    'navbar.successGenerateXperiences': 'エクスペリエンスが正常に生成されました。',
    'navbar.error.endpoint': 'エンドポイントが見つかりません。 API サービスの再起動が必要な場合があります。',
    'navbar.error.noBody': '応答本文がありません',
    'navbar.error.generateCreators': 'クリエイターの生成に失敗しました',
    'navbar.error.generateXperiences': 'エクスペリエンスの生成に失敗しました',
    'navbar.roleDefault': 'クリエイター',
    'navbar.statusPending': '保留中',
    'navbar.statusTitle': 'ステータス',
    'navbar.totalViews': '合計視聴数',
    'navbar.avgRating': '平均評価',
    'navbar.roleTitle': '役割',
    'navbar.languageLabel': '言語',
    'navbar.lang.en': '英語',
    'navbar.lang.es': 'スペイン語',
    'locale.en': '英語',
    'locale.zhHk': '中国語 (香港)',
    'locale.zhHans': '中国語、簡体字',
    'locale.zhHant': '中国語、繁体字',
    'locale.enAu': '英語 (オーストラリア)',
    'locale.enGb': '英語 (イギリス)',
    'locale.fr': 'フランス語',
    'locale.frCa': 'フランス語 (カナダ)',
    'locale.de': 'ドイツ語',
    'locale.ja': '日本語',
    'locale.es': 'スペイン語',
    'home.profileIncomplete': 'エクスペリエンスを管理する前にプロフィールを完成させてください',
    'home.error.load': 'エクスペリエンスのロードに失敗しました',
    'home.title': 'あなたの経験',
    'home.subtitle': 'Apple Vision Pro のイマーシブ コンテンツを管理する',
    'home.newXperience': '+ 新しい体験',
    'home.searchPlaceholder': 'タイトルまたは説明で検索...',
    'home.clearSearch': '検索をクリア',
    'home.allMediaTypes': 'すべてのメディアタイプ',
    'home.loading': 'エクスペリエンスを読み込んでいます...',
    'home.emptyTitle': 'まだ経験はありません',
    'home.emptyText': 'Apple Vision Pro の最初の没入型体験を作成する',
    'home.createFirst': '最初の体験を作成する',
    'home.noResultsTitle': '結果が見つかりませんでした',
    'home.noResultsText': '検索条件やフィルターを調整してみてください',
    'home.clearFilters': 'フィルターをクリアする',
    'home.privateTitle': 'プライベート体験',
    'home.categoryTitle': 'カテゴリ',
    'home.viewsTitle': 'ビュー',
    'home.likesTitle': 'いいね！',
    'home.dislikesTitle': '嫌いなもの',
    'home.ratingTitle': '評価',
    'home.viewDetails': '詳細を見る',
    'home.moreTags': 'さらに多くのタグ',
    'home.files': 'ファイル',
    'home.filesPlural': 'ファイル',
    'beCreator.title': 'X-perience のクリエイターになろう',
    'beCreator.subtitle': 'Apple Vision Pro の没入型エクスペリエンスを共有する',
    'beCreator.point1': '自分の体験を公開して視聴者を増やしましょう。',
    'beCreator.point2': 'ダッシュボードからビュー、いいね、評価を追跡します。',
    'beCreator.point3': '1 つのクリエイター ポータルからメディアと更新を管理します。',
    'beCreator.ctaPrimary': 'クリエイターアカウントを作成する',
    'beCreator.ctaSecondary': 'すでにアカウントを持っています',
    'beCreator.heroTitle': 'クリエイターになる',
    'beCreator.heroSubtitle': 'あなたのユニークな X 体験を世界と共有し、あなたの情熱を現実にしましょう。',
    'beCreator.heroCta': 'クリエイターとして参加する',
    'beCreator.benefitsTitle': 'X-periences に参加する理由',
    'beCreator.benefit.audienceTitle': '世界中の視聴者にリーチする',
    'beCreator.benefit.audienceText': '独自のコンテンツやエクスペリエンスを発見し、関与することに熱心な世界中のユーザーとつながりましょう。',
    'beCreator.benefit.recognitionTitle': '評価を獲得する',
    'beCreator.benefit.recognitionText': '世界中のユーザーにインスピレーションを与える没入型のストーリーを共有して、クリエイターとしての評判を築きましょう。',
    'beCreator.benefit.toolsTitle': '強力なクリエイターツール',
    'beCreator.benefit.toolsText': '高度な分析、シームレスなメディア管理、クリエイター向けにカスタマイズされた使いやすい公開ツールにアクセスできます。',
    'beCreator.benefit.communityTitle': '協力的なコミュニティ',
    'beCreator.benefit.communityText': '情熱的なクリエイターのネットワークに参加してください。安全な環境でアイデアを共有し、コラボレーションし、一緒に成長しましょう。',
    'beCreator.howItWorksTitle': '仕組み',
    'beCreator.step.signupTitle': 'サインアップ',
    'beCreator.step.signupText': '数回クリックするだけでクリエイタープロフィールを作成できます。',
    'beCreator.step.createTitle': '作成',
    'beCreator.step.createText': 'コンテンツをアップロードして、魅力的な X ペリエンスを構築します。',
    'beCreator.step.recognizedTitle': '認められるようにする',
    'beCreator.step.recognizedText': '自分の体験を世界中で共有し、視聴者を増やし、没入型コンテンツのリファレンス作成者になりましょう。',
    'beCreator.footerTitle': '旅を始める準備はできていますか?',
    'beCreator.footerText': '没入型体験を世界と共有する第一歩を踏み出しましょう。',
    'beCreator.footerCta': '今すぐ始めましょう',
    'profile.loading': 'プロファイルを読み込んでいます...',
    'profile.title': 'クリエイタープロフィール',
    'profile.subtitle': 'クリエイター情報を管理する',
    'profile.requiredFieldsLabel': '必須フィールド*:',
    'profile.requiredFieldsText': 'Xperiences ダッシュボードにアクセスするには、フルネーム、アバター、経歴、および国が必要です。',
    'profile.section.accountInfo': 'アカウント情報',
    'profile.section.changePassword': 'パスワードの変更',
    'profile.section.personalInfo': '個人情報',
    'profile.section.appSocial': 'アプリとソーシャルメディア',
    'profile.section.creatorStats': 'クリエイターの統計',
    'profile.field.usernameAlias': 'ユーザー名 (エイリアス)',
    'profile.field.currentPassword': '現在のパスワード',
    'profile.field.newPassword': '新しいパスワード',
    'profile.field.confirmNewPassword': '新しいパスワードを確認する',
    'profile.field.fullNameRequired': 'フルネーム *',
    'profile.field.phone': '電話',
    'profile.field.countryRequired': '国 *',
    'profile.field.avatarRequired': 'アバター *',
    'profile.field.biographyRequired': '略歴 *',
    'profile.field.appName': 'アプリ名',
    'profile.field.appUrl': 'アプリのURL',
    'profile.field.youtubeUrl': 'YouTubeのURL',
    'profile.field.instagramUrl': 'インスタグラムのURL',
    'profile.field.otherUrl': '他のURL',
    'profile.placeholder.username': 'あなたのユーザー名',
    'profile.placeholder.currentPassword': '現在のパスワードを入力してください',
    'profile.placeholder.newPassword': '新しいパスワードを入力してください',
    'profile.placeholder.confirmNewPassword': '新しいパスワードを確認します',
    'profile.placeholder.fullName': 'あなたのフルネーム',
    'profile.placeholder.phone': '+1 (555) 000-0000',
    'profile.placeholder.searchCountries': '国を検索するには入力してください...',
    'profile.placeholder.biography': 'あなた自身について教えてください...',
    'profile.placeholder.appName': '例: 私のアプリ',
    'profile.placeholder.appUrl': 'https://myapp.com',
    'profile.placeholder.youtubeUrl': 'https://youtube.com/@あなたのユーザー名',
    'profile.placeholder.instagramUrl': 'https://instagram.com/あなたのユーザー名',
    'profile.placeholder.otherUrl': 'https://example.com',
    'profile.note.publicUsername': 'あなたの公開ユーザー名',
    'profile.note.emailImmutable': 'プロフィールではメールアドレスは変更できません',
    'profile.note.passwordMin': '最低6文字',
    'profile.note.requiredForDashboard': 'ダッシュボードにアクセスするために必要です',
    'profile.note.countryRequired': 'ダッシュボードにアクセスするために必要です。リストから選択するか、検索する文字を入力してください。',
    'profile.note.avatarRequired': 'ダッシュボードにアクセスするために必要 • JPG、PNG、または GIF (最大 20MB)',
    'profile.note.biographyRequiredPrefix': 'ダッシュボードにアクセスするために必要です •',
    'profile.note.characters': 'キャラクター',
    'profile.optional': 'オプション',
    'profile.allOptional': 'すべてオ��ション',
    'profile.uploading': 'アップロード中...',
    'profile.uploadingAvatar': 'アバターをアップロードしています...',
    'profile.chooseAvatarImage': 'アバター画像を選択してください',
    'profile.avatarPreviewAlt': 'アバターのプレビュー',
    'profile.preview': 'プレビュー',
    'profile.openInNewTab': '新しいタブで開く',
    'profile.view': '見る',
    'profile.stats.rating': '評価',
    'profile.stats.credits': 'クレジット',
    'profile.stats.views': 'ビュー',
    'profile.stats.votes': '投票',
    'profile.saving': '保存中...',
    'profile.saveChanges': '変更を保存',
    'profile.success.profileAndPasswordUpdated': 'プロフィールとパスワードが正常に更新されました。',
    'profile.success.profileUpdatedComplete': 'プロフィールが正常に更新されました。すべての必須フィールドが入力されています。これで、Xperiences ダッシュボードにアクセスできるようになりました。',
    'profile.success.profileUpdatedIncomplete': 'プロフィールが正常に更新されました。ダッシュボードにアクセスするには、すべての必須フィールド (名前、アバター、経歴、国) を入力してください。',
    'profile.error.loadProfile': 'プロファイルのロードに失敗しました',
    'profile.error.avatarUpload': 'アバターのアップロードに失敗しました。プロファイルは保存されていません。',
    'profile.error.fillAllPasswordFields': 'パスワードを変更するには、すべてのパスワードフィールドに入力してください',
    'profile.error.passwordsMismatch': '新しいパスワードが一致しません',
    'profile.error.passwordMin': '新しいパスワードは6文字以上である必要があります',
    'profile.error.changePassword': 'パスワードの変更に失敗しま���た',
    'profile.error.profileUpdatedPasswordFailed': 'プロファイルは更新されましたが、パスワードの変更に失敗しました',
    'profile.error.updateProfile': 'プロファイルの更新に失敗しました。もう一度試してください。',
    'adminCreators.title': 'クリエイターの管理',
    'adminCreators.loading': 'クリエイターを読み込み中...',
    'adminCreators.error.load': 'クリエイターの読み込みに失敗しました',
    'adminCreators.error.roleUpdate': '役割の更新に失敗しました',
    'adminCreators.error.statusUpdate': 'ステータスの更新に失敗しました',
    'adminCreators.error.trustUpdate': '信頼フラグの更新に失敗しました',
    'adminCreators.success.roleUpdated': '役割が正常に更新されました。',
    'adminCreators.success.statusUpdated': 'ステータスが正常に更新されました。',
    'adminCreators.success.trustUpdated': '信頼フラグが正常に更新されました。',
    'adminCreators.table.alias': 'エイリアス',
    'adminCreators.table.email': '電子メール',
    'adminCreators.table.emailVerified': 'メール認証済み',
    'adminCreators.table.hidden': '隠された',
    'adminCreators.table.joinDate': '参加日',
    'adminCreators.table.role': '役割',
    'adminCreators.table.status': 'ステータス',
    'adminCreators.table.trusted': '信頼できる',
    'adminCreators.yes': 'はい',
    'adminCreators.no': 'いいえ',
    'adminCreators.hidden': '隠された',
    'adminCreators.visible': '見える',
    'adminCreators.trusted': '信頼できる',
    'adminCreators.standard': '標準',
    'adminCreators.role.creator': 'クリエイター',
    'adminCreators.role.manager': 'マネージャー',
    'adminCreators.role.administrator': '管理者',
    'adminCreators.status.pending': '保留中',
    'adminCreators.status.approved': '承認済み',
    'adminCreators.status.rejected': '禁止/拒否されました',
    'adminCreators.empty': 'クリエイターが見つかりませんでした。',
    'adminCreators.pagination.page': 'ページ',
    'adminCreators.pagination.of': 'の',
    'adminCreators.pagination.total': '合計',
    'adminCreators.pagination.rowsPerPage': 'ページあたりの行数',
    'adminCreators.pagination.previous': '前へ',
    'adminCreators.pagination.next': '次へ',
    'adminCreatorDetail.title': '作成者の編集:',
    'adminCreatorDetail.back': '戻る',
    'adminCreatorDetail.id': 'ID',
    'adminCreatorDetail.email': '電子メール',
    'adminCreatorDetail.alias': 'エイリアス',
    'adminCreatorDetail.fullName': 'フルネーム',
    'adminCreatorDetail.phone': '電話',
    'adminCreatorDetail.countryCode': '国コード',
    'adminCreatorDetail.countryPlaceholder': '国を検索するには入力してください...',
    'adminCreatorDetail.flags': 'プロファイルフラグ',
    'adminCreatorDetail.emailVerified': 'メール認証済み',
    'adminCreatorDetail.resendEmail': 'メールを再送信する',
    'adminCreatorDetail.sending': '送信中...',
    'adminCreatorDetail.hideProfile': 'プロフィールを隠す (未完成)',
    'adminCreatorDetail.isTrusted': '信頼できるクリエイター',
    'adminCreatorDetail.bio': '略歴 / 説明',
    'adminCreatorDetail.linksApps': 'リンクとアプリ',
    'adminCreatorDetail.appName': 'アプリ名',
    'adminCreatorDetail.appUrl': 'アプリのURL',
    'adminCreatorDetail.youtubeUrl': 'YouTubeのURL',
    'adminCreatorDetail.instagramUrl': 'インスタグラムのURL',
    'adminCreatorDetail.otherUrl': '他のURL',
    'adminCreatorDetail.saveProfile': 'プロファイルの保存',
    'adminCreatorDetail.saving': '保存中...',
    'adminCreatorDetail.error.load': 'クリエーターの読み込みに失敗しました',
    'adminCreatorDetail.error.verificationSend': '確認メールの送信に失敗しました。',
    'adminCreatorDetail.error.update': 'クリエイターの更新に失敗しました',
    'adminCreatorDetail.success.verificationSent': '確認メールが正常に送信されました。',
    'adminCreatorDetail.success.updated': 'クリエイターが正常に更新されました',
    'moderation.back': '戻る',
    'moderation.title.single': 'エクスペリエンスコンテンツのモデレート',
    'moderation.title.global': 'コンテンツモデレーション',
    'moderation.searchPlaceholder': 'タイトル、説明、作成者で検索します...',
    'moderation.filter.allMedia': 'すべてのメディア',
    'moderation.filter.pending': '保留中',
    'moderation.filter.approved': '承認済み',
    'moderation.filter.rejected': '拒否されました',
    'moderation.loading': 'メディアをロード中...',
    'moderation.empty.search': '検索に一致するメディアはありません。',
    'moderation.empty.filter': '選択したフィルターに対応するメディアが見つかりません。',
    'moderation.noPoster': 'ポスターなし',
    'moderation.untitled': '無題',
    'moderation.noDescription': '説明なし',
    'moderation.creator': 'クリエイター',
    'moderation.email': '電子メール',
    'moderation.date': '日付',
    'moderation.na': '該当なし',
    'moderation.viewOriginal': '元のファイルを表示する',
    'moderation.action.approve': '承認する',
    'moderation.action.reject': '拒否する',
    'moderation.action.setPending': '保留中の設定',
    'moderation.success.markedAs': 'メディアが正常にマークされました',
    'moderation.error.loadMedia': 'モデレート用のメディアの読み込み中にエラーが発生しました。',
    'moderation.error.updateStatus': 'メディアステータスの更新に失敗しました。',
    'adminXperiences.backDashboard': 'ダッシュボードに戻る',
    'adminXperiences.title': 'グローバル エクスペリエンス モデレーション',
    'adminXperiences.searchPlaceholder': 'タイトル、説明、作成者で検索します...',
    'adminXperiences.filter.all': 'すべての体験',
    'adminXperiences.filter.pending': '保留中',
    'adminXperiences.filter.approved': '承認済み',
    'adminXperiences.filter.rejected': '拒否されました',
    'adminXperiences.loading': 'エクスペリエンスを読み込んでいます...',
    'adminXperiences.empty.search': '検索に一致する経験はありません。',
    'adminXperiences.empty.filter': '選択したフィルターのエクスペリエンスが見つかりません。',
    'adminXperiences.noPoster': 'ポスターなし',
    'adminXperiences.noDescription': '説明なし',
    'adminXperiences.creator': 'クリエイター',
    'adminXperiences.email': '電子メール',
    'adminXperiences.date': '日付',
    'adminXperiences.na': '該当なし',
    'adminXperiences.mediaCount': 'メディア数',
    'adminXperiences.items': 'アイテム',
    'adminXperiences.action.moderateMedia': '適度なメディア',
    'adminXperiences.action.approveAll': 'すべて承認',
    'adminXperiences.action.rejectAll': 'すべて拒否する',
    'adminXperiences.action.setPending': '保留中の設定',
    'adminXperiences.success.markedAs': 'Xperience は正常にマークされました',
    'adminXperiences.error.fetch': 'エクスペリエンスの取得に失敗しました',
    'adminXperiences.error.updateStatus': 'ステータスの更新に失敗しました',
    'createXperience.profileIncomplete': 'エクスペリエンスを作成する前にプロフィールを完成させてください',
    'createXperience.error.create': 'エクスペリエンスの作成に失敗しました',
    'createXperience.title': '新しい体験を創造する',
    'createXperience.subtitle': '没入型コンテンツの構築を開始する',
    'createXperience.field.title': 'タイトル',
    'createXperience.placeholder.title': '体験タイトル',
    'createXperience.field.description': '説明',
    'createXperience.placeholder.description': 'あなたの経験を説明してください...',
    'createXperience.field.location': '場所',
    'createXperience.field.tags': 'タグ',
    'createXperience.copyLastLocation': '最後の場所をコピー',
    'createXperience.error.noLastLocation': '以前の場所はまだ利用できません。',
    'createXperience.placeholder.tags': 'タグを選択または検索...',
    'createXperience.help.tags': '発見を改善するには、1 つ以上のタグを選択します。',
    'createXperience.cancel': 'キャンセル',
    'createXperience.submit': 'エクスペリエンスを作成する',
    'xperienceDetail.success.mediaOrderSaved': 'メディアの注文が正常に保存されました。',
    'xperienceDetail.error.mediaOrderSave': 'メディアの順序を保存できませんでした。',
    'xperienceDetail.error.load': 'エクスペリエンスのロードに失敗しました',
    'xperienceDetail.success.updated': 'Xperienceは正常に更新されました。',
    'xperienceDetail.error.update': 'エクスペリエンスの更新に失敗しました',
    'xperienceDetail.sendingEmail': 'メールを送信中...',
    'xperienceDetail.success.emailSent': 'QR アクセスメールが正常に送信されました。',
    'xperienceDetail.success.locationCopiedToAll': '場所が {count} 個のメディア アイテムにコピーされました。',
    'xperienceDetail.error.sendEmail': 'QRメールの送信に失敗しました。',
    'xperienceDetail.error.uploadMedia': 'メディアのアップロードに失敗しました',
    'xperienceDetail.error.deleteMedia': 'メディアの削除に失敗しました',
    'xperienceDetail.error.deleteXperience': 'エクスペリエンスの削除に失敗しました',
    'xperienceDetail.error.noLocationToCopyAll': 'すべてのメディアにコピーする前に、まず場所を設定します。',
    'xperienceDetail.error.invalidLocationToCopyAll': '現在位置の座標が無効です。',
    'xperienceDetail.error.noMediaToCopyLocationAll': 'このエクス��リエンスでは更新するメディア アイテムが見つかりませんでした。',
    'xperienceDetail.error.locationCopiedToAllPartial': '{success} 個のメディア アイテムを更新しましたが、{failed} 個は失敗しました。',
    'xperienceDetail.error.locationCopiedToAllFailed': 'すべてのメディアの場所を更新できませんでした。',
    'xperienceDetail.loading': 'エクスペリエンスを読み込んでいます...',
    'xperienceDetail.notFound': '経験が見つかりません',
    'xperienceDetail.backDashboard': 'ダッシュボードに戻る',
    'xperienceDetail.editTitle': 'エクスペリエンスの編集',
    'xperienceDetail.field.title': 'タイトル',
    'xperienceDetail.field.description': '説明',
    'xperienceDetail.field.location': '場所',
    'xperienceDetail.field.tags': 'タグ',
    'xperienceDetail.copyLastLocation': '最後の場所をコピー',
    'xperienceDetail.copyLocationToAll': '場所をすべてのメディアにコピー',
    'xperienceDetail.copyLocationToAllLoading': 'すべてのメディアにコピーしています...',
    'xperienceDetail.error.noLastLocation': '以前の場所はまだ利用できません。',
    'xperienceDetail.success.lastLocationCopied': '最後にコピーされた場所。',
    'xperienceDetail.placeholder.tags': 'タグを選択または検索...',
    'xperienceDetail.help.tags': '発見を改善するには、1 つ以上のタグを選択します。',
    'xperienceDetail.privateToggle': 'プライベート体験（パスワードが必要）',
    'xperienceDetail.cancel': 'キャンセル',
    'xperienceDetail.saveChanges': '変更を保存',
    'xperienceDetail.edit': '編集',
    'xperienceDetail.deleteXperience': 'エクスペリエンスの削除',
    'xperienceDetail.info.status': 'ステータス',
    'xperienceDetail.pending': '保留中',
    'xperienceDetail.info.views': 'ビュー',
    'xperienceDetail.info.rating': '評価',
    'xperienceDetail.info.reactions': '反応',
    'xperienceDetail.info.tags': 'タグ',
    'xperienceDetail.info.category': 'カテゴリ',
    'xperienceDetail.info.created': '作成されました',
    'xperienceDetail.noDate': '該当なし',
    'xperienceDetail.info.mediaCount': 'メディア数',
    'xperienceDetail.info.visibility': '可視性',
    'xperienceDetail.visibility.private': 'プライベート',
    'xperienceDetail.visibility.public': '公共',
    'xperienceDetail.privateQR.title': 'プライベートアクセスQR',
    'xperienceDetail.privateQR.description': 'この QR またはパスワードを共有して、エクスペリエンスへのプライベート アクセスを許可します。',
    'xperienceDetail.privateQR.alt': 'プライベートアクセスQRコード',
    'xperienceDetail.success.passwordCopied': 'パスワードがクリップボードにコピーされました。',
    'xperienceDetail.copyPassword': 'パスワードをコピーする',
    'xperienceDetail.wait': '待ってください',
    'xperienceDetail.emailQR': 'メールQR',
    'xperienceDetail.mediaSectionTitle': 'エクスペリエンスメディア',
    'xperienceDetail.createMedia': '+ メディアの作成',
    'xperienceDetail.uploading': 'アップロード中',
    'xperienceDetail.noMedia': 'まだメディアは追加されていません。',
    'xperienceDetail.noMediaHelp': 'メディア ファイルはまだありません。��像、ビデオ、またはオーディオをアップロードします。',
    'xperienceDetail.mediaCard.added': '追加されました',
    'xperienceDetail.mediaCard.na': '該当なし',
    'xperienceDetail.mediaCard.viewDetails': '詳細を見る',
    'xperienceDetail.confirm.deleteMediaTitle': 'メディアを削除しますか?',
    'xperienceDetail.confirm.deleteMediaMessage': 'このメディア アイテムは完全に削除されます��この操作は元に戻すことができません。',
    'xperienceDetail.confirm.deleteXperienceTitle': 'エクスペリエンスを削除しますか?',
    'xperienceDetail.confirm.deleteXperienceMessage': 'このエクスペリエンスと関連するすべてのメディアは完全に削除されます。この操作は元に戻すことができません。',
    'xperienceDetail.confirm.delete': '削除',
    'xperienceDetail.confirm.cancel': 'キャンセル',
    'xperienceDetail.confirm.copyLocationAllTitle': '場所をすべてのメディアにコピーしますか?',
    'xperienceDetail.confirm.copyLocationAllMessage': 'これにより、このエクスペリエンス内のすべてのメディアの位置座標が更新されます。続く？',
    'xperienceDetail.confirm.copyLocationAllConfirm': 'はい、すべてのメディアを更新します',
    'xperienceDetail.confirm.copyLocationAllCancel': 'キャンセル',
    'xmedia.error.loadData': 'データのロードに失敗しました',
    'xmedia.error.delete': 'メディアの削除に失敗しました',
    'xmedia.error.save': 'エクスペリエンス メディアの保存に失敗しました',
    'xmedia.error.noXperienceLocation': '親エクスペリエンスにはコピーする場所がまだありません。',
    'xmedia.error.noLastLocation': '以前��場所はまだ利用できません。',
    'xmedia.error.requiredPrefix': '次のフィールドは必須です。',
    'xmedia.success.posterSelected': '現地で選ばれたポスター。保存時にアップロードされます。',
    'xmedia.success.mediaSelected': 'ローカルで選択されたメディア。保存時にアップロードされます。',
    'xmedia.success.deleted': 'メディアが正常に削除されました。',
    'xmedia.success.created': 'Xperience メディアが作成され、ファイルが正常にアップロードされました。',
    'xmedia.success.updated': 'Xperience メディアが正常に更新されました。',
    'xmedia.success.locationCopied': '場所はエクスペリエンスからコピーされました。',
    'xmedia.success.lastLocationCopied': '最後にコピーされた��所。',
    'xmedia.confirm.deleteMessage': 'このメディア アイテムとその関連ファイルを完全に削除してもよろしいですか?この操作は元に戻すことができません。',
    'xmedia.loading': 'エクスペリエンス メディアを読み込み中...',
    'xmedia.notFound': 'エクスペリエンス メディアが見つかりません',
    'xmedia.back': '戻る',
    'xmedia.title.create': '新しいメディアの作成',
    'xmedia.title.edit': 'エクスペリエンスメディアの編集',
    'xmedia.subtitle': 'このメディア アイテムのすべてのメタデータとファイルを更新します。',
    'xmedia.field.title': 'タイトル',
    'xmedia.field.description': '説明',
    'xmedia.field.type': '種類',
    'xmedia.field.format': 'フォーマット',
    'xmedia.field.category': 'カテゴリ',
    'xmedia.field.mediaFile': 'メディアファイル',
    'xmedia.field.posterUrl': 'ポスターURL',
    'xmedia.field.order': '注文',
    'xmedia.field.runtime': 'ランタイム',
    'xmedia.field.credits': '必要なクレジット/ポイント',
    'xmedia.field.location': '場所',
    'xmedia.field.createdDate': '作成日',
    'xmedia.placeholder.title': 'タイトルを入力してください',
    'xmedia.placeholder.description': '説明を入力してください...',
    'xmedia.placeholder.mediaUrl': 'URLは保存時に安全に生成されます',
    'xmedia.placeholder.posterUrl': '保存時にポスターのパスが生成されます',
    'xmedia.placeholder.order': '例: 1',
    'xmedia.placeholder.runtime': '例: 3600',
    'xmedia.placeholder.credits': '例: 0',
    'xmedia.selectFile': 'ファイルの選択',
    'xmedia.changeFile': 'ファイルの変更',
    'xmedia.viewMedia': 'メディアを見る',
    'xmedia.selectImage': '画像の選択',
    'xmedia.changeImage': '画像の変更',
    'xmedia.thumbnail': 'サムネイル画像',
    'xmedia.seconds': '秒',
    'xmedia.requiresDownload': 'ダウンロードが必要です',
    'xmedia.isPublic': '公開されています',
    'xmedia.isPremium': 'プレミアムです',
    'xmedia.hide': '隠す',
    'xmedia.deleteMedia': 'メディアの削除',
    'xmedia.cancel': 'キャンセル',
    'xmedia.saving': '保存中...',
    'xmedia.saveChanges': '変更を保存',
    'xmedia.copyXperienceLocation': 'エクスペリエンスの場所をコピーする',
    'xmedia.copyLastLocation': '最後の場所をコピー',
    'xmedia.copyLocationToAll': '場所をすべてのメディアにコピー',
    'xmedia.copyLocationToAllLoading': 'すべてのメディアにコピーしています...',
    'xmedia.locationSource.xperience': 'Xperience プライマリ ロケーションの使用',
    'xmedia.locationSource.last': '最後にコピーした場所を使用する',
    'xmedia.lastLocationPreview': '最後に保存した場所',
    'xmedia.confirm.copyLocationAllTitle': '場所をすべてのメディアにコピーしますか?',
    'xmedia.confirm.copyLocationAllMessage': 'これにより、このエクスペリエンス内のすべてのメディアの位置座標が更新されます。続く？',
    'xmedia.confirm.copyLocationAllConfirm': 'はい、すべてのメディアを更新します',
    'xmedia.confirm.copyLocationAllCancel': 'キャンセル',
    'xmedia.success.locationCopiedToAll': '場所が {count} 個のメディア アイテムにコピーされました。',
    'xmedia.error.noXperienceForBulkLocation': '一括位置情報更新の親エクスペリエンスが見つかりませんでした。',
    'xmedia.error.noLocationToCopyAll': 'すべてのメディアにコピーする前に、まず場所を設定します。',
    'xmedia.error.invalidLocationToCopyAll': '現在位置の座標が無効です。',
    'xmedia.error.noMediaToCopyLocationAll': 'このエクスペリエンスでは更新するメディア アイテムが見つかりませんでした。',
    'xmedia.error.locationCopiedToAllPartial': '{success} 個のメディア アイテムを更新しましたが、{failed} 個は失敗しました。',
    'xmedia.error.locationCopiedToAllFailed': 'すべてのメディアの場所を更新できませんでした。',
    'locationPicker.searchLabel': '住所検索',
    'locationPicker.searchPlaceholder': '住所、都市、または場所を入力します',
    'locationPicker.longitude': '経度',
    'locationPicker.latitude': '緯度',
    'locationPicker.clear': '明確な場所',
    'locationPicker.useCurrent': '現在地を使用する',
    'locationPicker.locating': '探しています...',
    'locationPicker.geoNotSupported': 'お使いのブラウザは地理位置情報をサポートしていません。',
    'locationPicker.geoError': '現在地を取得できません���した。ブラウザの権限を確認してください。',
    'locationPicker.selectedAddress': '選択したアドレス',
    'locationPicker.loadingMap': '地図を読み込んでいます...',
    'locationPicker.noApiKey': 'Google Maps API キーがありません',
    'locationPicker.noApiKeyHelp': 'フロントエンド環境に REACT_APP_GOOGLE_MAPS_API_KEY を設定して、地図と住所の検索を有効にします。',
    'locationPicker.loadError': 'Google マップを読み込めませんでした',
  },
  'zh-Hans': {
    'common.loading': '加载中...',
    'common.email': '电子邮件',
    'common.password': '密码',
    'common.confirmPassword': '确认密码',
    'common.backToLogin': '返回登录',
    'common.signIn': '登录',
    'common.emailExample': 'Creator@example.com',
    'common.clearSearch': '清除搜索',
    'login.title': '欢迎回来',
    'login.subtitle': '登录您的创作者帐户',
    'login.passwordPlaceholder': '输入您的密码',
    'login.forgotPassword': '忘记密码？',
    'login.submit': '登录',
    'login.createOne': '创建一个',
    'login.error.verifyEmail': '请在登录前验证您的电子邮件。请检查您的收件箱中的验证链接。',
    'login.error.invalidCredentials': '电子邮件或密码无效。',
    'login.resend.button': '重新发送验证邮件',
    'login.resend.success': '如果您的帐户存在且未经验证，则会发送一封新的验证电子邮件。',
    'login.resend.error': '重新发送验证邮件失败。请稍后重试。',
    'login.resend.wait': '请稍等片刻，然后再请求另一封验证电子邮件。',
    'login.resend.waitWithSeconds': '重新发送可用于',
    'register.title': '创建您的帐户',
    'register.titleSuccess': '检查您的电子邮件',
    'register.subtitle': '加入 X-perences 创建者社区',
    'register.subtitleSuccess': '我们向您发送了验证链接',
    'register.alias': '别名',
    'register.aliasPlaceholder': '您的创建者别名',
    'register.passwordPlaceholder': '至少 6 个字符',
    'register.confirmPasswordPlaceholder': '确认您的密码',
    'register.acceptPrefix': '我已阅读并接受',
    'register.terms': '使用条款',
    'register.and': '和',
    'register.privacy': '隐私政策',
    'register.acceptSuffix': '。',
    'register.submit': '创建帐户',
    'register.successCreated': '账户创建成功！',
    'register.successCheckInbox': '请检查您的收件箱（和垃圾邮件文件夹）并单击验证链接以激活您的帐户。',
    'register.successEmailIssue': '您的帐户已创建，但暂时无法发送验证电子邮件。稍后使用登录后的重新发送验证按钮。',
    'register.successBackToLogin': '返回登录',
    'register.haveAccount': '已经有帐户？',
    'register.signIn': '登录',
    'register.error.passwordsMismatch': '密码不匹配',
    'register.error.passwordMin': '密码必须至少为 6 个字符',
    'register.error.acceptTerms': '您必须阅读并接受使用条款和隐私政策',
    'register.error.generic': '注册失败',
    'forgot.title': '重置密码',
    'forgot.subtitle': '输入您的电子邮件以接收重置链接',
    'forgot.submit': '发送重置链接',
    'forgot.success': '检查您的电子邮件中是否有密码重置链接。',
    'forgot.devMode': '开发模式：',
    'forgot.devGoReset': '前往重置密码',
    'forgot.remember': '还记得您的密码吗？',
    'forgot.error.generic': '发送重置邮件失败',
    'reset.title': '重置密码',
    'reset.subtitle': '输入您的新密码',
    'reset.newPassword': '新密码',
    'reset.confirmPassword': '确认密码',
    'reset.confirmPlaceholder': '确认您的新密码',
    'reset.submit': '重置密码',
    'reset.success': '密码重置成功！正在重定向至登录...',
    'reset.error.invalidLink': '重置链接无效',
    'reset.error.passwordsMismatch': '密码不匹配',
    'reset.error.passwordMin': '密码必须至少为 6 个字符',
    'reset.error.invalidToken': '重置令牌无效',
    'reset.error.generic': '重置密码失败',
    'verify.title': '电子邮件验证',
    'verify.loading': '正在验证您的电子邮件...',
    'verify.successLine1': '您的邮箱已验证成功！',
    'verify.successLine2': '您现在可以登录您的帐户。',
    'verify.redirecting': '正在重定向至登录...',
    'verify.alreadyLine1': '您的电子邮件已被验证！',
    'verify.alreadyLine2': '您可以登录您的帐户。',
    'verify.goLogin': '前往登录',
    'verify.error.noToken': '未提供验证令牌',
    'verify.error.generic': '验证失败',
    'navbar.subtitle': '创作者门户',
    'navbar.dashboard': '仪表板',
    'navbar.modXperiences': '模组。经验',
    'navbar.manageCreators': '管理创作者',
    'navbar.newXperience': '新体验',
    'navbar.generateCreators': '产生创造者',
    'navbar.generateXperiences': '产生经验',
    'navbar.generate': '生成',
    'navbar.generating': '生成',
    'navbar.profile': '公司简介',
    'navbar.logout': '退出',
    'navbar.confirmGenerateCreators': '您确定要生成创建者 JSON 吗？',
    'navbar.confirmGenerateXperiences': '您确定要生成体验 JSON 吗？',
    'navbar.successGenerateCreators': '创建者生成成功！',
    'navbar.successGenerateXperiences': '经验生成成功！',
    'navbar.error.endpoint': '未找到端点。 API 服务可能需��重新启动。',
    'navbar.error.noBody': '无响应体',
    'navbar.error.generateCreators': '生成创建者失败',
    'navbar.error.generateXperiences': '无法生成经验',
    'navbar.roleDefault': '创作者',
    'navbar.statusPending': '待定',
    'navbar.statusTitle': '状态',
    'navbar.totalViews': '总观看次数',
    'navbar.avgRating': '平均评分',
    'navbar.roleTitle': '角色',
    'navbar.languageLabel': '语言',
    'navbar.lang.en': '英语',
    'navbar.lang.es': '西班牙语',
    'locale.en': '英语',
    'locale.zhHk': '中文（香港）',
    'locale.zhHans': '简体中文',
    'locale.zhHant': '中文、繁体',
    'locale.enAu': '英语（澳大利亚）',
    'locale.enGb': '英语（英国）',
    'locale.fr': '法语',
    'locale.frCa': '法语（加拿大）',
    'locale.de': '德语',
    'locale.ja': '日语',
    'locale.es': '西班牙语',
    'home.profileIncomplete': '请在管理体验之前填写您的个人资料',
    'home.error.load': '无法加载经验',
    'home.title': '您的经验',
    'home.subtitle': '管理 Apple Vision Pro 的沉浸式内容',
    'home.newXperience': '+ 新体验',
    'home.searchPlaceholder': '按标题或描述搜索...',
    'home.clearSearch': '清除搜索',
    'home.allMediaTypes': '所有媒体类型',
    'home.loading': '正在加载经验...',
    'home.emptyTitle': '还没有经验',
    'home.emptyText': '为 Apple Vision Pro 打造您的首次沉浸式体验',
    'home.createFirst': '创造第一体验',
    'home.noResultsTitle': '没有找到结果',
    'home.noResultsText': '尝试调整您的搜索条件或过滤器',
    'home.clearFilters': '清除过滤器',
    'home.privateTitle': '私人体验',
    'home.categoryTitle': '类别',
    'home.viewsTitle': '意见',
    'home.likesTitle': '喜欢',
    'home.dislikesTitle': '不喜欢',
    'home.ratingTitle': '评级',
    'home.viewDetails': '查看详情',
    'home.moreTags': '更多标签',
    'home.files': '文件',
    'home.filesPlural': '文件',
    'beCreator.title': '成为 X-perences 的创造者',
    'beCreator.subtitle': '分享 Apple Vision Pro 的沉浸式体验',
    'beCreator.point1': '发布您自己的经验并建立您的受众。',
    'beCreator.point2': '从仪表板跟踪观看次数、喜欢和评分。',
    'beCreator.point3': '从一个创作者门户管理媒体和更新。',
    'beCreator.ctaPrimary': '创建创建者帐户',
    'beCreator.ctaSecondary': '我已经有一个帐户',
    'beCreator.heroTitle': '成为创造者',
    'beCreator.heroSubtitle': '与世界分享您独特的 X 体验，将您的激情变成现实。',
    'beCreator.heroCta': '作为创作者加入',
    'beCreator.benefitsTitle': '为什么加入 X-perences？',
    'beCreator.benefit.audienceTitle': '吸引全球观众',
    'beCreator.benefit.audienceText': '与世界各地渴望发现���参与您的独特内容和 X 体验的用户建立联系。',
    'beCreator.benefit.recognitionTitle': '赢得认可',
    'beCreator.benefit.recognitionText': '通过分享激励世界各地用户的沉浸式故事来建立您作为创作者的声誉。',
    'beCreator.benefit.toolsTitle': '强大的创作者工具',
    'beCreator.benefit.toolsText': '访问为创作者量身定制的高级分析、无缝媒体管理和易于使用的发布工��。',
    'beCreator.benefit.communityTitle': '支持社区',
    'beCreator.benefit.communityText': '加入充满热情的创作者网络。在安全的环境中分享想法、协作并共同成长。',
    'beCreator.howItWorksTitle': '它是如何运作的',
    'beCreator.step.signupTitle': '注册',
    'beCreator.step.signupText': '只需点击几下即可创建您的创作者个人资料。',
    'beCreator.step.createTitle': '创建',
    'beCreator.step.createText': '上传您的内容并构建引人入胜的 X 体验。',
    'beCreator.step.recognizedTitle': '获得认可',
    'beCreator.step.recognizedText': '在全球分享您的经验，扩大您的受众，并成为沉浸式内容的参考创作者。',
    'beCreator.footerTitle': '准备好开始你的旅程了吗？',
    'beCreator.footerText': '迈出第一步，与世界分享沉浸式体验。',
    'beCreator.footerCta': '立即开始',
    'profile.loading': '正在加载个人资料...',
    'profile.title': '创作者简介',
    'profile.subtitle': '管理您的创作者信息',
    'profile.requiredFieldsLabel': '必填字段*：',
    'profile.requiredFieldsText': '访问 Xperiences 仪表板需要全名、头像、简历和国家/地区。',
    'profile.section.accountInfo': '账户信息',
    'profile.section.changePassword': '更改密码',
    'profile.section.personalInfo': '个人信息',
    'profile.section.appSocial': '应用程序和社交媒体',
    'profile.section.creatorStats': '创作者统计',
    'profile.field.usernameAlias': '用户名（别名）',
    'profile.field.currentPassword': '当前密码',
    'profile.field.newPassword': '新密码',
    'profile.field.confirmNewPassword': '确认新密码',
    'profile.field.fullNameRequired': '全名 *',
    'profile.field.phone': '电话',
    'profile.field.countryRequired': '国家*',
    'profile.field.avatarRequired': '头像 *',
    'profile.field.biographyRequired': '简历 *',
    'profile.field.appName': '应用程序名称',
    'profile.field.appUrl': '应用程序网址',
    'profile.field.youtubeUrl': 'YouTube 网址',
    'profile.field.instagramUrl': 'Instagram 网址',
    'profile.field.otherUrl': '其他网址',
    'profile.placeholder.username': '您的用户名',
    'profile.placeholder.currentPassword': '输入您当前的密码',
    'profile.placeholder.newPassword': '输入新密码',
    'profile.placeholder.confirmNewPassword': '确认新密码',
    'profile.placeholder.fullName': '你的全名',
    'profile.placeholder.phone': '+1 (555) 000-0000',
    'profile.placeholder.searchCountries': '输入以搜索国家/地区...',
    'profile.placeholder.biography': '告诉我们你自己...',
    'profile.placeholder.appName': '例如，我的应用程序',
    'profile.placeholder.appUrl': 'https://myapp.com',
    'profile.placeholder.youtubeUrl': 'https://youtube.com/@yourusername',
    'profile.placeholder.instagramUrl': 'https://instagram.com/你的用户名',
    'profile.placeholder.otherUrl': 'https://example.com',
    'profile.note.publicUsername': '您的公开用户名',
    'profile.note.emailImmutable': '个人资料中的电子邮件地址无法更改',
    'profile.note.passwordMin': '最少 6 个字符',
    'profile.note.requiredForDashboard': '需要访问仪表板',
    'profile.note.countryRequired': '需要访问仪表板 • 从列表中选择或键入要搜索的内容',
    'profile.note.avatarRequired': '访问仪表板需要 • JPG、PNG 或 GIF（最大 20MB）',
    'profile.note.biographyRequiredPrefix': '需要访问仪表板 •',
    'profile.note.characters': '人物',
    'profile.optional': '可选',
    'profile.allOptional': '全部可选',
    'profile.uploading': '正在上传...',
    'profile.uploadingAvatar': '正在上传头像...',
    'profile.chooseAvatarImage': '选择头像图片',
    'profile.avatarPreviewAlt': '头像预览',
    'profile.preview': '预览',
    'profile.openInNewTab': '在新选项卡中打开',
    'profile.view': '查看',
    'profile.stats.rating': '评级',
    'profile.stats.credits': '制作人员',
    'profile.stats.views': '意见',
    'profile.stats.votes': '投票数',
    'profile.saving': '正在保存...',
    'profile.saveChanges': '保存更改',
    'profile.success.profileAndPasswordUpdated': '个人资料和密码更新成功！',
    'profile.success.profileUpdatedComplete': '个人资料更新成功！所有必填字段均已填写。您现在可以访问 Xperiences 仪表板。',
    'profile.success.profileUpdatedIncomplete': '个人资料更新成功！请填写所有必填字段（姓名、头像、简历、国家/地区）以访问仪表板。',
    'profile.error.loadProfile': '无法加载配置文件',
    'profile.error.avatarUpload': '头像上传失败。个人资料未保存。',
    'profile.error.fillAllPasswordFields': '请填写所有密码字段以更改您的密码',
    'profile.error.passwordsMismatch': '新密码不匹配',
    'profile.error.passwordMin': '新密码必须至少 6 个字符',
    'profile.error.changePassword': '更改密码失败',
    'profile.error.profileUpdatedPasswordFailed': '个人资料已更新，但密码更改失败',
    'profile.error.updateProfile': '更新个人资料失败。请再试一次。',
    'adminCreators.title': '管理创作者',
    'adminCreators.loading': '正在加载创作者...',
    'adminCreators.error.load': '无法加载创建者',
    'adminCreators.error.roleUpdate': '更新角色失败',
    'adminCreators.error.statusUpdate': '更新状态失败',
    'adminCreators.error.trustUpdate': '无法更新信任标志',
    'adminCreators.success.roleUpdated': '角色更新成功！',
    'adminCreators.success.statusUpdated': '状态更新成功！',
    'adminCreators.success.trustUpdated': '信任标志更新成功！',
    'adminCreators.table.alias': '别名',
    'adminCreators.table.email': '电子邮件',
    'adminCreators.table.emailVerified': '电子邮件已验证',
    'adminCreators.table.hidden': '隐藏',
    'adminCreators.table.joinDate': '加入日期',
    'adminCreators.table.role': '角色',
    'adminCreators.table.status': '状态',
    'adminCreators.table.trusted': '值得信赖',
    'adminCreators.yes': '是的',
    'adminCreators.no': '否',
    'adminCreators.hidden': '隐藏',
    'adminCreators.visible': '可见',
    'adminCreators.trusted': '值得信赖',
    'adminCreators.standard': '标准型',
    'adminCreators.role.creator': '创作者',
    'adminCreators.role.manager': '经理',
    'adminCreators.role.administrator': '管理员',
    'adminCreators.status.pending': '待定',
    'adminCreators.status.approved': '已批准',
    'adminCreators.status.rejected': '禁止/拒绝',
    'adminCreators.empty': '��找到创作者。',
    'adminCreators.pagination.page': '页面',
    'adminCreators.pagination.of': '的',
    'adminCreators.pagination.total': '合计',
    'adminCreators.pagination.rowsPerPage': '每页行数',
    'adminCreators.pagination.previous': '上一页',
    'adminCreators.pagination.next': '下一步',
    'adminCreatorDetail.title': '编辑创建者：',
    'adminCreatorDetail.back': '返回',
    'adminCreatorDetail.id': '身份证号',
    'adminCreatorDetail.email': '电子邮件',
    'adminCreatorDetail.alias': '别名',
    'adminCreatorDetail.fullName': '全名',
    'adminCreatorDetail.phone': '电话',
    'adminCreatorDetail.countryCode': '国家/地区代码',
    'adminCreatorDetail.countryPlaceholder': '输入以搜索国家/地区...',
    'adminCreatorDetail.flags': '配置文件标志',
    'adminCreatorDetail.emailVerified': '电子邮件已验证',
    'adminCreatorDetail.resendEmail': '重新发送电子邮件',
    'adminCreatorDetail.sending': '正在发送...',
    'adminCreatorDetail.hideProfile': '隐藏个人资料（不完整）',
    'adminCreatorDetail.isTrusted': '值得信赖的创作者',
    'adminCreatorDetail.bio': '简介/描述',
    'adminCreatorDetail.linksApps': '链接和应用程序',
    'adminCreatorDetail.appName': '应用程序名称',
    'adminCreatorDetail.appUrl': '应用程序网址',
    'adminCreatorDetail.youtubeUrl': 'YouTube 网址',
    'adminCreatorDetail.instagramUrl': 'Instagram 网址',
    'adminCreatorDetail.otherUrl': '其他网址',
    'adminCreatorDetail.saveProfile': '保存个人资料',
    'adminCreatorDetail.saving': '正在保存...',
    'adminCreatorDetail.error.load': '无法加载创建者',
    'adminCreatorDetail.error.verificationSend': '无法发送验证电子邮件。',
    'adminCreatorDetail.error.update': '无法更新创建者',
    'adminCreatorDetail.success.verificationSent': '验证邮件发送成功。',
    'adminCreatorDetail.success.updated': '创建者更新成功',
    'moderation.back': '返回',
    'moderation.title.single': '调节体验内容',
    'moderation.title.global': '内容审核',
    'moderation.searchPlaceholder': '���标题、描述或创建者搜索...',
    'moderation.filter.allMedia': '所有媒体',
    'moderation.filter.pending': '待定',
    'moderation.filter.approved': '已批准',
    'moderation.filter.rejected': '被拒绝',
    'moderation.loading': '正在加载媒体...',
    'moderation.empty.search': '没有与您的搜索匹配的媒体。',
    'moderation.empty.filter': '没有找到适合所选过滤器的介质。',
    'moderation.noPoster': '无海报',
    'moderation.untitled': '无题',
    'moderation.noDescription': '无描述',
    'moderation.creator': '创作者',
    'moderation.email': '电子邮件',
    'moderation.date': '日期',
    'moderation.na': '不适用',
    'moderation.viewOriginal': '查看原始文件',
    'moderation.action.approve': '批准',
    'moderation.action.reject': '拒绝',
    'moderation.action.setPending': '设置待处理',
    'moderation.success.markedAs': '媒体成功标记为',
    'moderation.error.loadMedia': '加载媒体以进行审核时出错。',
    'moderation.error.updateStatus': '无法更新媒体状态。',
    'adminXperiences.backDashboard': '返回仪表板',
    'adminXperiences.title': '全球经验审核',
    'adminXperiences.searchPlaceholder': '按标题、描述或创建者搜索...',
    'adminXperiences.filter.all': '所有经历',
    'adminXperiences.filter.pending': '待定',
    'adminXperiences.filter.approved': '已批准',
    'adminXperiences.filter.rejected': '被拒绝',
    'adminXperiences.loading': '正在加载经验...',
    'adminXperiences.empty.search': '没有与您的搜索相符的经验。',
    'adminXperiences.empty.filter': '未找到所选过滤器的经验。',
    'adminXperiences.noPoster': '无海报',
    'adminXperiences.noDescription': '无描述',
    'adminXperiences.creator': '创作者',
    'adminXperiences.email': '电子邮件',
    'adminXperiences.date': '日期',
    'adminXperiences.na': '不适用',
    'adminXperiences.mediaCount': '媒体数',
    'adminXperiences.items': '项目',
    'adminXperiences.action.moderateMedia': '适度媒体',
    'adminXperiences.action.approveAll': '批准全部',
    'adminXperiences.action.rejectAll': '全部拒绝',
    'adminXperiences.action.setPending': '设置待处理',
    'adminXperiences.success.markedAs': 'Xperience 成功标记为',
    'adminXperiences.error.fetch': '获取经验失败',
    'adminXperiences.error.updateStatus': '更新状态失败',
    'createXperience.profileIncomplete': '请在创建体验之前填写您的个人资料',
    'createXperience.error.create': '无法创建体验',
    'createXperience.title': '创造新体验',
    'createXperience.subtitle': '开始构建您的沉浸式内容',
    'createXperience.field.title': '标题',
    'createXperience.placeholder.title': '体验标题',
    'createXperience.field.description': '描述',
    'createXperience.placeholder.description': '描述一下你的经历...',
    'createXperience.field.location': '地点',
    'createXperience.field.tags': '标签',
    'createXperience.copyLastLocation': '复制最后的位置',
    'createXperience.error.noLastLocation': '尚无可用的先前位置。',
    'createXperience.placeholder.tags': '选择或搜索标签...',
    'createXperience.help.tags': '选择一个或多个标签以提高发现率。',
    'createXperience.cancel': '取消',
    'createXperience.submit': '创造体验',
    'xperienceDetail.success.mediaOrderSaved': '媒体订单已成功保存。',
    'xperienceDetail.error.mediaOrderSave': '无法保存媒体订单。',
    'xperienceDetail.error.load': '无法加载体验',
    'xperienceDetail.success.updated': 'Xperience 更新成功。',
    'xperienceDetail.error.update': '更新体验失败',
    'xperienceDetail.sendingEmail': '正在发送电子邮件...',
    'xperienceDetail.success.emailSent': '二维码访问电子邮件发送成功。',
    'xperienceDetail.success.locationCopiedToAll': '位置已复制到 {count} 个媒体项。',
    'xperienceDetail.error.sendEmail': '发送二维码邮件失败。',
    'xperienceDetail.error.uploadMedia': '媒体上传失败',
    'xperienceDetail.error.deleteMedia': '删除媒体失败',
    'xperienceDetail.error.deleteXperience': '删除体验失败',
    'xperienceDetail.error.noLocationToCopyAll': '先设置一个位置，然后再将其复制到所有媒体。',
    'xperienceDetail.error.invalidLocationToCopyAll': '当前位置坐标无效。',
    'xperienceDetail.error.noMediaToCopyLocationAll': '在此体验中未找到可更新的媒体项目。',
    'xperienceDetail.error.locationCopiedToAllPartial': '更新了 {success} 媒体项，但 {failed} 失败。',
    'xperienceDetail.error.locationCopiedToAllFailed': '无法更新所有媒体的位置。',
    'xperienceDetail.loading': '正在加载经验...',
    'xperienceDetail.notFound': '未找到经验',
    'xperienceDetail.backDashboard': '返回仪表板',
    'xperienceDetail.editTitle': '编辑经验',
    'xperienceDetail.field.title': '标题',
    'xperienceDetail.field.description': '描述',
    'xperienceDetail.field.location': '地点',
    'xperienceDetail.field.tags': '标签',
    'xperienceDetail.copyLastLocation': '复制最后的位置',
    'xperienceDetail.copyLocationToAll': '将位置复制到所有媒体',
    'xperienceDetail.copyLocationToAllLoading': '复制到所有媒体...',
    'xperienceDetail.error.noLastLocation': '尚无可用的先前位置。',
    'xperienceDetail.success.lastLocationCopied': '复制的最后位置。',
    'xperienceDetail.placeholder.tags': '选择或搜索标签...',
    'xperienceDetail.help.tags': '选择一个或多个标签以提高发现率。',
    'xperienceDetail.privateToggle': '私人体验（需要密码）',
    'xperienceDetail.cancel': '取消',
    'xperienceDetail.saveChanges': '保存更改',
    'xperienceDetail.edit': '编辑',
    'xperienceDetail.deleteXperience': '删除体验',
    'xperienceDetail.info.status': '状态',
    'xperienceDetail.pending': '待定',
    'xperienceDetail.info.views': '意见',
    'xperienceDetail.info.rating': '评级',
    'xperienceDetail.info.reactions': '反应',
    'xperienceDetail.info.tags': '标签',
    'xperienceDetail.info.category': '类别',
    'xperienceDetail.info.created': '已创建',
    'xperienceDetail.noDate': '不适用',
    'xperienceDetail.info.mediaCount': '媒体数',
    'xperienceDetail.info.visibility': '能见度',
    'xperienceDetail.visibility.private': '私人',
    'xperienceDetail.visibility.public': '公共',
    'xperienceDetail.privateQR.title': '私人访问二维码',
    'xperienceDetail.privateQR.description': '分享此二维码或密码以授予对您的体验的私人访问权限。',
    'xperienceDetail.privateQR.alt': '私密��问二维码',
    'xperienceDetail.success.passwordCopied': '密码已复制到剪贴板。',
    'xperienceDetail.copyPassword': '复制密码',
    'xperienceDetail.wait': '等等',
    'xperienceDetail.emailQR': '电子邮件二维码',
    'xperienceDetail.mediaSectionTitle': '体验媒体',
    'xperienceDetail.createMedia': '+ 创建媒体',
    'xperienceDetail.uploading': '上传中',
    'xperienceDetail.noMedia': '尚未添加媒体。',
    'xperienceDetail.noMediaHelp': '还没有媒体文件。上传图像、视频或音频。',
    'xperienceDetail.mediaCard.added': '已添加',
    'xperienceDetail.mediaCard.na': '不适用',
    'xperienceDetail.mediaCard.viewDetails': '查看详情',
    'xperienceDetail.confirm.deleteMediaTitle': '删除媒体？',
    'xperienceDetail.confirm.deleteMediaMessage': '该媒体项目将被永久删除。此操作无法撤消。',
    'xperienceDetail.confirm.deleteXperienceTitle': '删除经验？',
    'xperienceDetail.confirm.deleteXperienceMessage': '此体验和所有相关媒体将被永久删除。此操作无法撤消。',
    'xperienceDetail.confirm.delete': '删除',
    'xperienceDetail.confirm.cancel': '取消',
    'xperienceDetail.confirm.copyLocationAllTitle': '将位置复制到所有媒体？',
    'xperienceDetail.confirm.copyLocationAllMessage': '这将更新此体验中所有媒体的位置坐标。继续？',
    'xperienceDetail.confirm.copyLocationAllConfirm': '是的，更新所有媒体',
    'xperienceDetail.confirm.copyLocationAllCancel': '取消',
    'xmedia.error.loadData': '加载数据失败',
    'xmedia.error.delete': '删除媒体失败',
    'xmedia.error.save': '无法保存 xperience 媒体',
    'xmedia.error.noXperienceLocation': '父体验还没有可以复制的位置。',
    'xmedia.error.noLastLocation': '尚无可用的先前位置。',
    'xmedia.error.requiredPrefix': '以下字段是必需的：',
    'xmedia.success.posterSelected': '海报是本地选择的。它将在保存时上传。',
    'xmedia.success.mediaSelected': '本地选择的媒体。它将在保存时上传。',
    'xmedia.success.deleted': '媒体删除成功！',
    'xmedia.success.created': 'Xperience 媒体已创建且文件已成功上传！',
    'xmedia.success.updated': 'Xperence 媒体更新成功！',
    'xmedia.success.locationCopied': '从 xperence 复制的位置。',
    'xmedia.success.lastLocationCopied': '复制的最后位置。',
    'xmedia.confirm.deleteMessage': '您确定要永久删除该媒体项目及其关联文件吗？此操作无法撤消。',
    'xmedia.loading': '正在加载体验媒体...',
    'xmedia.notFound': '未找到 Xperence 媒体',
    'xmedia.back': '返回',
    'xmedia.title.create': '创建新媒体',
    'xmedia.title.edit': '编辑体验媒体',
    'xmedia.subtitle': '更新该媒体项目的所有元数据和文件。',
    'xmedia.field.title': '标题',
    'xmedia.field.description': '描述',
    'xmedia.field.type': '类型',
    'xmedia.field.format': '格式',
    'xmedia.field.category': '类别',
    'xmedia.field.mediaFile': '媒体文件',
    'xmedia.field.posterUrl': '海报网址',
    'xmedia.field.order': '订单',
    'xmedia.field.runtime': '运行时',
    'xmedia.field.credits': '所需学分/积分',
    'xmedia.field.location': '地点',
    'xmedia.field.createdDate': '创建日期',
    'xmedia.placeholder.title': '输入标题',
    'xmedia.placeholder.description': '输入描述...',
    'xmedia.placeholder.mediaUrl': 'URL 将在保存时安全生成',
    'xmedia.placeholder.posterUrl': '保存时将生成海报路径',
    'xmedia.placeholder.order': '例如，1',
    'xmedia.placeholder.runtime': '例如，3600',
    'xmedia.placeholder.credits': '例如，0',
    'xmedia.selectFile': '选择文件',
    'xmedia.changeFile': '更改文件',
    'xmedia.viewMedia': '查看媒体',
    'xmedia.selectImage': '选择图像',
    'xmedia.changeImage': '更改图像',
    'xmedia.thumbnail': '缩略图',
    'xmedia.seconds': '秒',
    'xmedia.requiresDownload': '需要下载',
    'xmedia.isPublic': '是公开的',
    'xmedia.isPremium': '是高级版',
    'xmedia.hide': '隐藏',
    'xmedia.deleteMedia': '删除媒体',
    'xmedia.cancel': '取消',
    'xmedia.saving': '正在保存...',
    'xmedia.saveChanges': '保存更改',
    'xmedia.copyXperienceLocation': '复制体验位置',
    'xmedia.copyLastLocation': '复制最后的位置',
    'xmedia.copyLocationToAll': '将位置复制到所有媒体',
    'xmedia.copyLocationToAllLoading': '复制到所有媒体...',
    'xmedia.locationSource.xperience': '使用 xperience 主要位置',
    'xmedia.locationSource.last': '使用上次复制的位置',
    'xmedia.lastLocationPreview': '已保存最后位置',
    'xmedia.confirm.copyLocationAllTitle': '将位置复制到所有媒体？',
    'xmedia.confirm.copyLocationAllMessage': '这将更新此体验中所有媒体的位置坐标。继续？',
    'xmedia.confirm.copyLocationAllConfirm': '是的，更新所有媒体',
    'xmedia.confirm.copyLocationAllCancel': '取消',
    'xmedia.success.locationCopiedToAll': '位置已复制到 {count} 个媒体项。',
    'xmedia.error.noXperienceForBulkLocation': '找不到批量位置更新的父级体验。',
    'xmedia.error.noLocationToCopyAll': '先设置一个位置，然后再将其复制到所有媒体。',
    'xmedia.error.invalidLocationToCopyAll': '当前位置坐标无效。',
    'xmedia.error.noMediaToCopyLocationAll': '在此体验中未找到可更新的媒体项目。',
    'xmedia.error.locationCopiedToAllPartial': '更新了 {success} 媒体项，但 {failed} 失败。',
    'xmedia.error.locationCopiedToAllFailed': '无法更新所有媒体的位置。',
    'locationPicker.searchLabel': '搜寻地址',
    'locationPicker.searchPlaceholder': '输入地址、城市或地点',
    'locationPicker.longitude': '经度',
    'locationPicker.latitude': '纬度',
    'locationPicker.clear': '清晰的位置',
    'locationPicker.useCurrent': '使用我当前的位置',
    'locationPicker.locating': '正在定位...',
    'locationPicker.geoNotSupported': '您的浏览器不支持地理定位。',
    'locationPicker.geoError': '无法获取您的当前位置。检查浏览器权限。',
    'locationPicker.selectedAddress': '选定的地址',
    'locationPicker.loadingMap': '正在加载地图...',
    'locationPicker.noApiKey': 'Google 地图 API 密钥丢失',
    'locationPicker.noApiKeyHelp': '在前端环境中设置 REACT_APP_GOOGLE_MAPS_API_KEY 以启用地图和地址搜索。',
    'locationPicker.loadError': '无法加载 Google 地图',
  },
  'zh-Hant': {
    'common.loading': '加載中...',
    'common.email': '電子郵件',
    'common.password': '密碼',
    'common.confirmPassword': '確認密碼',
    'common.backToLogin': '返回登入',
    'common.signIn': '登入',
    'common.emailExample': 'Creator@example.com',
    'common.clearSearch': '清除搜尋',
    'login.title': '歡迎回來',
    'login.subtitle': '登入您的創作者帳戶',
    'login.passwordPlaceholder': '輸入您的密碼',
    'login.forgotPassword': '忘記密碼？',
    'login.submit': '登入',
    'login.createOne': '創建一個',
    'login.error.verifyEmail': '請在登入前驗證您的電子郵件。請檢查您的收件匣中的驗證連結。',
    'login.error.invalidCredentials': '電子郵件或密碼無效。',
    'login.resend.button': '重新發送驗證郵件',
    'login.resend.success': '如果您的帳戶存在且未經驗證，則會傳送一封新的驗證電子郵件。',
    'login.resend.error': '重新發送驗證郵件失敗。請稍後重試。',
    'login.resend.wait': '請稍等片刻，然後再要求另一封驗證電子郵件。',
    'login.resend.waitWithSeconds': '重新發送可用於',
    'register.title': '建立您的帳戶',
    'register.titleSuccess': '檢查您的電子郵件',
    'register.subtitle': '加入 X-perences 創作者社區',
    'register.subtitleSuccess': '我們向您發送了驗證鏈接',
    'register.alias': '別名',
    'register.aliasPlaceholder': '您的創建者別名',
    'register.passwordPlaceholder': '至少 6 個字符',
    'register.confirmPasswordPlaceholder': '確認您的密碼',
    'register.acceptPrefix': '我已閱讀並接受',
    'register.terms': '使用條款',
    'register.and': '和',
    'register.privacy': '隱私權���策',
    'register.acceptSuffix': '。',
    'register.submit': '建立帳戶',
    'register.successCreated': '帳戶創建成功！',
    'register.successCheckInbox': '請檢查您的收件匣（和垃圾郵件資料夾）並點擊驗證連結以啟動您的帳戶。',
    'register.successEmailIssue': '您的帳戶已創建，但暫時無法傳送驗證電子郵件。稍後使用登入後的重新發送驗證按鈕。',
    'register.successBackToLogin': '返回登入',
    'register.haveAccount': '已經有帳戶？',
    'register.signIn': '登入',
    'register.error.passwordsMismatch': '密碼不匹配',
    'register.error.passwordMin': '密碼必須至少為 6 個字符',
    'register.error.acceptTerms': '您必須閱讀並接受使用條款和隱私權政策',
    'register.error.generic': '註冊失敗',
    'forgot.title': '重設密碼',
    'forgot.subtitle': '輸入您的電子郵件以接收重置鏈接',
    'forgot.submit': '發送重置連結',
    'forgot.success': '檢查您的電子郵件中是否有密碼重設連結。',
    'forgot.devMode': '開發模式：',
    'forgot.devGoReset': '前往重置密碼',
    'forgot.remember': '還記得您的密碼嗎？',
    'forgot.error.generic': '發送重置郵件失敗',
    'reset.title': '重設密碼',
    'reset.subtitle': '輸入您的新密碼',
    'reset.newPassword': '新密碼',
    'reset.confirmPassword': '確認密碼',
    'reset.confirmPlaceholder': '確認您的新密碼',
    'reset.submit': '重設密碼',
    'reset.success': '密碼重置成功！正在重新導向至登入...',
    'reset.error.invalidLink': '重置連結無效',
    'reset.error.passwordsMismatch': '密碼不匹配',
    'reset.error.passwordMin': '密碼必須至少為 6 個字符',
    'reset.error.invalidToken': '重置令牌無效',
    'reset.error.generic': '重置密碼失敗',
    'verify.title': '電子郵件驗證',
    'verify.loading': '正在驗證您的電子郵件...',
    'verify.successLine1': '您的信箱已驗證成功！',
    'verify.successLine2': '您現在可以登入您的帳戶。',
    'verify.redirecting': '正在重新導向至登入...',
    'verify.alreadyLine1': '您的電子郵件已被驗證！',
    'verify.alreadyLine2': '您可以登入您的帳戶��',
    'verify.goLogin': '前往登入',
    'verify.error.noToken': '未提供驗證令牌',
    'verify.error.generic': '驗證失敗',
    'navbar.subtitle': '創作者門戶',
    'navbar.dashboard': '儀表板',
    'navbar.modXperiences': '模組。經驗',
    'navbar.manageCreators': '管理創作者',
    'navbar.newXperience': '新體驗',
    'navbar.generateCreators': '產生創造者',
    'navbar.generateXperiences': '產生經驗',
    'navbar.generate': '產生',
    'navbar.generating': '產生',
    'navbar.profile': '公司簡介',
    'navbar.logout': '退出',
    'navbar.confirmGenerateCreators': '您確定要產生建立者 JSON 嗎？',
    'navbar.confirmGenerateXperiences': '您確定要產生體驗 JSON 嗎？',
    'navbar.successGenerateCreators': '創建者生成成功！',
    'navbar.successGenerateXperiences': '經驗生成成功！',
    'navbar.error.endpoint': '未找到端點。 API 服務可能需要重新啟動。',
    'navbar.error.noBody': '無響應體',
    'navbar.error.generateCreators': '生成創建者失敗',
    'navbar.error.generateXperiences': '無法產生經驗',
    'navbar.roleDefault': '創作者',
    'navbar.statusPending': '待定',
    'navbar.statusTitle': '狀態',
    'navbar.totalViews': '總觀看次數',
    'navbar.avgRating': '平均評分',
    'navbar.roleTitle': '角色',
    'navbar.languageLabel': '語言',
    'navbar.lang.en': '英語',
    'navbar.lang.es': '西班牙語',
    'locale.en': '英語',
    'locale.zhHk': '中文（香港）',
    'locale.zhHans': '簡體中文',
    'locale.zhHant': '中文、繁體',
    'locale.enAu': '英語（澳洲）',
    'locale.enGb': '英語（英國）',
    'locale.fr': '法語',
    'locale.frCa': '法語（加拿大）',
    'locale.de': '德文',
    'locale.ja': '日語',
    'locale.es': '西班牙語',
    'home.profileIncomplete': '請在管理體驗之前填寫您的個人資料',
    'home.error.load': '無法加載經驗',
    'home.title': '您的經驗',
    'home.subtitle': '管理 Apple Vision Pro 的沉浸式內容',
    'home.newXperience': '+ ��體驗',
    'home.searchPlaceholder': '按標題或描述搜尋...',
    'home.clearSearch': '清除搜尋',
    'home.allMediaTypes': '所有媒體類型',
    'home.loading': '正在加載經驗...',
    'home.emptyTitle': '還沒有經驗',
    'home.emptyText': '為 Apple Vision Pro 打造您的首次沉浸式體驗',
    'home.createFirst': '創造第一體驗',
    'home.noResultsTitle': '沒有找到結果',
    'home.noResultsText': '嘗試調整您的搜尋條件或篩選器',
    'home.clearFilters': '清除過濾器',
    'home.privateTitle': '私人體驗',
    'home.categoryTitle': '類別',
    'home.viewsTitle': '意見',
    'home.likesTitle': '喜歡',
    'home.dislikesTitle': '不喜歡',
    'home.ratingTitle': '評級',
    'home.viewDetails': '看詳情',
    'home.moreTags': '更多標籤',
    'home.files': '文件',
    'home.filesPlural': '文件',
    'beCreator.title': '成為 X-perences 的創造者',
    'beCreator.subtitle': '分享 Apple Vision Pro 的沉浸式體驗',
    'beCreator.point1': '發布您自己的經驗並建立您的受眾。',
    'beCreator.point2': '從儀表板追蹤觀看次數、喜歡和評分。',
    'beCreator.point3': '從一個創作者入口網站管理媒體和更新。',
    'beCreator.ctaPrimary': '建立創建者帳戶',
    'beCreator.ctaSecondary': '我已經有一個帳戶',
    'beCreator.heroTitle': '成為創造者',
    'beCreator.heroSubtitle': '與世界分享您獨特的 X 體驗，將您的熱情變成現實。',
    'beCreator.heroCta': '作為創作者加入',
    'beCreator.benefitsTitle': '為什麼要加入 X-perences？',
    'beCreator.benefit.audienceTitle': '吸引全球觀眾',
    'beCreator.benefit.audienceText': '與世界各地渴望發現並參與您的獨特內容和 X 體驗���用戶建立聯繫。',
    'beCreator.benefit.recognitionTitle': '贏得認可',
    'beCreator.benefit.recognitionText': '透過分享激勵世界各地用戶的沉浸式故事來建立您作為創作者的聲譽。',
    'beCreator.benefit.toolsTitle': '強大的創作者工具',
    'beCreator.benefit.toolsText': '存取為創作者量身定制的高級分析、無縫媒體管理和易於使用的發布工具。',
    'beCreator.benefit.communityTitle': '支持社區',
    'beCreator.benefit.communityText': '加入充滿熱情的創作者網絡。在安全的環境中分享想法、協作並共同成長。',
    'beCreator.howItWorksTitle': '它是如何運作的',
    'beCreator.step.signupTitle': '註冊',
    'beCreator.step.signupText': '只需點擊幾下即可建立您的創作者個人資料。',
    'beCreator.step.createTitle': '創建',
    'beCreator.step.createText': '上傳您的內容並建立引人入勝的 X 體驗。',
    'beCreator.step.recognizedTitle': '獲得認可',
    'beCreator.step.recognizedText': '在全球分享您的經驗，擴大您的受眾，並成為沉浸式內容的參考創作者。',
    'beCreator.footerTitle': '準備好開始你的旅程了嗎？',
    'beCreator.footerText': '踏出第一步，與世界分享沉浸式體驗。',
    'beCreator.footerCta': '立即開始',
    'profile.loading': '正在載入個人資料...',
    'profile.title': '創作者簡介',
    'profile.subtitle': '管理您的創作者訊息',
    'profile.requiredFieldsLabel': '必填欄位*：',
    'profile.requiredFieldsText': '存取 Xperiences 儀表板需要全名、頭像、簡歷和國家。',
    'profile.section.accountInfo': '帳號資訊',
    'profile.section.changePassword': '更改密碼',
    'profile.section.personalInfo': '個人資訊',
    'profile.section.appSocial': '應用程式和社交媒體',
    'profile.section.creatorStats': '創作者統計',
    'profile.field.usernameAlias': '使用者名稱（別名）',
    'profile.field.currentPassword': '目前密碼',
    'profile.field.newPassword': '新密碼',
    'profile.field.confirmNewPassword': '確認新密碼',
    'profile.field.fullNameRequired': '全名 *',
    'profile.field.phone': '電話',
    'profile.field.countryRequired': '國家*',
    'profile.field.avatarRequired': '頭像 *',
    'profile.field.biographyRequired': '簡歷 *',
    'profile.field.appName': '應用程式名稱',
    'profile.field.appUrl': '應用程式網址',
    'profile.field.youtubeUrl': 'YouTube 網址',
    'profile.field.instagramUrl': 'Instagram 網址',
    'profile.field.otherUrl': '其他網址',
    'profile.placeholder.username': '您的使用者名稱',
    'profile.placeholder.currentPassword': '輸入您目前的密碼',
    'profile.placeholder.newPassword': '輸入新密碼',
    'profile.placeholder.confirmNewPassword': '確認新密碼',
    'profile.placeholder.fullName': '你的全名',
    'profile.placeholder.phone': '+1 (555) 000-0000',
    'profile.placeholder.searchCountries': '輸入以搜尋國家/地區...',
    'profile.placeholder.biography': '告訴我們你自己...',
    'profile.placeholder.appName': '例如，我的應用程式',
    'profile.placeholder.appUrl': 'https://myapp.com',
    'profile.placeholder.youtubeUrl': 'https://youtube.com/@yourusername',
    'profile.placeholder.instagramUrl': 'https://instagram.com/你的用戶名',
    'profile.placeholder.otherUrl': 'https://example.com',
    'profile.note.publicUsername': '您的公開用戶名',
    'profile.note.emailImmutable': '個人資料中的電子郵件地址無法更改',
    'profile.note.passwordMin': '最少 6 個字符',
    'profile.note.requiredForDashboard': '需要訪問儀表板',
    'profile.note.countryRequired': '需要存取儀表板 • 從清單中選擇或鍵入要搜尋的內容',
    'profile.note.avatarRequired': '存取儀表板需要 • JPG、PNG 或 GIF（最大 20MB）',
    'profile.note.biographyRequiredPrefix': '需要存取儀表板 •',
    'profile.note.characters': '人物',
    'profile.optional': '可選',
    'profile.allOptional': '全部可選',
    'profile.uploading': '正在上傳...',
    'profile.uploadingAvatar': '正在上傳頭像...',
    'profile.chooseAvatarImage': '選擇頭像圖片',
    'profile.avatarPreviewAlt': '頭像預覽',
    'profile.preview': '預覽',
    'profile.openInNewTab': '在新分頁中開啟',
    'profile.view': '查看',
    'profile.stats.rating': '評級',
    'profile.stats.credits': '製作人員',
    'profile.stats.views': '意見',
    'profile.stats.votes': '投票數',
    'profile.saving': '正在儲存...',
    'profile.saveChanges': '儲存變更',
    'profile.success.profileAndPasswordUpdated': '個人資料和密碼更新成功！',
    'profile.success.profileUpdatedComplete': '個人資料更新成功！所有必填欄位均已填寫。您現在可以存取 Xperiences 儀表板。',
    'profile.success.profileUpdatedIncomplete': '個人資料更新成功！請填寫所有必填欄位（姓名、頭像、履歷、國家/地區）以存取儀表板。',
    'profile.error.loadProfile': '無法載入設定檔',
    'profile.error.avatarUpload': '頭像上傳失敗。個人資料未儲存。',
    'profile.error.fillAllPasswordFields': '請填寫所有密碼欄位以更改您的密碼',
    'profile.error.passwordsMismatch': '新密碼不匹配',
    'profile.error.passwordMin': '新密碼必須至少 6 個字符',
    'profile.error.changePassword': '更改密碼失敗',
    'profile.error.profileUpdatedPasswordFailed': '個人資料已更新，但密碼變更失敗',
    'profile.error.updateProfile': '更新個人資料失敗。請再試一次。',
    'adminCreators.title': '管理創作者',
    'adminCreators.loading': '正在加載創作者...',
    'adminCreators.error.load': '無法載入創建者',
    'adminCreators.error.roleUpdate': '更新角色失敗',
    'adminCreators.error.statusUpdate': '更新狀態失敗',
    'adminCreators.error.trustUpdate': '無法更新信任標誌',
    'adminCreators.success.roleUpdated': '角色更新成功！',
    'adminCreators.success.statusUpdated': '狀態更新成功！',
    'adminCreators.success.trustUpdated': '信任標誌更新成功！',
    'adminCreators.table.alias': '別名',
    'adminCreators.table.email': '電子郵件',
    'adminCreators.table.emailVerified': '電子郵件已驗證',
    'adminCreators.table.hidden': '隱藏',
    'adminCreators.table.joinDate': '加入日期',
    'adminCreators.table.role': '角色',
    'adminCreators.table.status': '狀態',
    'adminCreators.table.trusted': '值得信賴',
    'adminCreators.yes': '是的',
    'adminCreators.no': '否',
    'adminCreators.hidden': '隱藏',
    'adminCreators.visible': '可見',
    'adminCreators.trusted': '值得信賴',
    'adminCreators.standard': '標準型',
    'adminCreators.role.creator': '創作者',
    'adminCreators.role.manager': '主管',
    'adminCreators.role.administrator': '管理員',
    'adminCreators.status.pending': '待定',
    'adminCreators.status.approved': '已批准',
    'adminCreators.status.rejected': '禁止/拒絕',
    'adminCreators.empty': '未找到創作者。',
    'adminCreators.pagination.page': '頁面',
    'adminCreators.pagination.of': '的',
    'adminCreators.pagination.total': '合計',
    'adminCreators.pagination.rowsPerPage': '每頁行數',
    'adminCreators.pagination.previous': '上一頁',
    'adminCreators.pagination.next': '下一步',
    'adminCreatorDetail.title': '編輯創建者：',
    'adminCreatorDetail.back': '返回',
    'adminCreatorDetail.id': '身分證號',
    'adminCreatorDetail.email': '電子郵件',
    'adminCreatorDetail.alias': '別名',
    'adminCreatorDetail.fullName': '全名',
    'adminCreatorDetail.phone': '電話',
    'adminCreatorDetail.countryCode': '國家/地區代碼',
    'adminCreatorDetail.countryPlaceholder': '輸入以搜尋國家/地區...',
    'adminCreatorDetail.flags': '設定檔標誌',
    'adminCreatorDetail.emailVerified': '電子郵件已驗證',
    'adminCreatorDetail.resendEmail': '重新發送電子郵件',
    'adminCreatorDetail.sending': '正在發送...',
    'adminCreatorDetail.hideProfile': '隱藏個人資料（不完整）',
    'adminCreatorDetail.isTrusted': '值得信賴的創作者',
    'adminCreatorDetail.bio': '簡介/描述',
    'adminCreatorDetail.linksApps': '連結和應用程式',
    'adminCreatorDetail.appName': '應用程式名稱',
    'adminCreatorDetail.appUrl': '應用程式網址',
    'adminCreatorDetail.youtubeUrl': 'YouTube 網址',
    'adminCreatorDetail.instagramUrl': 'Instagram 網址',
    'adminCreatorDetail.otherUrl': '其他網址',
    'adminCreatorDetail.saveProfile': '儲存個人資料',
    'adminCreatorDetail.saving': '正在儲存...',
    'adminCreatorDetail.error.load': '無法載入創建者',
    'adminCreatorDetail.error.verificationSend': '無法傳送驗證電子郵件。',
    'adminCreatorDetail.error.update': '無法更新創建者',
    'adminCreatorDetail.success.verificationSent': '驗證郵件發送成功。',
    'adminCreatorDetail.success.updated': '創建者更新成功',
    'moderation.back': '返回',
    'moderation.title.single': '調節體驗內容',
    'moderation.title.global': '內容審核',
    'moderation.searchPlaceholder': '按標題、描述或建立者搜尋...',
    'moderation.filter.allMedia': '所有媒體',
    'moderation.filter.pending': '待定',
    'moderation.filter.approved': '已批准',
    'moderation.filter.rejected': '被拒絕',
    'moderation.loading': '正在加載媒體...',
    'moderation.empty.search': '沒有與您的搜尋相符的媒體。',
    'moderation.empty.filter': '沒有找到適合所選過濾器的媒體。',
    'moderation.noPoster': '無海報',
    'moderation.untitled': '無題',
    'moderation.noDescription': '無描述',
    'moderation.creator': '創作者',
    'moderation.email': '電子郵件',
    'moderation.date': '日期',
    'moderation.na': '不適用',
    'moderation.viewOriginal': '查看原始文件',
    'moderation.action.approve': '核准',
    'moderation.action.reject': '拒絕',
    'moderation.action.setPending': '設定待處理',
    'moderation.success.markedAs': '媒體成功標記為',
    'moderation.error.loadMedia': '載入媒體以進行審核時出錯。',
    'moderation.error.updateStatus': '無法更新媒體狀態。',
    'adminXperiences.backDashboard': '返回儀表板',
    'adminXperiences.title': '全球經驗審核',
    'adminXperiences.searchPlaceholder': '按標題、描述或建立者搜尋...',
    'adminXperiences.filter.all': '所有經歷',
    'adminXperiences.filter.pending': '待定',
    'adminXperiences.filter.approved': '已批准',
    'adminXperiences.filter.rejected': '被拒絕',
    'adminXperiences.loading': '正在加載經驗...',
    'adminXperiences.empty.search': '沒有與您的搜尋相符的經驗。',
    'adminXperiences.empty.filter': '未找到所選過濾器的經驗。',
    'adminXperiences.noPoster': '無海報',
    'adminXperiences.noDescription': '無描述',
    'adminXperiences.creator': '創作者',
    'adminXperiences.email': '電子郵件',
    'adminXperiences.date': '日期',
    'adminXperiences.na': '不適用',
    'adminXperiences.mediaCount': '媒體數',
    'adminXperiences.items': '專案',
    'adminXperiences.action.moderateMedia': '適度媒體',
    'adminXperiences.action.approveAll': '批准全部',
    'adminXperiences.action.rejectAll': '全部拒絕',
    'adminXperiences.action.setPending': '設定待處理',
    'adminXperiences.success.markedAs': 'Xperience 成功標記為',
    'adminXperiences.error.fetch': '取得經驗失敗',
    'adminXperiences.error.updateStatus': '更新狀態失敗',
    'createXperience.profileIncomplete': '請在創建體驗之前填寫您的個人資料',
    'createXperience.error.create': '無法創造體驗',
    'createXperience.title': '創造新體驗',
    'createXperience.subtitle': '開始建立您的沉浸式內容',
    'createXperience.field.title': '標題',
    'createXperience.placeholder.title': '體驗標題',
    'createXperience.field.description': '描述',
    'createXperience.placeholder.description': '描述一下你的經歷...',
    'createXperience.field.location': '地點',
    'createXperience.field.tags': '標籤',
    'createXperience.copyLastLocation': '複製最後的位置',
    'createXperience.error.noLastLocation': '尚無可用的先前位置。',
    'createXperience.placeholder.tags': '選擇或搜尋標籤...',
    'createXperience.help.tags': '選擇一個或多個標籤以提高發現率。',
    'createXperience.cancel': '取消',
    'createXperience.submit': '創造體驗',
    'xperienceDetail.success.mediaOrderSaved': '媒體訂單已成功保存。',
    'xperienceDetail.error.mediaOrderSave': '無法儲存媒體訂單。',
    'xperienceDetail.error.load': '無法載入體驗',
    'xperienceDetail.success.updated': 'Xperience 更新成功。',
    'xperienceDetail.error.update': '更新體驗失敗',
    'xperienceDetail.sendingEmail': '正在發送電子郵件...',
    'xperienceDetail.success.emailSent': '二維碼存取電子郵件發送成功。',
    'xperienceDetail.success.locationCopiedToAll': '位置已複製到 {count} 個媒體項目。',
    'xperienceDetail.error.sendEmail': '發送二維碼郵件失敗。',
    'xperienceDetail.error.uploadMedia': '媒體上傳失敗',
    'xperienceDetail.error.deleteMedia': '刪除媒體失敗',
    'xperienceDetail.error.deleteXperience': '刪除體驗失敗',
    'xperienceDetail.error.noLocationToCopyAll': '先設定一個位置，然後再複製到所有媒體。',
    'xperienceDetail.error.invalidLocationToCopyAll': '目前位置座標無效。',
    'xperienceDetail.error.noMediaToCopyLocationAll': '在此體驗中未找到可更新的媒體項目。',
    'xperienceDetail.error.locationCopiedToAllPartial': '更新了 {success} 媒體項，但 {failed} 失敗。',
    'xperienceDetail.error.locationCopiedToAllFailed': '無法更新所有媒體的位置。',
    'xperienceDetail.loading': '正在加載經驗...',
    'xperienceDetail.notFound': '未找到經驗',
    'xperienceDetail.backDashboard': '返回儀表板',
    'xperienceDetail.editTitle': '編輯經驗',
    'xperienceDetail.field.title': '標題',
    'xperienceDetail.field.description': '描述',
    'xperienceDetail.field.location': '地點',
    'xperienceDetail.field.tags': '標籤',
    'xperienceDetail.copyLastLocation': '複製最後的位置',
    'xperienceDetail.copyLocationToAll': '將位置複製到所有媒體',
    'xperienceDetail.copyLocationToAllLoading': '複製到所有媒體...',
    'xperienceDetail.error.noLastLocation': '尚無可用的先前位置。',
    'xperienceDetail.success.lastLocationCopied': '複製的最後位置。',
    'xperienceDetail.placeholder.tags': '選擇或搜尋標籤...',
    'xperienceDetail.help.tags': '選擇一個或多個標籤以提高發現率。',
    'xperienceDetail.privateToggle': '私人體驗（需要密碼）',
    'xperienceDetail.cancel': '取消',
    'xperienceDetail.saveChanges': '儲存變更',
    'xperienceDetail.edit': '編輯',
    'xperienceDetail.deleteXperience': '刪除體驗',
    'xperienceDetail.info.status': '狀態',
    'xperienceDetail.pending': '待定',
    'xperienceDetail.info.views': '意見',
    'xperienceDetail.info.rating': '評級',
    'xperienceDetail.info.reactions': '反應',
    'xperienceDetail.info.tags': '標籤',
    'xperienceDetail.info.category': '類別',
    'xperienceDetail.info.created': '已創建',
    'xperienceDetail.noDate': '不適用',
    'xperienceDetail.info.mediaCount': '媒體數',
    'xperienceDetail.info.visibility': '能見度',
    'xperienceDetail.visibility.private': '私人',
    'xperienceDetail.visibility.public': '公有',
    'xperienceDetail.privateQR.title': '私人訪問二維碼',
    'xperienceDetail.privateQR.description': '分享此二維碼或密碼以授予對您的體驗的私人存取權限。',
    'xperienceDetail.privateQR.alt': '私密訪問二維碼',
    'xperienceDetail.success.passwordCopied': '密碼已複製到剪貼簿。',
    'xperienceDetail.copyPassword': '複製密碼',
    'xperienceDetail.wait': '等等',
    'xperienceDetail.emailQR': '電子郵件二維碼',
    'xperienceDetail.mediaSectionTitle': '體驗媒體',
    'xperienceDetail.createMedia': '+ 建立媒體',
    'xperienceDetail.uploading': '上傳中',
    'xperienceDetail.noMedia': '尚未添加媒體。',
    'xperienceDetail.noMediaHelp': '還沒有媒體檔。上傳圖像、影片或音訊。',
    'xperienceDetail.mediaCard.added': '已新增',
    'xperienceDetail.mediaCard.na': '不適用',
    'xperienceDetail.mediaCard.viewDetails': '看詳情',
    'xperienceDetail.confirm.deleteMediaTitle': '刪除媒體？',
    'xperienceDetail.confirm.deleteMediaMessage': '該媒體項目將永久刪除。此操作無法撤銷。',
    'xperienceDetail.confirm.deleteXperienceTitle': '刪除經驗？',
    'xperienceDetail.confirm.deleteXperienceMessage': '此體驗和所有相關媒體將永久刪除。此操作無法撤銷。',
    'xperienceDetail.confirm.delete': '刪除',
    'xperienceDetail.confirm.cancel': '取消',
    'xperienceDetail.confirm.copyLocationAllTitle': '將位置複製到所有媒體？',
    'xperienceDetail.confirm.copyLocationAllMessage': '這將更新此體驗中所有媒體的位置座標。繼續？',
    'xperienceDetail.confirm.copyLocationAllConfirm': '是的，更新所有媒體',
    'xperienceDetail.confirm.copyLocationAllCancel': '取消',
    'xmedia.error.loadData': '載入資料失敗',
    'xmedia.error.delete': '刪除媒體失敗',
    'xmedia.error.save': '無法儲存 xperience 媒體',
    'xmedia.error.noXperienceLocation': '父體驗還沒有可以複製的位置。',
    'xmedia.error.noLastLocation': '尚無可用的先前位置。',
    'xmedia.error.requiredPrefix': '以下欄位是必要的：',
    'xmedia.success.posterSelected': '海報是本地選擇的。它將在保存時上傳。',
    'xmedia.success.mediaSelected': '本地選擇的媒體。它將在保存時上傳。',
    'xmedia.success.deleted': '媒體刪除成功！',
    'xmedia.success.created': 'Xperience 媒體已建立且檔案已成功上傳！',
    'xmedia.success.updated': 'Xperence 媒體更新成功！',
    'xmedia.success.locationCopied': '從 xperence 複製的位置。',
    'xmedia.success.lastLocationCopied': '複製的最後位置。',
    'xmedia.confirm.deleteMessage': '您確定要永久刪除該媒體項目及其關聯檔案嗎？此操作無法撤銷。',
    'xmedia.loading': '正在加載體驗媒體...',
    'xmedia.notFound': '未找到 Xperence 媒體',
    'xmedia.back': '返回',
    'xmedia.title.create': '創造新媒體',
    'xmedia.title.edit': '編輯體驗媒體',
    'xmedia.subtitle': '更新該媒體項目的所有元資料和檔案。',
    'xmedia.field.title': '標題',
    'xmedia.field.description': '描述',
    'xmedia.field.type': '類型',
    'xmedia.field.format': '格式',
    'xmedia.field.category': '類別',
    'xmedia.field.mediaFile': '媒體檔案',
    'xmedia.field.posterUrl': '海報網址',
    'xmedia.field.order': '訂單',
    'xmedia.field.runtime': '運行時',
    'xmedia.field.credits': '所需學分/積分',
    'xmedia.field.location': '地點',
    'xmedia.field.createdDate': '建立日期',
    'xmedia.placeholder.title': '輸入標題',
    'xmedia.placeholder.description': '輸入描述...',
    'xmedia.placeholder.mediaUrl': 'URL 將在儲存時安全地生成',
    'xmedia.placeholder.posterUrl': '儲存時將產生海報路徑',
    'xmedia.placeholder.order': '例如，1',
    'xmedia.placeholder.runtime': '例如，3600',
    'xmedia.placeholder.credits': '例如，0',
    'xmedia.selectFile': '選擇文件',
    'xmedia.changeFile': '更改文件',
    'xmedia.viewMedia': '查看媒體',
    'xmedia.selectImage': '選擇影像',
    'xmedia.changeImage': '更改圖像',
    'xmedia.thumbnail': '縮圖',
    'xmedia.seconds': '秒',
    'xmedia.requiresDownload': '需要下載',
    'xmedia.isPublic': '是公開的',
    'xmedia.isPremium': '是高級版',
    'xmedia.hide': '隱藏',
    'xmedia.deleteMedia': '刪除媒體',
    'xmedia.cancel': '取消',
    'xmedia.saving': '正在儲存...',
    'xmedia.saveChanges': '儲存變更',
    'xmedia.copyXperienceLocation': '複製體驗位置',
    'xmedia.copyLastLocation': '複製最後的位置',
    'xmedia.copyLocationToAll': '將位置複製到所有媒體',
    'xmedia.copyLocationToAllLoading': '複製到所有媒體...',
    'xmedia.locationSource.xperience': '使用 xperience 主要位置',
    'xmedia.locationSource.last': '使用上次複製的位置',
    'xmedia.lastLocationPreview': '已儲存最後位置',
    'xmedia.confirm.copyLocationAllTitle': '將位置複製到所有媒體？',
    'xmedia.confirm.copyLocationAllMessage': '這將更新此體驗中所有媒體的位置座標。繼續？',
    'xmedia.confirm.copyLocationAllConfirm': '是的，更新所有媒體',
    'xmedia.confirm.copyLocationAllCancel': '取消',
    'xmedia.success.locationCopiedToAll': '位置已複製到 {count} 個媒體項目。',
    'xmedia.error.noXperienceForBulkLocation': '找不到批次位置更新的父級體驗。',
    'xmedia.error.noLocationToCopyAll': '先設定一個位置，然後再複製到所有媒體。',
    'xmedia.error.invalidLocationToCopyAll': '目前位置座標無效。',
    'xmedia.error.noMediaToCopyLocationAll': '在此體驗中未找到可更新的媒體項目。',
    'xmedia.error.locationCopiedToAllPartial': '更新了 {success} 媒體項，但 {failed} 失敗。',
    'xmedia.error.locationCopiedToAllFailed': '無法更新所有媒體的位置。',
    'locationPicker.searchLabel': '搜尋地址',
    'locationPicker.searchPlaceholder': '輸入地址、城市或地點',
    'locationPicker.longitude': '經度',
    'locationPicker.latitude': '緯度',
    'locationPicker.clear': '清晰的位置',
    'locationPicker.useCurrent': '使用我目前的位置',
    'locationPicker.locating': '正在定位...',
    'locationPicker.geoNotSupported': '您的瀏覽器不支援地理定位。',
    'locationPicker.geoError': '無法取得您的目前位置。檢查瀏覽器權限。',
    'locationPicker.selectedAddress': '選定的地址',
    'locationPicker.loadingMap': '正在加載地圖...',
    'locationPicker.noApiKey': 'Google 地圖 API 金鑰遺失',
    'locationPicker.noApiKeyHelp': '在前端環境中設定 REACT_APP_GOOGLE_MAPS_API_KEY 以啟用地圖和位址搜尋。',
    'locationPicker.loadError': '無法加載 Google 地圖',
  },
  'zh-HK': {
    'common.loading': '加載中...',
    'common.email': '電子郵件',
    'common.password': '密碼',
    'common.confirmPassword': '確認密碼',
    'common.backToLogin': '返回登入',
    'common.signIn': '登入',
    'common.emailExample': 'Creator@example.com',
    'common.clearSearch': '清除搜尋',
    'login.title': '歡迎回來',
    'login.subtitle': '登入您的創作者帳戶',
    'login.passwordPlaceholder': '輸入您的密碼',
    'login.forgotPassword': '忘記密碼？',
    'login.submit': '登入',
    'login.createOne': '創建一個',
    'login.error.verifyEmail': '請在登入前驗證您的電子郵件。請檢查您的收件匣中的驗證連結。',
    'login.error.invalidCredentials': '電子郵件或密碼無效。',
    'login.resend.button': '重新發送驗證郵件',
    'login.resend.success': '如果您的帳戶存在且未經驗證，則會傳送一封新的驗證電子郵件。',
    'login.resend.error': '重新發送驗證郵件失敗。請稍後重試。',
    'login.resend.wait': '請稍等片刻，然後再要求另一封驗證電子郵件。',
    'login.resend.waitWithSeconds': '重新發送可用於',
    'register.title': '建立您的帳戶',
    'register.titleSuccess': '檢查您的電子郵件',
    'register.subtitle': '加入 X-perences 創作者社區',
    'register.subtitleSuccess': '我們向您發送了驗證鏈接',
    'register.alias': '別名',
    'register.aliasPlaceholder': '您的創建者別名',
    'register.passwordPlaceholder': '至少 6 個字符',
    'register.confirmPasswordPlaceholder': '確認您的密碼',
    'register.acceptPrefix': '我已閱讀並接受',
    'register.terms': '使用條款',
    'register.and': '和',
    'register.privacy': '隱私權���策',
    'register.acceptSuffix': '。',
    'register.submit': '建立帳戶',
    'register.successCreated': '帳戶創建成功！',
    'register.successCheckInbox': '請檢查您的收件匣（和垃圾郵件資料夾）並點擊驗證連結以啟動您的帳戶。',
    'register.successEmailIssue': '您的帳戶已創建，但暫時無法傳送驗證電子郵件。稍後使用登入後的重新發送驗證按鈕。',
    'register.successBackToLogin': '返回登入',
    'register.haveAccount': '已經有帳戶？',
    'register.signIn': '登入',
    'register.error.passwordsMismatch': '密碼不匹配',
    'register.error.passwordMin': '密碼必須至少為 6 個字符',
    'register.error.acceptTerms': '您必須閱讀並接受使用條款和隱私權政策',
    'register.error.generic': '註冊失敗',
    'forgot.title': '重設密碼',
    'forgot.subtitle': '輸入您的電子郵件以接收重置鏈接',
    'forgot.submit': '發送重置連結',
    'forgot.success': '檢查您的電子郵件中是否有密碼重設連結。',
    'forgot.devMode': '開發模式：',
    'forgot.devGoReset': '前往重置密碼',
    'forgot.remember': '還記得您的密碼嗎？',
    'forgot.error.generic': '發送重置郵件失敗',
    'reset.title': '重設密碼',
    'reset.subtitle': '輸入您的新密碼',
    'reset.newPassword': '新密碼',
    'reset.confirmPassword': '確認密碼',
    'reset.confirmPlaceholder': '確認您的新密碼',
    'reset.submit': '重設密碼',
    'reset.success': '密碼重置成功！正在重新導向至登入...',
    'reset.error.invalidLink': '重置連結無效',
    'reset.error.passwordsMismatch': '密碼不匹配',
    'reset.error.passwordMin': '密碼必須至少為 6 個字符',
    'reset.error.invalidToken': '重置令牌無效',
    'reset.error.generic': '重置密碼失敗',
    'verify.title': '電子郵件驗證',
    'verify.loading': '正在驗證您的電子郵件...',
    'verify.successLine1': '您的信箱已驗證成功！',
    'verify.successLine2': '您現在可以登入您的帳戶。',
    'verify.redirecting': '正在重新導向至登入...',
    'verify.alreadyLine1': '您的電子郵件已被驗證！',
    'verify.alreadyLine2': '您可以登入您的帳戶���',
    'verify.goLogin': '前往登入',
    'verify.error.noToken': '未提供驗證令牌',
    'verify.error.generic': '驗證失敗',
    'navbar.subtitle': '創作者門戶',
    'navbar.dashboard': '儀表板',
    'navbar.modXperiences': '模組。經驗',
    'navbar.manageCreators': '管理創作者',
    'navbar.newXperience': '新體驗',
    'navbar.generateCreators': '產生創造者',
    'navbar.generateXperiences': '產生經驗',
    'navbar.generate': '產生',
    'navbar.generating': '產生',
    'navbar.profile': '公司簡介',
    'navbar.logout': '退出',
    'navbar.confirmGenerateCreators': '您確定要產生建立者 JSON 嗎？',
    'navbar.confirmGenerateXperiences': '您確定要產生體驗 JSON 嗎？',
    'navbar.successGenerateCreators': '創建者生成成功！',
    'navbar.successGenerateXperiences': '經驗生成成功！',
    'navbar.error.endpoint': '未找到端點。 API 服務可能需要重新啟動。',
    'navbar.error.noBody': '無響應體',
    'navbar.error.generateCreators': '生成創建者失敗',
    'navbar.error.generateXperiences': '無法產生經驗',
    'navbar.roleDefault': '創作者',
    'navbar.statusPending': '待定',
    'navbar.statusTitle': '狀態',
    'navbar.totalViews': '總觀看次數',
    'navbar.avgRating': '平均評分',
    'navbar.roleTitle': '角色',
    'navbar.languageLabel': '語言',
    'navbar.lang.en': '英語',
    'navbar.lang.es': '西班牙語',
    'locale.en': '英語',
    'locale.zhHk': '中文（香港）',
    'locale.zhHans': '簡體中文',
    'locale.zhHant': '中文、繁體',
    'locale.enAu': '英語（澳洲）',
    'locale.enGb': '英語（英國）',
    'locale.fr': '法語',
    'locale.frCa': '法語（加拿大）',
    'locale.de': '德文',
    'locale.ja': '日語',
    'locale.es': '西班牙語',
    'home.profileIncomplete': '請在管理體驗之前填寫您的個人資料',
    'home.error.load': '無法加載經驗',
    'home.title': '您的經驗',
    'home.subtitle': '管理 Apple Vision Pro 的沉浸式內容',
    'home.newXperience': '+ ��體驗',
    'home.searchPlaceholder': '按標題或描述搜尋...',
    'home.clearSearch': '清除搜尋',
    'home.allMediaTypes': '所有媒體類型',
    'home.loading': '正在加載經驗...',
    'home.emptyTitle': '還沒有經驗',
    'home.emptyText': '為 Apple Vision Pro 打造您的首次沉浸式體驗',
    'home.createFirst': '創造第一體驗',
    'home.noResultsTitle': '沒有找到結果',
    'home.noResultsText': '嘗試調整您的搜尋條件或篩選器',
    'home.clearFilters': '清除過濾器',
    'home.privateTitle': '私人體驗',
    'home.categoryTitle': '類別',
    'home.viewsTitle': '意見',
    'home.likesTitle': '喜歡',
    'home.dislikesTitle': '不喜歡',
    'home.ratingTitle': '評級',
    'home.viewDetails': '看詳情',
    'home.moreTags': '更多標籤',
    'home.files': '文件',
    'home.filesPlural': '文件',
    'beCreator.title': '成為 X-perences 的創造者',
    'beCreator.subtitle': '分享 Apple Vision Pro 的沉浸式體驗',
    'beCreator.point1': '發布您自己的經驗並建立您的受眾。',
    'beCreator.point2': '從儀表板追蹤觀看次數、喜歡和評分。',
    'beCreator.point3': '從一個創作者入口網站管理媒體和更新。',
    'beCreator.ctaPrimary': '建立創建者帳戶',
    'beCreator.ctaSecondary': '我已經有一個帳戶',
    'beCreator.heroTitle': '成為創造者',
    'beCreator.heroSubtitle': '與世界分享您獨特的 X 體驗，將您的熱情變成現實。',
    'beCreator.heroCta': '作為創作者加入',
    'beCreator.benefitsTitle': '為什麼要加入 X-perences？',
    'beCreator.benefit.audienceTitle': '吸引全球觀眾',
    'beCreator.benefit.audienceText': '與世界各地渴望發現並參與您的獨特內容和 X 體驗��用戶建立聯繫。',
    'beCreator.benefit.recognitionTitle': '贏得認可',
    'beCreator.benefit.recognitionText': '透過分享激勵世界各地用戶的沉浸式故事來建立您作為創作者的聲譽。',
    'beCreator.benefit.toolsTitle': '強大的創作者工具',
    'beCreator.benefit.toolsText': '存取為創作者量身定制的高級分析、無縫媒體管理和易於使用的發布工具。',
    'beCreator.benefit.communityTitle': '支持社區',
    'beCreator.benefit.communityText': '加入充滿熱情的創作者網絡。在安全的環境中分享想法、協作並共同成長。',
    'beCreator.howItWorksTitle': '它是如何運作的',
    'beCreator.step.signupTitle': '註冊',
    'beCreator.step.signupText': '只需點擊幾下即可建立您的創作者個人資料。',
    'beCreator.step.createTitle': '創建',
    'beCreator.step.createText': '上傳您的內容並建立引人入勝的 X 體驗。',
    'beCreator.step.recognizedTitle': '獲得認可',
    'beCreator.step.recognizedText': '在全球分享您的經驗，擴大您的受眾，並成為沉浸式內容的參考創作者。',
    'beCreator.footerTitle': '準備好開始你的旅程了嗎？',
    'beCreator.footerText': '踏出第一步，與世界分享沉浸式體驗。',
    'beCreator.footerCta': '立即開始',
    'profile.loading': '正在載入個人資料...',
    'profile.title': '創作者簡介',
    'profile.subtitle': '管理您的創作者訊息',
    'profile.requiredFieldsLabel': '必填欄位*：',
    'profile.requiredFieldsText': '存取 Xperiences 儀表板需要全名、頭像、簡歷和國家。',
    'profile.section.accountInfo': '帳號資訊',
    'profile.section.changePassword': '更改密碼',
    'profile.section.personalInfo': '個人資訊',
    'profile.section.appSocial': '應用程式和社交媒體',
    'profile.section.creatorStats': '創作者統計',
    'profile.field.usernameAlias': '使用者名稱（別名）',
    'profile.field.currentPassword': '目前密碼',
    'profile.field.newPassword': '新密碼',
    'profile.field.confirmNewPassword': '確認新密碼',
    'profile.field.fullNameRequired': '全名 *',
    'profile.field.phone': '電話',
    'profile.field.countryRequired': '國家*',
    'profile.field.avatarRequired': '頭像 *',
    'profile.field.biographyRequired': '簡歷 *',
    'profile.field.appName': '應用程式名稱',
    'profile.field.appUrl': '應用程式網址',
    'profile.field.youtubeUrl': 'YouTube 網址',
    'profile.field.instagramUrl': 'Instagram 網址',
    'profile.field.otherUrl': '其他網址',
    'profile.placeholder.username': '您的使用者名稱',
    'profile.placeholder.currentPassword': '輸入您目前的密碼',
    'profile.placeholder.newPassword': '輸入新密碼',
    'profile.placeholder.confirmNewPassword': '確認新密碼',
    'profile.placeholder.fullName': '你的全名',
    'profile.placeholder.phone': '+1 (555) 000-0000',
    'profile.placeholder.searchCountries': '輸入以搜尋國家/地區...',
    'profile.placeholder.biography': '告訴我們你自己...',
    'profile.placeholder.appName': '例如，我的應用程式',
    'profile.placeholder.appUrl': 'https://myapp.com',
    'profile.placeholder.youtubeUrl': 'https://youtube.com/@yourusername',
    'profile.placeholder.instagramUrl': 'https://instagram.com/你的用戶名',
    'profile.placeholder.otherUrl': 'https://example.com',
    'profile.note.publicUsername': '您的公開用戶名',
    'profile.note.emailImmutable': '個人資料中的電子郵件地址無法更改',
    'profile.note.passwordMin': '最少 6 個字符',
    'profile.note.requiredForDashboard': '需要訪問儀表板',
    'profile.note.countryRequired': '需要存取儀表板 • 從清單中選擇或鍵入要搜尋的內容',
    'profile.note.avatarRequired': '存取儀表板需要 • JPG、PNG 或 GIF（最大 20MB）',
    'profile.note.biographyRequiredPrefix': '需要存取儀表板 •',
    'profile.note.characters': '人物',
    'profile.optional': '可選',
    'profile.allOptional': '全部可選',
    'profile.uploading': '正在上傳...',
    'profile.uploadingAvatar': '正在上傳頭像...',
    'profile.chooseAvatarImage': '選擇頭像圖片',
    'profile.avatarPreviewAlt': '頭像預覽',
    'profile.preview': '預覽',
    'profile.openInNewTab': '在新分頁中開啟',
    'profile.view': '查看',
    'profile.stats.rating': '評級',
    'profile.stats.credits': '製作人員',
    'profile.stats.views': '意見',
    'profile.stats.votes': '投票數',
    'profile.saving': '正在儲存...',
    'profile.saveChanges': '儲存變更',
    'profile.success.profileAndPasswordUpdated': '個人資料和密碼更新成功！',
    'profile.success.profileUpdatedComplete': '個人資料更新成功！所有必填欄位均已填寫。您現在可以存取 Xperiences 儀表板。',
    'profile.success.profileUpdatedIncomplete': '個人資料更新成功！請填寫所有必填欄位（姓名、頭像、履歷、國家/地區）以存取儀表板。',
    'profile.error.loadProfile': '無法載入設定檔',
    'profile.error.avatarUpload': '頭像上傳失敗。個人資料未儲存。',
    'profile.error.fillAllPasswordFields': '請填寫所有密碼欄位以更改您的密碼',
    'profile.error.passwordsMismatch': '新密碼不匹配',
    'profile.error.passwordMin': '新密碼必須至少 6 個字符',
    'profile.error.changePassword': '更改密碼失敗',
    'profile.error.profileUpdatedPasswordFailed': '個人資料已更新，但密碼變更失敗',
    'profile.error.updateProfile': '更新個人資料失敗。請再試一次。',
    'adminCreators.title': '管理創作者',
    'adminCreators.loading': '正在加載創作者...',
    'adminCreators.error.load': '無法載入創建者',
    'adminCreators.error.roleUpdate': '更新角色失敗',
    'adminCreators.error.statusUpdate': '更新狀態失敗',
    'adminCreators.error.trustUpdate': '無法更新信任標誌',
    'adminCreators.success.roleUpdated': '角色更新成功！',
    'adminCreators.success.statusUpdated': '狀態更新成功！',
    'adminCreators.success.trustUpdated': '信任標誌更新成功！',
    'adminCreators.table.alias': '別名',
    'adminCreators.table.email': '電子郵件',
    'adminCreators.table.emailVerified': '電子郵件已驗證',
    'adminCreators.table.hidden': '隱藏',
    'adminCreators.table.joinDate': '加入日期',
    'adminCreators.table.role': '角色',
    'adminCreators.table.status': '狀態',
    'adminCreators.table.trusted': '值得信賴',
    'adminCreators.yes': '是的',
    'adminCreators.no': '否',
    'adminCreators.hidden': '隱藏',
    'adminCreators.visible': '可見',
    'adminCreators.trusted': '值得信賴',
    'adminCreators.standard': '標準型',
    'adminCreators.role.creator': '創作者',
    'adminCreators.role.manager': '主管',
    'adminCreators.role.administrator': '管理員',
    'adminCreators.status.pending': '待定',
    'adminCreators.status.approved': '已批准',
    'adminCreators.status.rejected': '禁止/拒絕',
    'adminCreators.empty': '未找到創作者。',
    'adminCreators.pagination.page': '頁面',
    'adminCreators.pagination.of': '的',
    'adminCreators.pagination.total': '合計',
    'adminCreators.pagination.rowsPerPage': '每頁行數',
    'adminCreators.pagination.previous': '上一頁',
    'adminCreators.pagination.next': '下一步',
    'adminCreatorDetail.title': '編輯創建者：',
    'adminCreatorDetail.back': '返回',
    'adminCreatorDetail.id': '身分證號',
    'adminCreatorDetail.email': '電子郵件',
    'adminCreatorDetail.alias': '別名',
    'adminCreatorDetail.fullName': '全名',
    'adminCreatorDetail.phone': '電話',
    'adminCreatorDetail.countryCode': '國家/地區代碼',
    'adminCreatorDetail.countryPlaceholder': '輸入以搜尋國家/地區...',
    'adminCreatorDetail.flags': '設定檔標誌',
    'adminCreatorDetail.emailVerified': '電子郵件已驗證',
    'adminCreatorDetail.resendEmail': '重新發送電子郵件',
    'adminCreatorDetail.sending': '正在發送...',
    'adminCreatorDetail.hideProfile': '隱藏個人資料（不完整）',
    'adminCreatorDetail.isTrusted': '值得信賴的創作者',
    'adminCreatorDetail.bio': '簡介/描述',
    'adminCreatorDetail.linksApps': '連結和應用程式',
    'adminCreatorDetail.appName': '應用程式名稱',
    'adminCreatorDetail.appUrl': '應用程式網址',
    'adminCreatorDetail.youtubeUrl': 'YouTube 網址',
    'adminCreatorDetail.instagramUrl': 'Instagram 網址',
    'adminCreatorDetail.otherUrl': '其他網址',
    'adminCreatorDetail.saveProfile': '儲存個人資料',
    'adminCreatorDetail.saving': '正在儲存...',
    'adminCreatorDetail.error.load': '無法載入創建者',
    'adminCreatorDetail.error.verificationSend': '無法傳送驗證電子郵件。',
    'adminCreatorDetail.error.update': '無法更新創建者',
    'adminCreatorDetail.success.verificationSent': '驗證郵件發送成功。',
    'adminCreatorDetail.success.updated': '創建者更新成功',
    'moderation.back': '返回',
    'moderation.title.single': '調節體驗內容',
    'moderation.title.global': '內容審核',
    'moderation.searchPlaceholder': '按標題、描述或建立者搜尋...',
    'moderation.filter.allMedia': '所有媒體',
    'moderation.filter.pending': '待定',
    'moderation.filter.approved': '已批准',
    'moderation.filter.rejected': '被拒絕',
    'moderation.loading': '正在加載媒體...',
    'moderation.empty.search': '沒有與您的搜尋相符的媒體。',
    'moderation.empty.filter': '沒有找到適合所選過濾器的媒體。',
    'moderation.noPoster': '無海報',
    'moderation.untitled': '無題',
    'moderation.noDescription': '無描述',
    'moderation.creator': '創作者',
    'moderation.email': '電子郵件',
    'moderation.date': '日期',
    'moderation.na': '不適用',
    'moderation.viewOriginal': '查看原始文件',
    'moderation.action.approve': '核准',
    'moderation.action.reject': '拒絕',
    'moderation.action.setPending': '設定待處理',
    'moderation.success.markedAs': '媒體成功標記為',
    'moderation.error.loadMedia': '載入媒體以進行審核時出錯。',
    'moderation.error.updateStatus': '無法更新媒體狀態。',
    'adminXperiences.backDashboard': '返回儀表板',
    'adminXperiences.title': '全球經驗審核',
    'adminXperiences.searchPlaceholder': '按標題、描述或建立者搜尋...',
    'adminXperiences.filter.all': '所有經歷',
    'adminXperiences.filter.pending': '待定',
    'adminXperiences.filter.approved': '已批准',
    'adminXperiences.filter.rejected': '被拒絕',
    'adminXperiences.loading': '正在加載經驗...',
    'adminXperiences.empty.search': '沒有與您的搜尋相符的經驗。',
    'adminXperiences.empty.filter': '未找到所選過濾器的經驗。',
    'adminXperiences.noPoster': '無海報',
    'adminXperiences.noDescription': '無描述',
    'adminXperiences.creator': '創作者',
    'adminXperiences.email': '電子郵件',
    'adminXperiences.date': '日期',
    'adminXperiences.na': '不適用',
    'adminXperiences.mediaCount': '媒體數',
    'adminXperiences.items': '專案',
    'adminXperiences.action.moderateMedia': '適度媒體',
    'adminXperiences.action.approveAll': '批准全部',
    'adminXperiences.action.rejectAll': '全部拒絕',
    'adminXperiences.action.setPending': '設定待處理',
    'adminXperiences.success.markedAs': 'Xperience 成功標記為',
    'adminXperiences.error.fetch': '取得經驗失敗',
    'adminXperiences.error.updateStatus': '更新狀態失敗',
    'createXperience.profileIncomplete': '請在創建體驗之前填寫您的個人資料',
    'createXperience.error.create': '無法創造體驗',
    'createXperience.title': '創造新體驗',
    'createXperience.subtitle': '開始建立您的沉浸式內容',
    'createXperience.field.title': '標題',
    'createXperience.placeholder.title': '體驗標題',
    'createXperience.field.description': '描述',
    'createXperience.placeholder.description': '描述一下你的經歷...',
    'createXperience.field.location': '地點',
    'createXperience.field.tags': '標籤',
    'createXperience.copyLastLocation': '複製最後的位置',
    'createXperience.error.noLastLocation': '尚無可用的先前位置。',
    'createXperience.placeholder.tags': '選擇或搜尋標籤...',
    'createXperience.help.tags': '選擇一個或多個標籤以提高發現率。',
    'createXperience.cancel': '取消',
    'createXperience.submit': '創造體驗',
    'xperienceDetail.success.mediaOrderSaved': '媒體訂單已成功保存。',
    'xperienceDetail.error.mediaOrderSave': '無法儲存媒體訂單。',
    'xperienceDetail.error.load': '無法載入體驗',
    'xperienceDetail.success.updated': 'Xperience 更新成功。',
    'xperienceDetail.error.update': '更新體驗失敗',
    'xperienceDetail.sendingEmail': '正在發送電子郵件...',
    'xperienceDetail.success.emailSent': '二維碼存取電子郵件發送成功。',
    'xperienceDetail.success.locationCopiedToAll': '位置已複製到 {count} 個媒體項目。',
    'xperienceDetail.error.sendEmail': '發送二維碼郵件失敗。',
    'xperienceDetail.error.uploadMedia': '媒體上傳失敗',
    'xperienceDetail.error.deleteMedia': '刪除媒體失敗',
    'xperienceDetail.error.deleteXperience': '刪除體驗失敗',
    'xperienceDetail.error.noLocationToCopyAll': '先設定一個位置，然後再複製到所有媒體。',
    'xperienceDetail.error.invalidLocationToCopyAll': '目前位置座標無效。',
    'xperienceDetail.error.noMediaToCopyLocationAll': '在此體驗中未找到可更新的媒體項目。',
    'xperienceDetail.error.locationCopiedToAllPartial': '更新了 {success} 媒體項，但 {failed} 失敗。',
    'xperienceDetail.error.locationCopiedToAllFailed': '無法更新所有媒體的位置。',
    'xperienceDetail.loading': '正在加載經驗...',
    'xperienceDetail.notFound': '未找到經驗',
    'xperienceDetail.backDashboard': '返回儀表板',
    'xperienceDetail.editTitle': '編輯經驗',
    'xperienceDetail.field.title': '標題',
    'xperienceDetail.field.description': '描述',
    'xperienceDetail.field.location': '地點',
    'xperienceDetail.field.tags': '標籤',
    'xperienceDetail.copyLastLocation': '複製最後的位置',
    'xperienceDetail.copyLocationToAll': '將位置複製到所有媒體',
    'xperienceDetail.copyLocationToAllLoading': '複製到所有媒體...',
    'xperienceDetail.error.noLastLocation': '尚無可用的先前位置。',
    'xperienceDetail.success.lastLocationCopied': '複製的最後位置。',
    'xperienceDetail.placeholder.tags': '選擇或搜尋標籤...',
    'xperienceDetail.help.tags': '選擇一個或多個標籤以提高發現率。',
    'xperienceDetail.privateToggle': '私人體驗（需要密碼）',
    'xperienceDetail.cancel': '取消',
    'xperienceDetail.saveChanges': '儲存變更',
    'xperienceDetail.edit': '編輯',
    'xperienceDetail.deleteXperience': '刪除體驗',
    'xperienceDetail.info.status': '狀態',
    'xperienceDetail.pending': '待定',
    'xperienceDetail.info.views': '意見',
    'xperienceDetail.info.rating': '評級',
    'xperienceDetail.info.reactions': '反應',
    'xperienceDetail.info.tags': '標籤',
    'xperienceDetail.info.category': '類別',
    'xperienceDetail.info.created': '已創建',
    'xperienceDetail.noDate': '不適用',
    'xperienceDetail.info.mediaCount': '媒體數',
    'xperienceDetail.info.visibility': '能見度',
    'xperienceDetail.visibility.private': '私人',
    'xperienceDetail.visibility.public': '公有',
    'xperienceDetail.privateQR.title': '私人訪問二維碼',
    'xperienceDetail.privateQR.description': '分享此二維碼或密碼以授予對您的體驗的私人存取權限。',
    'xperienceDetail.privateQR.alt': '私密訪問二維碼',
    'xperienceDetail.success.passwordCopied': '密碼已複製到剪貼簿。',
    'xperienceDetail.copyPassword': '複製密碼',
    'xperienceDetail.wait': '等等',
    'xperienceDetail.emailQR': '電子郵件二維碼',
    'xperienceDetail.mediaSectionTitle': '體驗媒體',
    'xperienceDetail.createMedia': '+ 建立媒體',
    'xperienceDetail.uploading': '上傳中',
    'xperienceDetail.noMedia': '尚未添加媒體。',
    'xperienceDetail.noMediaHelp': '還沒有媒體檔。上傳圖像、影片或音訊。',
    'xperienceDetail.mediaCard.added': '已新增',
    'xperienceDetail.mediaCard.na': '不適用',
    'xperienceDetail.mediaCard.viewDetails': '看詳情',
    'xperienceDetail.confirm.deleteMediaTitle': '刪除媒體？',
    'xperienceDetail.confirm.deleteMediaMessage': '該媒體項目將永久刪除。此操作無法撤銷。',
    'xperienceDetail.confirm.deleteXperienceTitle': '刪除經驗？',
    'xperienceDetail.confirm.deleteXperienceMessage': '此體驗和所有相關媒體將永久刪除。此操作無法撤銷。',
    'xperienceDetail.confirm.delete': '刪除',
    'xperienceDetail.confirm.cancel': '取消',
    'xperienceDetail.confirm.copyLocationAllTitle': '將位置複製到所有媒體？',
    'xperienceDetail.confirm.copyLocationAllMessage': '這將更新此體驗中所有媒體的位置座標。繼續？',
    'xperienceDetail.confirm.copyLocationAllConfirm': '是的，更新所有媒體',
    'xperienceDetail.confirm.copyLocationAllCancel': '取消',
    'xmedia.error.loadData': '載入資料失敗',
    'xmedia.error.delete': '刪除媒體失敗',
    'xmedia.error.save': '無法儲存 xperience 媒體',
    'xmedia.error.noXperienceLocation': '父體驗還沒有可以複製的位置。',
    'xmedia.error.noLastLocation': '尚無可用的先前位置。',
    'xmedia.error.requiredPrefix': '以下欄位是必要的：',
    'xmedia.success.posterSelected': '海報是本地選擇的。它將在保存時上傳。',
    'xmedia.success.mediaSelected': '本地選擇的媒體。它將在保存時上傳。',
    'xmedia.success.deleted': '媒體刪除成功！',
    'xmedia.success.created': 'Xperience 媒體已建立且檔案已成功上傳！',
    'xmedia.success.updated': 'Xperence 媒體更新成功！',
    'xmedia.success.locationCopied': '從 xperence 複製的位置。',
    'xmedia.success.lastLocationCopied': '複製的最後位置。',
    'xmedia.confirm.deleteMessage': '您確定要永久刪除該媒體項目及其關聯檔案嗎？此操作無法撤銷。',
    'xmedia.loading': '正在加載體驗媒體...',
    'xmedia.notFound': '未找到 Xperence 媒體',
    'xmedia.back': '返回',
    'xmedia.title.create': '創造新媒體',
    'xmedia.title.edit': '編輯體驗媒體',
    'xmedia.subtitle': '更新該媒體項目的所有元資料和檔案。',
    'xmedia.field.title': '標題',
    'xmedia.field.description': '描述',
    'xmedia.field.type': '類型',
    'xmedia.field.format': '格式',
    'xmedia.field.category': '類別',
    'xmedia.field.mediaFile': '媒體檔案',
    'xmedia.field.posterUrl': '海報網址',
    'xmedia.field.order': '訂單',
    'xmedia.field.runtime': '運行時',
    'xmedia.field.credits': '所需學分/積分',
    'xmedia.field.location': '地點',
    'xmedia.field.createdDate': '建立日期',
    'xmedia.placeholder.title': '輸入標題',
    'xmedia.placeholder.description': '輸入描述...',
    'xmedia.placeholder.mediaUrl': 'URL 將在儲存時安全地生成',
    'xmedia.placeholder.posterUrl': '儲存時將產生海報路徑',
    'xmedia.placeholder.order': '例如，1',
    'xmedia.placeholder.runtime': '例如，3600',
    'xmedia.placeholder.credits': '例如，0',
    'xmedia.selectFile': '選擇文件',
    'xmedia.changeFile': '更改文件',
    'xmedia.viewMedia': '查看媒體',
    'xmedia.selectImage': '選擇影像',
    'xmedia.changeImage': '更改圖像',
    'xmedia.thumbnail': '縮圖',
    'xmedia.seconds': '秒',
    'xmedia.requiresDownload': '需要下載',
    'xmedia.isPublic': '是公開的',
    'xmedia.isPremium': '是高級版',
    'xmedia.hide': '隱藏',
    'xmedia.deleteMedia': '刪除媒體',
    'xmedia.cancel': '取消',
    'xmedia.saving': '正在儲存...',
    'xmedia.saveChanges': '儲存變更',
    'xmedia.copyXperienceLocation': '複製體驗位置',
    'xmedia.copyLastLocation': '複製最後的位置',
    'xmedia.copyLocationToAll': '將位置複製到所有媒體',
    'xmedia.copyLocationToAllLoading': '複製到所有媒體...',
    'xmedia.locationSource.xperience': '使用 xperience 主要位置',
    'xmedia.locationSource.last': '使用上次複製的位置',
    'xmedia.lastLocationPreview': '已儲存最後位置',
    'xmedia.confirm.copyLocationAllTitle': '將位置複製到所有媒體？',
    'xmedia.confirm.copyLocationAllMessage': '這將更新此體驗中所有媒體的位置座標。繼續？',
    'xmedia.confirm.copyLocationAllConfirm': '是的，更新所有媒體',
    'xmedia.confirm.copyLocationAllCancel': '取消',
    'xmedia.success.locationCopiedToAll': '位置已複製到 {count} 個媒體項目。',
    'xmedia.error.noXperienceForBulkLocation': '找不到批次位置更新的父級體驗。',
    'xmedia.error.noLocationToCopyAll': '先設定一個位置，然後再複製到所有媒體。',
    'xmedia.error.invalidLocationToCopyAll': '目前位置座標無效。',
    'xmedia.error.noMediaToCopyLocationAll': '在此體驗中未找���可更新的媒體項目。',
    'xmedia.error.locationCopiedToAllPartial': '更新了 {success} 媒體項，但 {failed} 失敗。',
    'xmedia.error.locationCopiedToAllFailed': '無法更新所有媒體的位置。',
    'locationPicker.searchLabel': '搜尋地址',
    'locationPicker.searchPlaceholder': '輸入地址、城市或地點',
    'locationPicker.longitude': '經度',
    'locationPicker.latitude': '緯度',
    'locationPicker.clear': '清晰的位置',
    'locationPicker.useCurrent': '使用我目前的位置',
    'locationPicker.locating': '正在定位...',
    'locationPicker.geoNotSupported': '您的瀏覽器不支援地理定位。',
    'locationPicker.geoError': '無法取得您的目前位置。檢查瀏覽器權限。',
    'locationPicker.selectedAddress': '選定的地址',
    'locationPicker.loadingMap': '正在加載地圖...',
    'locationPicker.noApiKey': 'Google 地圖 API 金鑰遺失',
    'locationPicker.noApiKeyHelp': '在前端環境中設定 REACT_APP_GOOGLE_MAPS_API_KEY 以啟用地圖和位址搜尋。',
    'locationPicker.loadError': '無法加載 Google 地圖',
  }
};
